var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWebsite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-126"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--floor--inject-126",
    cx: 250,
    cy: 370.91,
    rx: 199.47,
    ry: 115.17,
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-126"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--Shadow--inject-126",
    d: "M313.56,284.59l-4.87-2.81a13.26,13.26,0,0,0-12,0L39.39,430.36c-3.29,1.9-3.29,5,0,6.9l4.87,2.81a13.26,13.26,0,0,0,12,0l78.18-45.13L169.18,415c9,5.18,23.64,5.18,32.6,0l53.94-31.14c7.65-4.42,7.65-11.65,0-16.07l-37.17-21.46,95-54.85C316.85,289.6,316.85,286.49,313.56,284.59Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-126",
    cx: 364.64,
    cy: 428.83,
    rx: 67.87,
    ry: 39.18,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-126",
    d: "M427,431.48l47.12-27.2c3-1.71,3-4.48,0-6.19l-29.51-17a12.46,12.46,0,0,0-10.84-.2L384.37,407c-3,1.6-3.07,4.28-.11,6l32,18.49A11.84,11.84,0,0,0,427,431.48Z",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clouds--inject-126"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--clouds--inject-126"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M141.9,81.08l4.21-2.54a8.13,8.13,0,0,1-.06-.89V75.57a12.85,12.85,0,0,1,5.82-10.07,4.54,4.54,0,0,1,3.46-.67c.53-5.27,4.19-11.23,8.63-13.79,4.8-2.78,8.7-.53,8.7,5v3.12a15.2,15.2,0,0,1-.74,4.46l6-3.45c1.78-1,3.23-.2,3.23,1.86a7.14,7.14,0,0,1-3.23,5.59l-36,20.89c-1.78,1-3.22.2-3.22-1.86A7.13,7.13,0,0,1,141.9,81.08Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.72,70.53l-4.41,1.69V62.5c0-7.71-6.15-9.56-12.83-5.71h0C81.8,60.65,76.39,70,76.39,77.74v1.41c-1.51-.61-3.47-.37-5.61.86h0c-4.8,2.78-8.7,9.52-8.7,15.07v.64l-6.16,3.56a12.68,12.68,0,0,0-5.73,9.92c0,3.66,2.57,5.14,5.73,3.31l49.8-28.75a12.66,12.66,0,0,0,5.73-9.93C111.45,70.18,108.89,68.7,105.72,70.53Z",
    style: {
      fill: "#ebebeb"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-126"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Monitor--inject-126"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M203.71,405.77,248.32,380c4.6-2.66,6.9-6.14,6.9-9.62s0-6.2,0-6.2l-42-23.83a9.8,9.8,0,0,1-4.44-7.69v-55l-77.93,45v55a9.83,9.83,0,0,0,4.44,7.69l35.07,20.41C179.6,411.08,194.51,411.08,203.71,405.77Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.6,387.4v6.18l-14.28-8.23a9.81,9.81,0,0,1-4.44-7.69v-55l14.85-8.56c.3,3.77.64,7.66.94,11.46l-10.41,6v43a9.77,9.77,0,0,0,4.44,7.69Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.26,374.57a9.81,9.81,0,0,0,4.44,7.69l29.69,17.31c9.2,5.31,24.11,5.31,33.31,0l44.64-25.79c9.2-5.31,9.2-13.92,0-19.23l-29.71-17.32a9.83,9.83,0,0,1-4.44-7.69v-43l-77.93,45Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.68,342.46h0l-9.05-5.22a9.83,9.83,0,0,1-4.44-7.69v-43l-77.93,45v43a9.81,9.81,0,0,0,4.44,7.69l8.89,5.13Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.43,408.49c2.88,1.66,7.7,1.57,10.76-.2l256.39-148a12.29,12.29,0,0,0,5.55-9.62V36c0-3.54-2.33-7.76-5.21-9.42s-7.69-1.57-10.76.2l-256.38,148a12.29,12.29,0,0,0-5.55,9.62V399.07C38.23,402.61,40.56,406.83,43.43,408.49Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.19,408.28l256.39-148a12.28,12.28,0,0,0,5.55-9.61V36c0-3.54-2.49-5-5.55-3.2L54.2,180.77a12.25,12.25,0,0,0-5.55,9.61v214.7C48.64,408.62,51.13,410.05,54.19,408.28Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.64,386.19v18.89c0,3.54,2.49,5,5.55,3.2l256.39-148a12.28,12.28,0,0,0,5.55-9.61V231.76Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56,368.62V192.86A7.53,7.53,0,0,1,59.39,187l246-142c1.88-1.09,3.41-.2,3.41,2V222.67a7.55,7.55,0,0,1-3.41,5.91l-246,142C57.51,371.68,56,370.8,56,368.62Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56,368.62V192.86A7.53,7.53,0,0,1,59.39,187l246-142c1.88-1.09,3.41-.2,3.41,2V222.67a7.55,7.55,0,0,1-3.41,5.91l-246,142C57.51,371.68,56,370.8,56,368.62Z",
    style: {
      fill: "#fff",
      opacity: 0.75
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.86,178.89l10.42,6a11.76,11.76,0,0,0-1.65,5.49v214.7c0,3.23,2.19,5,5.55,3.21a11.82,11.82,0,0,1-10.76.2,10.71,10.71,0,0,1-5.21-8.75V184.38A11.52,11.52,0,0,1,39.86,178.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.52,322.32l12.56-7.2c1.12-.65,2-.19,2,1a4.39,4.39,0,0,1-2,3.38l-12.56,7.2c-1.12.65-2,.19-2-1A4.38,4.38,0,0,1,177.52,322.32Z",
    style: {
      fill: "#46C5FB"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--window-1--inject-126"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-126"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-126"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M254.91,105.57a2.84,2.84,0,0,0-.06-.31.07.07,0,0,0,0-.06,1,1,0,0,0-.08-.3,1.59,1.59,0,0,0-.19-.42.67.67,0,0,0-.11-.18l-.1-.12a1.1,1.1,0,0,0-.22-.21l0,0a2,2,0,0,0-.28-.16,2.43,2.43,0,0,0-2.24.28L84.39,200.27c-1.83,1.06-3.33,3.64-3.33,7.35V332.71c0-1.58,0-1.57,0-1.56v.73a2.23,2.23,0,0,0,1.19,2l.14.1.18.1a1.31,1.31,0,0,0,.28.09,1.59,1.59,0,0,0,.43.06,2.12,2.12,0,0,0,1.1-.32l.09,0h0L87.65,332l164-94.38a7.36,7.36,0,0,0,3.33-5.76V106C254.93,105.84,254.92,105.7,254.91,105.57Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.84,103.78a2.43,2.43,0,0,0-2.24.28L84.39,200.27A7.37,7.37,0,0,0,81.06,206v6.44L76.82,210v-6.37a7.32,7.32,0,0,1,3.32-5.75l167.22-96.2a2.31,2.31,0,0,1,2.41-.2C250.37,101.83,253.13,103.41,253.84,103.78Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.92,106c0-2.1-1.49-2.95-3.32-1.89L84.39,200.28A7.33,7.33,0,0,0,81.06,206v6.45l173.85-100Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M251.6,104.07,84.39,200.28a6.85,6.85,0,0,0-2.34,2.46l-4.22-2.44a6.53,6.53,0,0,1,2.31-2.43l167.22-96.21a2.32,2.32,0,0,1,2.41-.19c.6.36,3.35,1.93,4,2.31A2.37,2.37,0,0,0,251.6,104.07Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M76.82,210v-6.38a6.78,6.78,0,0,1,1-3.32l4.23,2.43a6.67,6.67,0,0,0-1,3.3v6.45Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.83,112.79a3.31,3.31,0,0,0-1.27,2.67c0,1.07.57,1.61,1.27,1.21a3.35,3.35,0,0,0,1.26-2.67C243.09,112.93,242.52,112.38,241.83,112.79Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.37,110.16a3.32,3.32,0,0,0-1.26,2.67c0,1.07.56,1.62,1.26,1.21a3.32,3.32,0,0,0,1.26-2.67C247.63,110.3,247.07,109.75,246.37,110.16Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.92,107.53a3.32,3.32,0,0,0-1.27,2.67c0,1.07.57,1.62,1.27,1.21a3.33,3.33,0,0,0,1.26-2.67C252.18,107.67,251.61,107.12,250.92,107.53Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.26,333.89l-.17-.1-3.51-2a3.52,3.52,0,0,1-1.73-2.57,4,4,0,0,1,0-.49V210l4.24,2.49V331.87a2.18,2.18,0,0,0,1,1.89l.1.07,0,0Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Code--inject-126",
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.49,280.9,95,278.29c.45-.26.82-.05.82.47v1.67a1.82,1.82,0,0,1-.82,1.42l-4.53,2.62c-.45.26-.82,0-.82-.48v-1.66A1.82,1.82,0,0,1,90.49,280.9Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.49,287.52,95,284.91c.45-.26.82-.05.82.48v1.66a1.82,1.82,0,0,1-.82,1.42l-4.53,2.62c-.45.26-.82.05-.82-.48V289A1.84,1.84,0,0,1,90.49,287.52Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.49,294.15,95,291.53c.45-.26.82,0,.82.48v1.66A1.84,1.84,0,0,1,95,295.1l-4.53,2.61c-.45.26-.82.05-.82-.47v-1.67A1.82,1.82,0,0,1,90.49,294.15Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.49,300.77,95,298.16c.45-.27.82-.05.82.47v1.67a1.82,1.82,0,0,1-.82,1.42l-4.53,2.61c-.45.27-.82.05-.82-.47v-1.67A1.82,1.82,0,0,1,90.49,300.77Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.49,248.05,95,245.44c.45-.27.82-.05.82.47v1.67A1.82,1.82,0,0,1,95,249l-4.53,2.61c-.45.27-.82,0-.82-.47v-1.67A1.82,1.82,0,0,1,90.49,248.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.49,254.67,95,252.06c.45-.26.82-.05.82.47v1.67a1.82,1.82,0,0,1-.82,1.42l-4.53,2.62c-.45.26-.82.05-.82-.48V256.1A1.84,1.84,0,0,1,90.49,254.67Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.49,261.3,95,258.68c.45-.26.82-.05.82.48v1.66a1.84,1.84,0,0,1-.82,1.43l-4.53,2.61c-.45.26-.82.05-.82-.48v-1.66A1.82,1.82,0,0,1,90.49,261.3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.49,267.92,95,265.3c.45-.26.82,0,.82.48v1.66a1.82,1.82,0,0,1-.82,1.43l-4.53,2.61c-.45.26-.82,0-.82-.47v-1.67A1.82,1.82,0,0,1,90.49,267.92Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.49,313.75,95,311.14c.45-.26.82-.05.82.47v1.67A1.82,1.82,0,0,1,95,314.7l-4.53,2.62c-.45.26-.82.05-.82-.48v-1.66A1.84,1.84,0,0,1,90.49,313.75Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.49,320.38,95,317.76c.45-.26.82-.05.82.48v1.66a1.84,1.84,0,0,1-.82,1.43l-4.53,2.61c-.45.26-.82.05-.82-.48V321.8A1.82,1.82,0,0,1,90.49,320.38Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.49,215.2,95,212.59c.45-.27.82-.05.82.47v1.66a1.82,1.82,0,0,1-.82,1.43l-4.53,2.61c-.45.26-.82.05-.82-.47v-1.67A1.82,1.82,0,0,1,90.49,215.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.49,221.82,95,219.21c.45-.26.82-.05.82.47v1.67a1.82,1.82,0,0,1-.82,1.42l-4.53,2.61c-.45.27-.82.05-.82-.47v-1.66A1.82,1.82,0,0,1,90.49,221.82Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.49,228.44,95,225.83c.45-.26.82-.05.82.48V228a1.82,1.82,0,0,1-.82,1.42L90.49,232c-.45.26-.82.05-.82-.48v-1.66A1.84,1.84,0,0,1,90.49,228.44Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.49,235.07,95,232.45c.45-.26.82,0,.82.48v1.66A1.84,1.84,0,0,1,95,236l-4.53,2.61c-.45.26-.82.05-.82-.47v-1.67A1.82,1.82,0,0,1,90.49,235.07Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M245.06,174.85,210.33,194.9a5.14,5.14,0,0,0-2.33,4v52.31c0,1.49,1,2.09,2.33,1.35l34.73-20a5.17,5.17,0,0,0,2.33-4.05V176.2C247.39,174.71,246.35,174.1,245.06,174.85Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.84,214.6l-3.2,1.85a2.54,2.54,0,0,0-1.18,2c0,.71.53,1,1.18.6l3.2-1.85a2.55,2.55,0,0,0,1.18-2C243,214.49,242.49,214.22,241.84,214.6Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.84,214.6l-3.2,1.85a2.54,2.54,0,0,0-1.18,2c0,.71.53,1,1.18.6l3.2-1.85a2.55,2.55,0,0,0,1.18-2C243,214.49,242.49,214.22,241.84,214.6Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.84,181.76l-3.2,1.85a2.54,2.54,0,0,0-1.18,2c0,.7.53,1,1.18.6l3.2-1.85a2.55,2.55,0,0,0,1.18-2C243,181.65,242.49,181.38,241.84,181.76Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.84,181.76l-3.2,1.85a2.54,2.54,0,0,0-1.18,2c0,.7.53,1,1.18.6l3.2-1.85a2.55,2.55,0,0,0,1.18-2C243,181.65,242.49,181.38,241.84,181.76Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.34,190.91l-3.19,1.85a2.49,2.49,0,0,0-1.18,2c0,.7.52,1,1.18.59l3.19-1.84a2.55,2.55,0,0,0,1.18-2C238.52,190.8,238,190.53,237.34,190.91Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.34,190.91l-3.19,1.85a2.49,2.49,0,0,0-1.18,2c0,.7.52,1,1.18.59l3.19-1.84a2.55,2.55,0,0,0,1.18-2C238.52,190.8,238,190.53,237.34,190.91Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.34,197.46l-3.19,1.85a2.49,2.49,0,0,0-1.18,2c0,.7.52,1,1.18.6l3.19-1.85a2.55,2.55,0,0,0,1.18-2C238.52,197.35,238,197.08,237.34,197.46Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.34,197.46l-3.19,1.85a2.49,2.49,0,0,0-1.18,2c0,.7.52,1,1.18.6l3.19-1.85a2.55,2.55,0,0,0,1.18-2C238.52,197.35,238,197.08,237.34,197.46Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.84,201.46l-3.2,1.85a2.54,2.54,0,0,0-1.18,2c0,.71.53,1,1.18.6l3.2-1.85a2.55,2.55,0,0,0,1.18-2C243,201.35,242.49,201.08,241.84,201.46Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.84,201.46l-3.2,1.85a2.54,2.54,0,0,0-1.18,2c0,.71.53,1,1.18.6l3.2-1.85a2.55,2.55,0,0,0,1.18-2C243,201.35,242.49,201.08,241.84,201.46Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.34,210.61l-3.19,1.85a2.52,2.52,0,0,0-1.18,2c0,.71.52,1,1.18.6l3.19-1.85a2.52,2.52,0,0,0,1.18-2C238.52,210.51,238,210.24,237.34,210.61Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.34,210.61l-3.19,1.85a2.52,2.52,0,0,0-1.18,2c0,.71.52,1,1.18.6l3.19-1.85a2.52,2.52,0,0,0,1.18-2C238.52,210.51,238,210.24,237.34,210.61Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.08,186.82l-19.52,11.27a2.52,2.52,0,0,0-1.18,2c0,.71.52,1,1.18.6l19.52-11.28a2.52,2.52,0,0,0,1.18-2C234.26,186.71,233.73,186.44,233.08,186.82Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.08,186.82l-19.52,11.27a2.52,2.52,0,0,0-1.18,2c0,.71.52,1,1.18.6l19.52-11.28a2.52,2.52,0,0,0,1.18-2C234.26,186.71,233.73,186.44,233.08,186.82Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.08,219.66l-19.52,11.27a2.52,2.52,0,0,0-1.18,2c0,.71.52,1,1.18.6l19.52-11.27a2.55,2.55,0,0,0,1.18-2C234.26,219.55,233.73,219.28,233.08,219.66Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.08,219.66l-19.52,11.27a2.52,2.52,0,0,0-1.18,2c0,.71.52,1,1.18.6l19.52-11.27a2.55,2.55,0,0,0,1.18-2C234.26,219.55,233.73,219.28,233.08,219.66Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.59,196l-15,8.7a2.51,2.51,0,0,0-1.18,2c0,.71.52,1,1.18.6l15-8.7a2.52,2.52,0,0,0,1.18-2C229.77,195.86,229.24,195.59,228.59,196Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.59,196l-15,8.7a2.51,2.51,0,0,0-1.18,2c0,.71.52,1,1.18.6l15-8.7a2.52,2.52,0,0,0,1.18-2C229.77,195.86,229.24,195.59,228.59,196Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.59,202.53l-15,8.7a2.49,2.49,0,0,0-1.18,2c0,.7.52,1,1.18.6l15-8.7a2.54,2.54,0,0,0,1.18-2C229.77,202.42,229.24,202.16,228.59,202.53Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.59,202.53l-15,8.7a2.49,2.49,0,0,0-1.18,2c0,.7.52,1,1.18.6l15-8.7a2.54,2.54,0,0,0,1.18-2C229.77,202.42,229.24,202.16,228.59,202.53Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.08,206.52,213.56,217.8a2.49,2.49,0,0,0-1.18,2c0,.7.52,1,1.18.59l19.52-11.27a2.54,2.54,0,0,0,1.18-2C234.26,206.41,233.73,206.15,233.08,206.52Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.08,206.52,213.56,217.8a2.49,2.49,0,0,0-1.18,2c0,.7.52,1,1.18.59l19.52-11.27a2.54,2.54,0,0,0,1.18-2C234.26,206.41,233.73,206.15,233.08,206.52Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.59,215.67l-15,8.69a2.52,2.52,0,0,0-1.18,2c0,.71.52,1,1.18.6l15-8.69a2.54,2.54,0,0,0,1.18-2C229.77,215.56,229.24,215.3,228.59,215.67Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.59,215.67l-15,8.69a2.52,2.52,0,0,0-1.18,2c0,.71.52,1,1.18.6l15-8.69a2.54,2.54,0,0,0,1.18-2C229.77,215.56,229.24,215.3,228.59,215.67Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.84,227.81l-3.2,1.85a2.52,2.52,0,0,0-1.18,2c0,.7.53,1,1.18.6l3.2-1.85a2.55,2.55,0,0,0,1.18-2C243,227.7,242.49,227.43,241.84,227.81Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.84,227.81l-3.2,1.85a2.52,2.52,0,0,0-1.18,2c0,.7.53,1,1.18.6l3.2-1.85a2.55,2.55,0,0,0,1.18-2C243,227.7,242.49,227.43,241.84,227.81Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.34,223.82l-3.19,1.85a2.52,2.52,0,0,0-1.18,2c0,.71.52,1,1.18.6l3.19-1.85a2.54,2.54,0,0,0,1.18-2C238.52,223.71,238,223.45,237.34,223.82Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.34,223.82l-3.19,1.85a2.52,2.52,0,0,0-1.18,2c0,.71.52,1,1.18.6l3.19-1.85a2.54,2.54,0,0,0,1.18-2C238.52,223.71,238,223.45,237.34,223.82Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.08,232.87l-19.52,11.27a2.52,2.52,0,0,0-1.18,2c0,.71.52,1,1.18.6l19.52-11.28a2.52,2.52,0,0,0,1.18-2C234.26,232.76,233.73,232.49,233.08,232.87Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.08,232.87l-19.52,11.27a2.52,2.52,0,0,0-1.18,2c0,.71.52,1,1.18.6l19.52-11.28a2.52,2.52,0,0,0,1.18-2C234.26,232.76,233.73,232.49,233.08,232.87Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.59,228.88l-15,8.69a2.52,2.52,0,0,0-1.18,2c0,.71.52,1,1.18.6l15-8.69a2.55,2.55,0,0,0,1.18-2C229.77,228.77,229.24,228.5,228.59,228.88Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.59,228.88l-15,8.69a2.52,2.52,0,0,0-1.18,2c0,.71.52,1,1.18.6l15-8.69a2.55,2.55,0,0,0,1.18-2C229.77,228.77,229.24,228.5,228.59,228.88Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.06,121.05l-34.73,20a5.14,5.14,0,0,0-2.33,4v40.1c0,1.49,1,2.09,2.33,1.35l34.73-20.05a5.17,5.17,0,0,0,2.33-4v-40.1C247.39,120.9,246.35,120.3,245.06,121.05Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.84,160.8l-3.2,1.85a2.52,2.52,0,0,0-1.18,2c0,.7.53,1,1.18.59l3.2-1.84a2.55,2.55,0,0,0,1.18-2C243,160.69,242.49,160.42,241.84,160.8Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.84,160.8l-3.2,1.85a2.52,2.52,0,0,0-1.18,2c0,.7.53,1,1.18.59l3.2-1.84a2.55,2.55,0,0,0,1.18-2C243,160.69,242.49,160.42,241.84,160.8Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.84,128l-3.2,1.85a2.52,2.52,0,0,0-1.18,2c0,.7.53,1,1.18.59l3.2-1.85a2.52,2.52,0,0,0,1.18-2C243,127.85,242.49,127.58,241.84,128Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.84,128l-3.2,1.85a2.52,2.52,0,0,0-1.18,2c0,.7.53,1,1.18.59l3.2-1.85a2.52,2.52,0,0,0,1.18-2C243,127.85,242.49,127.58,241.84,128Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.34,137.11,234.15,139a2.52,2.52,0,0,0-1.18,2c0,.71.52,1,1.18.6l3.19-1.85a2.52,2.52,0,0,0,1.18-2C238.52,137,238,136.73,237.34,137.11Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.34,137.11,234.15,139a2.52,2.52,0,0,0-1.18,2c0,.71.52,1,1.18.6l3.19-1.85a2.52,2.52,0,0,0,1.18-2C238.52,137,238,136.73,237.34,137.11Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.34,143.66l-3.19,1.85a2.49,2.49,0,0,0-1.18,2c0,.7.52,1,1.18.59l3.19-1.85a2.52,2.52,0,0,0,1.18-2C238.52,143.55,238,143.28,237.34,143.66Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.34,143.66l-3.19,1.85a2.49,2.49,0,0,0-1.18,2c0,.7.52,1,1.18.59l3.19-1.85a2.52,2.52,0,0,0,1.18-2C238.52,143.55,238,143.28,237.34,143.66Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.84,147.66l-3.2,1.85a2.52,2.52,0,0,0-1.18,2c0,.7.53,1,1.18.59l3.2-1.85a2.52,2.52,0,0,0,1.18-2C243,147.55,242.49,147.28,241.84,147.66Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.84,147.66l-3.2,1.85a2.52,2.52,0,0,0-1.18,2c0,.7.53,1,1.18.59l3.2-1.85a2.52,2.52,0,0,0,1.18-2C243,147.55,242.49,147.28,241.84,147.66Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.34,156.81l-3.19,1.85a2.51,2.51,0,0,0-1.18,2c0,.71.52,1,1.18.6l3.19-1.85a2.55,2.55,0,0,0,1.18-2C238.52,156.7,238,156.43,237.34,156.81Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.34,156.81l-3.19,1.85a2.51,2.51,0,0,0-1.18,2c0,.71.52,1,1.18.6l3.19-1.85a2.55,2.55,0,0,0,1.18-2C238.52,156.7,238,156.43,237.34,156.81Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.08,133l-19.52,11.28a2.51,2.51,0,0,0-1.18,2c0,.71.52,1,1.18.6l19.52-11.28a2.52,2.52,0,0,0,1.18-2C234.26,132.91,233.73,132.64,233.08,133Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.08,133l-19.52,11.28a2.51,2.51,0,0,0-1.18,2c0,.71.52,1,1.18.6l19.52-11.28a2.52,2.52,0,0,0,1.18-2C234.26,132.91,233.73,132.64,233.08,133Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.08,165.86l-19.52,11.27a2.51,2.51,0,0,0-1.18,2c0,.71.52,1,1.18.6l19.52-11.28a2.52,2.52,0,0,0,1.18-2C234.26,165.75,233.73,165.48,233.08,165.86Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.08,165.86l-19.52,11.27a2.51,2.51,0,0,0-1.18,2c0,.71.52,1,1.18.6l19.52-11.28a2.52,2.52,0,0,0,1.18-2C234.26,165.75,233.73,165.48,233.08,165.86Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.59,142.16l-15,8.7a2.49,2.49,0,0,0-1.18,2c0,.7.52,1,1.18.59l15-8.69a2.54,2.54,0,0,0,1.18-2C229.77,142.05,229.24,141.79,228.59,142.16Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.59,142.16l-15,8.7a2.49,2.49,0,0,0-1.18,2c0,.7.52,1,1.18.59l15-8.69a2.54,2.54,0,0,0,1.18-2C229.77,142.05,229.24,141.79,228.59,142.16Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.59,148.73l-15,8.7a2.49,2.49,0,0,0-1.18,2c0,.7.52,1,1.18.59l15-8.69a2.55,2.55,0,0,0,1.18-2C229.77,148.62,229.24,148.35,228.59,148.73Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.59,148.73l-15,8.7a2.49,2.49,0,0,0-1.18,2c0,.7.52,1,1.18.59l15-8.69a2.55,2.55,0,0,0,1.18-2C229.77,148.62,229.24,148.35,228.59,148.73Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.08,152.72,213.56,164a2.52,2.52,0,0,0-1.18,2c0,.71.52,1,1.18.6l19.52-11.27a2.55,2.55,0,0,0,1.18-2C234.26,152.61,233.73,152.34,233.08,152.72Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.08,152.72,213.56,164a2.52,2.52,0,0,0-1.18,2c0,.71.52,1,1.18.6l19.52-11.27a2.55,2.55,0,0,0,1.18-2C234.26,152.61,233.73,152.34,233.08,152.72Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.59,161.87l-15,8.69a2.52,2.52,0,0,0-1.18,2c0,.71.52,1,1.18.6l15-8.69a2.55,2.55,0,0,0,1.18-2C229.77,161.76,229.24,161.49,228.59,161.87Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.59,161.87l-15,8.69a2.52,2.52,0,0,0-1.18,2c0,.71.52,1,1.18.6l15-8.69a2.55,2.55,0,0,0,1.18-2C229.77,161.76,229.24,161.49,228.59,161.87Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M102.32,207.55l32.86-19c.46-.27.83-.08.83.42a1.77,1.77,0,0,1-.83,1.38l-32.86,19c-.46.27-.83.08-.83-.42A1.8,1.8,0,0,1,102.32,207.55Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.29,229.34,199,173.59c.46-.27.83-.08.83.42a1.77,1.77,0,0,1-.83,1.38l-96.71,55.75c-.46.27-.83.08-.83-.42A1.77,1.77,0,0,1,102.29,229.34Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.41,186.72l61.09-35.16c.46-.26.84-.08.84.42a1.78,1.78,0,0,1-.84,1.38l-61.09,35.16c-.46.27-.83.08-.83-.42A1.77,1.77,0,0,1,138.41,186.72Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.32,212.73,119,203.11c.46-.26.83-.07.83.43a1.8,1.8,0,0,1-.83,1.38l-16.64,9.61c-.46.27-.83.08-.83-.42A1.77,1.77,0,0,1,102.32,212.73Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.32,212.73,119,203.11c.46-.26.83-.07.83.43a1.8,1.8,0,0,1-.83,1.38l-16.64,9.61c-.46.27-.83.08-.83-.42A1.77,1.77,0,0,1,102.32,212.73Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.32,217.88l10-5.75c.46-.27.83-.08.83.42a1.78,1.78,0,0,1-.83,1.38l-10,5.75c-.46.27-.83.08-.83-.42A1.77,1.77,0,0,1,102.32,217.88Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.32,217.88l10-5.75c.46-.27.83-.08.83.42a1.78,1.78,0,0,1-.83,1.38l-10,5.75c-.46.27-.83.08-.83-.42A1.77,1.77,0,0,1,102.32,217.88Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.19,201.25l57.89-33.34c.46-.27.83-.08.83.42a1.8,1.8,0,0,1-.83,1.38l-57.89,33.34c-.46.27-.84.08-.84-.42A1.81,1.81,0,0,1,122.19,201.25Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.19,201.25l57.89-33.34c.46-.27.83-.08.83.42a1.8,1.8,0,0,1-.83,1.38l-57.89,33.34c-.46.27-.84.08-.84-.42A1.81,1.81,0,0,1,122.19,201.25Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111,243l88.51-51.15c.46-.26.84-.07.84.42a1.81,1.81,0,0,1-.84,1.39L111,244.78c-.46.27-.83.08-.83-.42A1.77,1.77,0,0,1,111,243Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111,237.83l88.51-51.17c.46-.26.84-.08.84.42a1.78,1.78,0,0,1-.84,1.38L111,239.64c-.46.26-.83.07-.83-.43A1.8,1.8,0,0,1,111,237.83Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115,210.6l16.46-9.55c.46-.26.83-.07.83.42a1.77,1.77,0,0,1-.83,1.38L115,212.4c-.46.27-.84.08-.84-.42A1.81,1.81,0,0,1,115,210.6Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115,210.6l16.46-9.55c.46-.26.83-.07.83.42a1.77,1.77,0,0,1-.83,1.38L115,212.4c-.46.27-.84.08-.84-.42A1.81,1.81,0,0,1,115,210.6Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.68,199.19,199,162.33c.46-.26.84-.07.84.43a1.81,1.81,0,0,1-.84,1.38L134.68,201c-.46.27-.84.08-.84-.42A1.78,1.78,0,0,1,134.68,199.19Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.68,199.19,199,162.33c.46-.26.84-.07.84.43a1.81,1.81,0,0,1-.84,1.38L134.68,201c-.46.27-.84.08-.84-.42A1.78,1.78,0,0,1,134.68,199.19Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.29,223.32l29.16-16.74c.46-.27.83-.08.83.42a1.77,1.77,0,0,1-.83,1.38l-29.16,16.74c-.46.26-.83.07-.83-.42A1.77,1.77,0,0,1,102.29,223.32Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.29,223.32l29.16-16.74c.46-.27.83-.08.83.42a1.77,1.77,0,0,1-.83,1.38l-29.16,16.74c-.46.26-.83.07-.83-.42A1.77,1.77,0,0,1,102.29,223.32Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.68,204.72,199,167.86c.46-.26.84-.08.84.42a1.78,1.78,0,0,1-.84,1.38l-64.33,36.86c-.46.26-.84.08-.84-.42A1.78,1.78,0,0,1,134.68,204.72Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.68,204.72,199,167.86c.46-.26.84-.08.84.42a1.78,1.78,0,0,1-.84,1.38l-64.33,36.86c-.46.26-.84.08-.84-.42A1.78,1.78,0,0,1,134.68,204.72Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111,248.19l88.51-51c.46-.26.84-.08.84.42a1.78,1.78,0,0,1-.84,1.38L111,250c-.46.27-.83.08-.83-.42A1.78,1.78,0,0,1,111,248.19Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111,253.35l88.51-51c.46-.27.84-.08.84.42a1.78,1.78,0,0,1-.84,1.38l-88.51,51c-.46.27-.83.08-.83-.42A1.77,1.77,0,0,1,111,253.35Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111,258.51l88.51-51c.46-.27.84-.08.84.42a1.78,1.78,0,0,1-.84,1.38l-88.51,51c-.46.27-.83.08-.83-.42A1.77,1.77,0,0,1,111,258.51Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111,265.36l88.51-51c.46-.27.84-.08.84.42a1.78,1.78,0,0,1-.84,1.38l-88.51,51c-.46.26-.83.08-.83-.42A1.77,1.77,0,0,1,111,265.36Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.5,270.19l3.85-2.21c.46-.27.83-.08.83.42a1.77,1.77,0,0,1-.83,1.38L102.5,272c-.46.27-.83.08-.83-.42A1.8,1.8,0,0,1,102.5,270.19Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.5,270.19l3.85-2.21c.46-.27.83-.08.83.42a1.77,1.77,0,0,1-.83,1.38L102.5,272c-.46.27-.83.08-.83-.42A1.8,1.8,0,0,1,102.5,270.19Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.5,242l3.85-2.21c.46-.26.83-.07.83.42a1.77,1.77,0,0,1-.83,1.38l-3.85,2.22c-.46.26-.83.07-.83-.42A1.8,1.8,0,0,1,102.5,242Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.5,242l3.85-2.21c.46-.26.83-.07.83.42a1.77,1.77,0,0,1-.83,1.38l-3.85,2.22c-.46.26-.83.07-.83-.42A1.8,1.8,0,0,1,102.5,242Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.5,253.1l3.85-2.21c.46-.27.83-.08.83.42a1.8,1.8,0,0,1-.83,1.38l-3.85,2.21c-.46.27-.83.08-.83-.42A1.77,1.77,0,0,1,102.5,253.1Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.5,253.1l3.85-2.21c.46-.27.83-.08.83.42a1.8,1.8,0,0,1-.83,1.38l-3.85,2.21c-.46.27-.83.08-.83-.42A1.77,1.77,0,0,1,102.5,253.1Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.5,258.26l3.85-2.22c.46-.26.83-.07.83.43a1.8,1.8,0,0,1-.83,1.38l-3.85,2.21c-.46.26-.83.08-.83-.42A1.77,1.77,0,0,1,102.5,258.26Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.5,258.26l3.85-2.22c.46-.26.83-.07.83.43a1.8,1.8,0,0,1-.83,1.38l-3.85,2.21c-.46.26-.83.08-.83-.42A1.77,1.77,0,0,1,102.5,258.26Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.5,263.42l3.85-2.22c.46-.26.83-.07.83.42a1.8,1.8,0,0,1-.83,1.39l-3.85,2.21c-.46.26-.83.08-.83-.42A1.77,1.77,0,0,1,102.5,263.42Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.5,263.42l3.85-2.22c.46-.26.83-.07.83.42a1.8,1.8,0,0,1-.83,1.39l-3.85,2.21c-.46.26-.83.08-.83-.42A1.77,1.77,0,0,1,102.5,263.42Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.5,274.86l3.85-2.22c.46-.26.83-.07.83.42a1.8,1.8,0,0,1-.83,1.39l-3.85,2.21c-.46.26-.83.08-.83-.42A1.77,1.77,0,0,1,102.5,274.86Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.5,274.86l3.85-2.22c.46-.26.83-.07.83.42a1.8,1.8,0,0,1-.83,1.39l-3.85,2.21c-.46.26-.83.08-.83-.42A1.77,1.77,0,0,1,102.5,274.86Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111,270.05l88.51-51.17c.46-.26.84-.08.84.42a1.78,1.78,0,0,1-.84,1.38L111,271.86c-.46.26-.83.07-.83-.42A1.8,1.8,0,0,1,111,270.05Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.41,303.54l23.77-13.72c.46-.27.83-.08.83.42a1.78,1.78,0,0,1-.83,1.38l-23.77,13.72c-.46.26-.84.08-.84-.42A1.78,1.78,0,0,1,111.41,303.54Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.5,308.63l3.85-2.21c.46-.27.83-.08.83.42a1.8,1.8,0,0,1-.83,1.38l-3.85,2.21c-.46.27-.83.08-.83-.42A1.77,1.77,0,0,1,102.5,308.63Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.5,308.63l3.85-2.21c.46-.27.83-.08.83.42a1.8,1.8,0,0,1-.83,1.38l-3.85,2.21c-.46.27-.83.08-.83-.42A1.77,1.77,0,0,1,102.5,308.63Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.5,313.29l3.85-2.21c.46-.27.83-.08.83.42a1.77,1.77,0,0,1-.83,1.38l-3.85,2.21c-.46.27-.83.08-.83-.42A1.8,1.8,0,0,1,102.5,313.29Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.5,313.29l3.85-2.21c.46-.27.83-.08.83.42a1.77,1.77,0,0,1-.83,1.38l-3.85,2.21c-.46.27-.83.08-.83-.42A1.8,1.8,0,0,1,102.5,313.29Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.37,308l87.78-50.65c.46-.27.83-.08.83.42a1.77,1.77,0,0,1-.83,1.38L111.37,309.8c-.46.27-.83.08-.83-.42A1.77,1.77,0,0,1,111.37,308Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.14,281l88.36-50.89c.46-.26.84-.07.84.42a1.81,1.81,0,0,1-.84,1.39l-88.36,50.88c-.46.27-.84.08-.84-.42A1.78,1.78,0,0,1,111.14,281Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.5,286l3.85-2.21c.46-.27.83-.08.83.42a1.78,1.78,0,0,1-.83,1.38l-3.85,2.21c-.46.27-.83.08-.83-.42A1.77,1.77,0,0,1,102.5,286Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.5,286l3.85-2.21c.46-.27.83-.08.83.42a1.78,1.78,0,0,1-.83,1.38l-3.85,2.21c-.46.27-.83.08-.83-.42A1.77,1.77,0,0,1,102.5,286Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.14,286.12l88.36-50.88c.46-.27.84-.08.84.42a1.78,1.78,0,0,1-.84,1.38l-88.36,50.89c-.46.26-.84.07-.84-.43A1.81,1.81,0,0,1,111.14,286.12Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.5,291.11l3.85-2.21c.46-.27.83-.08.83.42a1.8,1.8,0,0,1-.83,1.38l-3.85,2.21c-.46.27-.83.08-.83-.42A1.77,1.77,0,0,1,102.5,291.11Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.5,291.11l3.85-2.21c.46-.27.83-.08.83.42a1.8,1.8,0,0,1-.83,1.38l-3.85,2.21c-.46.27-.83.08-.83-.42A1.77,1.77,0,0,1,102.5,291.11Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.14,291.3l88.36-50.88c.46-.27.84-.08.84.42a1.78,1.78,0,0,1-.84,1.38l-88.36,50.89c-.46.26-.84.07-.84-.42A1.81,1.81,0,0,1,111.14,291.3Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.5,296.27l3.85-2.22c.46-.26.83-.07.83.43a1.8,1.8,0,0,1-.83,1.38l-3.85,2.21c-.46.27-.83.08-.83-.42A1.77,1.77,0,0,1,102.5,296.27Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.5,296.27l3.85-2.22c.46-.26.83-.07.83.43a1.8,1.8,0,0,1-.83,1.38l-3.85,2.21c-.46.27-.83.08-.83-.42A1.77,1.77,0,0,1,102.5,296.27Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Gears--inject-126"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--gears--inject-126"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M272.15,71.58l61.39-35.46c.79-.45,1.43-.08,1.43.83V92.38a3.14,3.14,0,0,1-1.43,2.47L272.15,130.3c-.79.46-1.43.09-1.43-.82V74.05A3.14,3.14,0,0,1,272.15,71.58Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.74,81.18a3.58,3.58,0,0,0-.66-.93,2.77,2.77,0,0,0-.76-.56,2.44,2.44,0,0,0-.44-.19,3.66,3.66,0,0,0-1.3-.17l-.47,0-.34.07a3.37,3.37,0,0,0-.34.09,1.9,1.9,0,0,0-.38.13l-.34.13c0,.12,0,.25,0,.38v.27a1.77,1.77,0,0,1,0,.23,14.1,14.1,0,0,1-6.38,11,8.42,8.42,0,0,1-.78.41h0a3.26,3.26,0,0,0,.05.33.7.7,0,0,0,0,.14,2.33,2.33,0,0,0,.08.36,1.28,1.28,0,0,0,.09.32,1.7,1.7,0,0,0,.12.34,2.36,2.36,0,0,0,.12.28,3.78,3.78,0,0,0,.44.7,3,3,0,0,0,.5.5l.05,0,.23.17.05,0a1.64,1.64,0,0,0,.29.16,1.62,1.62,0,0,0,.33.13,4,4,0,0,0,2.46,0c.24-.08.48-.17.73-.28s.5-.24.76-.38a14.1,14.1,0,0,0,6.39-11.06A6,6,0,0,0,301.74,81.18Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.19,74.06l-.65,1.3a.92.92,0,0,0,0,.81,7.41,7.41,0,0,1,.75,1.66.4.4,0,0,0,.56.27l3.36-1.52a.43.43,0,0,1,.27,0ZM302,67l-2.44-1.41a.88.88,0,0,0-.17,0l-.16,0a.15.15,0,0,0-.09,0l-.16.13s-.07,0-.08.06l-2,3-2.51-1.45-.05,0-1.82-1h0l-.09,0a.35.35,0,0,0-.19.06l-2.6,1.5-.3.17h0l-.82.46,0,0a.79.79,0,0,0-.15.12,1.41,1.41,0,0,0-.23.35h0a.63.63,0,0,0-.07.22l-.38,4.21s0,0,0,.06a1,1,0,0,1-.06.23,1.44,1.44,0,0,1-.32.49,23.3,23.3,0,0,0-2.1,2.22.63.63,0,0,1-.32.2.64.64,0,0,1-.43,0L282,75.67c-.06,0-.12,0-.18,0l-.06,0-.05,0,0,0-.1,0-.1.06-.07,0a.31.31,0,0,0-.09.11l-1.14,2L279,80l-.42.74a.53.53,0,0,0-.07.37h0a.56.56,0,0,0,.17.33l2,1.68.1.11a.76.76,0,0,1,.13.39.73.73,0,0,1,0,.25,23.09,23.09,0,0,0-.87,2.92,1.28,1.28,0,0,1-.23.47,1.12,1.12,0,0,1-.26.27L276,90a.68.68,0,0,0-.12.12,1.11,1.11,0,0,0-.11.16h0a.93.93,0,0,0-.15.46v4.36a.29.29,0,0,0,.13.28l4.37,2.53-1.59,3.22a.49.49,0,0,0,.2.65l5.94,3.45.08,0-.07,0-.4-.23a.51.51,0,0,1-.2-.66l2.25-4.52a.78.78,0,0,0,.05-.18,1,1,0,0,0-.11-.63,8,8,0,0,1-.75-1.67.4.4,0,0,0-.56-.26l-1.69.76-1.67.75a.27.27,0,0,1-.3,0h0a.29.29,0,0,1-.13-.27V93.91a.86.86,0,0,1,.15-.46.77.77,0,0,1,.23-.27L285,90.74a1.25,1.25,0,0,0,.25-.26,1.28,1.28,0,0,0,.23-.47,23.09,23.09,0,0,1,.87-2.92.69.69,0,0,0,0-.25h0a.66.66,0,0,0-.23-.5l-1.94-1.68a.52.52,0,0,1-.18-.33.64.64,0,0,1,.05-.39l.8-1.37,1-1.7,1-1.74a.52.52,0,0,1,.42-.26h0a.48.48,0,0,1,.24,0l2.43.85a.7.7,0,0,0,.43,0,.6.6,0,0,0,.31-.2,23.5,23.5,0,0,1,2.1-2.23,1.55,1.55,0,0,0,.32-.48.92.92,0,0,0,.07-.3l.38-4.2a.62.62,0,0,1,.07-.23.89.89,0,0,1,.39-.48l.71-.41,1.52-.88,1.54-.89a.29.29,0,0,1,.28,0s0,0,0,0a.31.31,0,0,1,.16.26l.19,1.92.18,1.75a.39.39,0,0,0,.5.35A7.22,7.22,0,0,1,301,73.5a.93.93,0,0,0,.53-.17,1,1,0,0,0,.21-.2l2.79-4.2a.43.43,0,0,1,.09-.1.52.52,0,0,1,.44-.11l.1,0Zm-8.37,38.72a.18.18,0,0,1-.05-.08.5.5,0,0,1,0-.13l-.36-3.66a.39.39,0,0,0-.51-.36,7.69,7.69,0,0,1-1.81.19.93.93,0,0,0-.74.36l-.8,1.2,4.32,2.49A0,0,0,0,0,293.66,105.69Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.11,68.76l-.1,0a.52.52,0,0,0-.44.11.43.43,0,0,0-.09.1l-2.79,4.2a1,1,0,0,1-.21.2.93.93,0,0,1-.53.17,7.22,7.22,0,0,0-1.81.18.39.39,0,0,1-.5-.35l-.18-1.75-.19-1.92a.31.31,0,0,0-.16-.26s0,0,0,0a.29.29,0,0,0-.28,0l-1.54.89-1.52.88-.71.41a.89.89,0,0,0-.39.48.62.62,0,0,0-.07.23l-.38,4.2a.92.92,0,0,1-.07.3,1.55,1.55,0,0,1-.32.48,23.5,23.5,0,0,0-2.1,2.23.6.6,0,0,1-.31.2.7.7,0,0,1-.43,0l-2.43-.85a.48.48,0,0,0-.24,0h0a.52.52,0,0,0-.42.26l-1,1.74-1,1.7-.8,1.37a.64.64,0,0,0-.05.39.52.52,0,0,0,.18.33l1.94,1.68a.66.66,0,0,1,.23.5h0a.69.69,0,0,1,0,.25,23.09,23.09,0,0,0-.87,2.92,1.28,1.28,0,0,1-.23.47,1.25,1.25,0,0,1-.25.26l-3.46,2.44a.77.77,0,0,0-.23.27.86.86,0,0,0-.15.46v4.37a.29.29,0,0,0,.13.27h0a.27.27,0,0,0,.3,0l1.67-.75,1.69-.76a.4.4,0,0,1,.56.26,8,8,0,0,0,.75,1.67,1,1,0,0,1,.11.63.78.78,0,0,1-.05.18l-2.25,4.52a.51.51,0,0,0,.2.66l.4.23.07,0-.08,0-5.94-3.45a.49.49,0,0,1-.2-.65l1.59-3.22-4.37-2.53a.29.29,0,0,1-.13-.28V90.71a.93.93,0,0,1,.15-.46h0a1.11,1.11,0,0,1,.11-.16A.68.68,0,0,1,276,90l3.45-2.43a1.12,1.12,0,0,0,.26-.27,1.28,1.28,0,0,0,.23-.47,23.09,23.09,0,0,1,.87-2.92.73.73,0,0,0,0-.25.76.76,0,0,0-.13-.39l-.1-.11-2-1.68a.56.56,0,0,1-.17-.33h0a.53.53,0,0,1,.07-.37L279,80l1.21-2.09.33-.58.84-1.45a.5.5,0,0,1,.61-.22H282l2.22.79h0l.19.06a.64.64,0,0,0,.43,0,.63.63,0,0,0,.32-.2,23.3,23.3,0,0,1,2.1-2.22,1.44,1.44,0,0,0,.32-.49,1,1,0,0,0,.06-.23s0,0,0-.06L288,69.1a.63.63,0,0,1,.07-.22h0a1.41,1.41,0,0,1,.23-.35,1,1,0,0,1,.2-.16l.82-.46h0l.3-.17,2.6-1.5a.35.35,0,0,1,.19-.06l.09,0h0l1.82,1,.05,0,2.51,1.45,2-3s.05,0,.08-.06l.16-.13a.15.15,0,0,1,.09,0l.16,0a.88.88,0,0,1,.17,0L302,67Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.61,105.61a.5.5,0,0,1,0-.13l-.36-3.66a.39.39,0,0,0-.51-.36,7.69,7.69,0,0,1-1.81.19.93.93,0,0,0-.74.36l-.8,1.2,4.32,2.49a0,0,0,0,0,0,0A.18.18,0,0,1,293.61,105.61Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.19,74.06l-.65,1.3a.92.92,0,0,0,0,.81,7.41,7.41,0,0,1,.75,1.66.4.4,0,0,0,.56.27l3.36-1.52a.43.43,0,0,1,.27,0Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.65,72.08a.62.62,0,0,0-.07.23l-.38,4.2a.92.92,0,0,1-.07.3l-5.55-3.21h0a2,2,0,0,0,.08-.22s0,0,0-.06L288,69.1a.94.94,0,0,1,.07-.22Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.38,86.84l-5.55-3.21,0,0a.76.76,0,0,0-.1-.37l-.1-.11-2-1.68a.56.56,0,0,1-.17-.33L284,84.33a.52.52,0,0,0,.18.33l1.94,1.68A.66.66,0,0,1,286.38,86.84Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.06,104.3a.51.51,0,0,0,.2.66l.4.23h0l-5.94-3.45a.49.49,0,0,1-.2-.65l1.59-3.22,1.18.67h0a.27.27,0,0,0,.3,0l1.67-.75,3.11,1.8a.78.78,0,0,1-.05.18Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.31,83.88a14.1,14.1,0,0,1-6.39,11.06c-.26.14-.51.27-.76.38s-.49.2-.73.28a4,4,0,0,1-2.46,0,1.62,1.62,0,0,1-.33-.13,1.64,1.64,0,0,1-.29-.16l-.05,0-.23-.17-.05,0a3,3,0,0,1-.5-.5,3.78,3.78,0,0,1-.44-.7,2.36,2.36,0,0,1-.12-.28,1.7,1.7,0,0,1-.12-.34,1.28,1.28,0,0,1-.09-.32,2.33,2.33,0,0,1-.08-.36.7.7,0,0,1,0-.14,3.26,3.26,0,0,1-.05-.33h0a8.42,8.42,0,0,0,.78-.41,14.1,14.1,0,0,0,6.38-11,1.77,1.77,0,0,0,0-.23v-.27c0-.13,0-.26,0-.38h0l.34-.13a1.9,1.9,0,0,1,.38-.13,3.37,3.37,0,0,1,.34-.09l.34-.07.47,0a3.66,3.66,0,0,1,1.3.17,2.44,2.44,0,0,1,.44.19,2.77,2.77,0,0,1,.76.56,3.58,3.58,0,0,1,.66.93A6,6,0,0,1,302.31,83.88Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.11,68.76l-.1,0a.52.52,0,0,0-.44.11l-.09.1-2.79,4.2a1,1,0,0,1-.21.2l-1.56-.91-1.46-.84-.19-1.92a.31.31,0,0,0-.16-.26s0,0,0,0l-1.15-.68,2-3a.46.46,0,0,1,.24-.19.15.15,0,0,1,.09,0,.42.42,0,0,1,.33,0L302,67Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.24,90.48a1.25,1.25,0,0,1-.25.26l-3.46,2.44a.77.77,0,0,0-.23.27l-5.55-3.2.11-.16A.68.68,0,0,1,276,90l3.45-2.43a1.12,1.12,0,0,0,.26-.27Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.11,69.39h0s0,0,0,0Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.11,69.39h0s0,0,0,0Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.69,81.22V76.86a.28.28,0,0,0-.43-.28L306.9,78.1a.4.4,0,0,1-.56-.26,7.3,7.3,0,0,0-.75-1.67.92.92,0,0,1,0-.81l2.24-4.52a.5.5,0,0,0-.2-.66l-2.43-1.4a.52.52,0,0,0-.67.15l-2.79,4.2a1,1,0,0,1-.73.37,7.25,7.25,0,0,0-1.82.18.4.4,0,0,1-.51-.36l-.36-3.67a.29.29,0,0,0-.46-.23L294,71.6a1.07,1.07,0,0,0-.45.71l-.38,4.2a1.41,1.41,0,0,1-.39.79,22.23,22.23,0,0,0-2.1,2.22.73.73,0,0,1-.74.21l-2.42-.85a.6.6,0,0,0-.69.25l-2.77,4.81a.59.59,0,0,0,.12.72l1.94,1.68a.71.71,0,0,1,.19.74,23.73,23.73,0,0,0-.87,2.93,1.4,1.4,0,0,1-.48.73l-3.46,2.43a1,1,0,0,0-.38.75v4.36a.28.28,0,0,0,.43.28L284.94,97a.4.4,0,0,1,.56.26,8,8,0,0,0,.75,1.67.89.89,0,0,1,.05.81l-2.24,4.52a.51.51,0,0,0,.2.66l2.43,1.4a.51.51,0,0,0,.67-.15l2.79-4.2a1,1,0,0,1,.74-.37,7.22,7.22,0,0,0,1.81-.18.4.4,0,0,1,.51.35l.37,3.67a.28.28,0,0,0,.45.24l3.78-2.18a1,1,0,0,0,.45-.71l.38-4.2a1.41,1.41,0,0,1,.39-.79,21.14,21.14,0,0,0,2.1-2.22.72.72,0,0,1,.74-.21l2.43.85A.6.6,0,0,0,305,96l2.78-4.81a.58.58,0,0,0-.13-.71l-1.94-1.68a.72.72,0,0,1-.19-.75,23.09,23.09,0,0,0,.87-2.92,1.39,1.39,0,0,1,.49-.74L310.31,82A1,1,0,0,0,310.69,81.22ZM295.92,94.94c-3.52,2-6.38.38-6.38-3.69a14.1,14.1,0,0,1,6.38-11c3.53-2,6.38-.39,6.38,3.68A14.11,14.11,0,0,1,295.92,94.94Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283,76.39l-1.3-.76a.53.53,0,0,0-.4.26l-.84,1.44h0l-.33.58L279,80l-.42.74a.53.53,0,0,0-.07.37h0L284,84.33a.64.64,0,0,1,.05-.39l.8-1.37,1-1.7,1-1.74a.52.52,0,0,1,.42-.26Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283,76.39l-1.3-.76a.53.53,0,0,0-.4.26l-.84,1.44h0l-.33.58L279,80l-.42.74a.53.53,0,0,0-.07.37h0L284,84.33a.64.64,0,0,1,.05-.39l.8-1.37,1-1.7,1-1.74a.52.52,0,0,1,.42-.26Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.84,76.51a.64.64,0,0,1-.43,0l-.19-.06h0L282,75.67H282a.51.51,0,0,0-.21,0l.08.05h0l1.22.71.42.25h0l3.83,2.23h0a.48.48,0,0,1,.24,0l2.43.85a.7.7,0,0,0,.43,0Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.09,69.39a.29.29,0,0,0-.28,0l-1.54.89-1.52.88-.71.41a.89.89,0,0,0-.39.48l-5.55-3.2h0a1.41,1.41,0,0,1,.23-.35.79.79,0,0,1,.15-.12l0,0,.82-.46h0l.3-.17,2.6-1.5a.35.35,0,0,1,.19-.06l.09,0h0l1.82,1,.05,0,2.51,1.45Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.09,69.39a.29.29,0,0,0-.28,0l-1.54.89-1.52.88-.71.41a.89.89,0,0,0-.39.48l-5.55-3.2h0a1.41,1.41,0,0,1,.23-.35.79.79,0,0,1,.15-.12l0,0,.82-.46h0l.3-.17,2.6-1.5a.35.35,0,0,1,.19-.06l.09,0h0l1.82,1,.05,0,2.51,1.45Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.68,84a2,2,0,0,0-1.62-1.28h-.24a3.11,3.11,0,0,0-1.46.31c0,.18,0,.36,0,.56a9.15,9.15,0,0,1-4.15,7.18,3.87,3.87,0,0,1-.49.26,3.37,3.37,0,0,0,.29,1.08A2.06,2.06,0,0,0,321,93.42h.19l.22,0a1.13,1.13,0,0,0,.18,0l.08,0a.53.53,0,0,0,.12,0,5.77,5.77,0,0,0,2.68-1.74C326.56,89.34,327.56,86,326.68,84Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.44,91.57a5.77,5.77,0,0,1-2.68,1.74.53.53,0,0,1-.12,0l-.08,0a1.13,1.13,0,0,1-.18,0l-.22,0H321A2.06,2.06,0,0,1,319,92.11a3.37,3.37,0,0,1-.29-1.08,3.87,3.87,0,0,0,.49-.26,9.15,9.15,0,0,0,4.15-7.18c0-.2,0-.38,0-.56a3.11,3.11,0,0,1,1.46-.31h.24A2,2,0,0,1,326.68,84C327.56,86,326.56,89.34,324.44,91.57Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325,97.43,324,95.82c-.08-.11-.27-.11-.44,0s-.42.28-.62.4L325,97.47S325,97.45,325,97.43Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.94,84a7.81,7.81,0,0,1,0,.83.29.29,0,0,0,.3.29l1.77.1a.28.28,0,0,1,.13,0Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.3,97a4.09,4.09,0,0,1-.9-.53.37.37,0,0,0-.46.08l-2.11,1.93a.42.42,0,0,1-.23.1l2.07,1.2c.67.39,1.21.71,1.28.74a.19.19,0,0,1-.09-.2l.65-3A.31.31,0,0,0,318.3,97Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.31,98.42h0l.12.08a.05.05,0,0,1,0,0l-.05-.06-.94-2.08a.36.36,0,0,1,0-.25.55.55,0,0,1,.12-.24l2-2.39a.85.85,0,0,0,.18-.37.46.46,0,0,0,0-.16,10.88,10.88,0,0,1,0-1.71.28.28,0,0,0-.3-.28l-1.77-.11a.22.22,0,0,1-.24-.29l1-3.29a.7.7,0,0,1,.45-.36l1.93-.47a.84.84,0,0,0,.5-.37,20.57,20.57,0,0,1,1-1.81s.05-.09.07-.14a.32.32,0,0,0,0-.09.44.44,0,0,0,0-.1.36.36,0,0,0,0-.18l-.64-2.14a.43.43,0,0,1,0-.24.31.31,0,0,1,.06-.13l.09-.13,2.27-2.39a.29.29,0,0,1,.3-.11s0,0,0,0a.15.15,0,0,1,.06,0l1.06,1.61c.07.11.27.11.44,0a9.36,9.36,0,0,1,1.28-.74,1,1,0,0,0,.45-.43l1.11-3a.35.35,0,0,1,0-.08.65.65,0,0,1,.28-.2l.06,0h.07l2.06-.21h.13l.07,0a.16.16,0,0,1,.08.2l-.64,3a.35.35,0,0,0,.21.37,3.52,3.52,0,0,1,.9.52.37.37,0,0,0,.46-.08l2.11-1.92c.12-.1.23-.13.31-.09L327,75.18H327l-.75-.44h0l-.82-.47-.33-.2-.75-.43-.12-.07c-.33-.19-.56-.33-.58-.33a.24.24,0,0,0-.2,0l-2.06.2-.09,0-.1,0-.09,0-.07.06a.36.36,0,0,0-.1.15l-1.12,3,0,.07-.08.11-.11.1v0l-.1.07-.12.07-.65.34-2.17-1.25h0a.17.17,0,0,0-.18,0,.28.28,0,0,0-.12.08h0L314.54,78l-.66.7a1.13,1.13,0,0,0-.1.13l-.06.15a.39.39,0,0,0,0,.18v0l.64,2.14a.6.6,0,0,1,0,.19.2.2,0,0,1,0,.07v0a.06.06,0,0,1,0,0,.72.72,0,0,1-.09.2,16.28,16.28,0,0,0-1,1.81.89.89,0,0,1-.49.37l-1.95.46a.62.62,0,0,0-.43.37l-1,3.28a.2.2,0,0,0,.08.24l1.49.87.7.4a8.57,8.57,0,0,0,0,.89v0a.59.59,0,0,1,0,.13,1,1,0,0,1-.05.16c0,.07-.08.15-.12.21l-2,2.4a.5.5,0,0,0-.12.24.32.32,0,0,0,0,.13.2.2,0,0,0,0,.11l.94,2.08a.13.13,0,0,0,.06.07h0l.6.34.28.17,2.53,1.45.27.16.15.09",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.31,98.42h0l.12.08a.05.05,0,0,1,0,0l-.05-.06-.94-2.08a.36.36,0,0,1,0-.25.55.55,0,0,1,.12-.24l2-2.39a.85.85,0,0,0,.18-.37.46.46,0,0,0,0-.16,10.88,10.88,0,0,1,0-1.71.28.28,0,0,0-.3-.28l-1.77-.11a.22.22,0,0,1-.24-.29l1-3.29a.7.7,0,0,1,.45-.36l1.93-.47a.84.84,0,0,0,.5-.37,20.57,20.57,0,0,1,1-1.81s.05-.09.07-.14a.32.32,0,0,0,0-.09.44.44,0,0,0,0-.1.36.36,0,0,0,0-.18l-.64-2.14a.43.43,0,0,1,0-.24.31.31,0,0,1,.06-.13l.09-.13,2.27-2.39a.29.29,0,0,1,.3-.11s0,0,0,0a.15.15,0,0,1,.06,0l1.06,1.61c.07.11.27.11.44,0a9.36,9.36,0,0,1,1.28-.74,1,1,0,0,0,.45-.43l1.11-3a.35.35,0,0,1,0-.08.65.65,0,0,1,.28-.2l.06,0h.07l2.06-.21h.13l.07,0a.16.16,0,0,1,.08.2l-.64,3a.35.35,0,0,0,.21.37,3.52,3.52,0,0,1,.9.52.37.37,0,0,0,.46-.08l2.11-1.92c.12-.1.23-.13.31-.09L327,75.18H327l-.75-.44h0l-.82-.47-.33-.2-.75-.43-.12-.07c-.33-.19-.56-.33-.58-.33a.24.24,0,0,0-.2,0l-2.06.2-.09,0-.1,0-.09,0-.07.06a.36.36,0,0,0-.1.15l-1.12,3,0,.07-.08.11-.11.1v0l-.1.07-.12.07-.65.34-2.17-1.25h0a.17.17,0,0,0-.18,0,.28.28,0,0,0-.12.08h0L314.54,78l-.66.7a1.13,1.13,0,0,0-.1.13l-.06.15a.39.39,0,0,0,0,.18v0l.64,2.14a.6.6,0,0,1,0,.19.2.2,0,0,1,0,.07v0a.06.06,0,0,1,0,0,.72.72,0,0,1-.09.2,16.28,16.28,0,0,0-1,1.81.89.89,0,0,1-.49.37l-1.95.46a.62.62,0,0,0-.43.37l-1,3.28a.2.2,0,0,0,.08.24l1.49.87.7.4a8.57,8.57,0,0,0,0,.89v0a.59.59,0,0,1,0,.13,1,1,0,0,1-.05.16c0,.07-.08.15-.12.21l-2,2.4a.5.5,0,0,0-.12.24.32.32,0,0,0,0,.13.2.2,0,0,0,0,.11l.94,2.08a.13.13,0,0,0,.06.07h0l.6.34.28.17,2.53,1.45.27.16.15.09",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325,97.43,324,95.82c-.08-.11-.27-.11-.44,0s-.42.28-.62.4L325,97.47S325,97.45,325,97.43Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.94,84a7.81,7.81,0,0,1,0,.83.29.29,0,0,0,.3.29l1.77.1a.28.28,0,0,1,.13,0Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.3,97a4.09,4.09,0,0,1-.9-.53.37.37,0,0,0-.46.08l-2.11,1.93a.42.42,0,0,1-.23.1l2.07,1.2c.67.39,1.21.71,1.28.74a.19.19,0,0,1-.09-.2l.65-3A.31.31,0,0,0,318.3,97Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.75,93.28a1.09,1.09,0,0,1-.14.23l-2,2.39a.55.55,0,0,0-.12.24l-4.17-2.41a.5.5,0,0,1,.12-.24l2-2.4c0-.06.08-.14.12-.21Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.8,93a.57.57,0,0,1-.05.3l-4.18-2.4a1,1,0,0,0,.05-.16.59.59,0,0,0,0-.13v0a8.51,8.51,0,0,1,0-.88l2,1.13a.24.24,0,0,0,.18.06l1.77.11a.28.28,0,0,1,.3.28A10.88,10.88,0,0,0,315.8,93Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.12,86.34a.75.75,0,0,1-.27.13l-1.93.47a.63.63,0,0,0-.36.23l-4.18-2.41a.56.56,0,0,1,.22-.18l.14-.06,1.95-.46a1,1,0,0,0,.25-.12h0Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.5,90.59a.22.22,0,0,0,.06.23l-2-1.13h0l-2.15-1.24s0,0,0,0a.2.2,0,0,1-.08-.24l1-3.28a.38.38,0,0,1,.06-.13l4.19,2.41a.51.51,0,0,0-.09.13Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.72,79l4.17,2.4a.38.38,0,0,0,0,.23l.64,2.14a.55.55,0,0,1,0,.28l-4.17-2.42v0a.2.2,0,0,0,0-.07.6.6,0,0,0,0-.19l-.64-2.14a.32.32,0,0,1,0-.21",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.16,76a.4.4,0,0,0-.12.15l-1.11,3a.67.67,0,0,1-.22.27L319.53,77a.9.9,0,0,0,.19-.21l0-.07,1.12-3a.36.36,0,0,1,.1-.15Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.5,90.59a.22.22,0,0,0,.06.23l-2-1.13h0l-2.15-1.24s0,0,0,0a.2.2,0,0,1-.08-.24l1-3.28a.38.38,0,0,1,.06-.13l4.19,2.41a.51.51,0,0,0-.09.13Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.5,90.59a.22.22,0,0,0,.06.23l-2-1.13h0l-2.15-1.24s0,0,0,0a.2.2,0,0,1-.08-.24l1-3.28a.38.38,0,0,1,.06-.13l4.19,2.41a.51.51,0,0,0-.09.13Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.38,84.76l0,0,0,0Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.65,78.64h0a.28.28,0,0,0-.32.1l-2.27,2.39a1,1,0,0,0-.16.27L313.72,79l.06-.15a1.13,1.13,0,0,1,.1-.13l2.27-2.39.12-.09a.17.17,0,0,1,.18,0h0l2.17,1.25Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.65,78.64h0a.28.28,0,0,0-.32.1l-2.27,2.39a1,1,0,0,0-.16.27L313.72,79l.06-.15a1.13,1.13,0,0,1,.1-.13l2.27-2.39.12-.09a.17.17,0,0,1,.18,0h0l2.17,1.25Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.75,75.63a.4.4,0,0,0-.19,0l-2.06.21a.54.54,0,0,0-.34.16L321,73.56l.07-.06.09,0,.1,0,.09,0,2.06-.2a.24.24,0,0,1,.2,0S327.69,75.59,327.75,75.63Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.75,75.63a.4.4,0,0,0-.19,0l-2.06.21a.54.54,0,0,0-.34.16L321,73.56l.07-.06.09,0,.1,0,.09,0,2.06-.2a.24.24,0,0,1,.2,0S327.69,75.59,327.75,75.63Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.48,89.62l.12.06h0Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.1,85.28a.28.28,0,0,0-.13,0l-1.77-.1a.29.29,0,0,1-.3-.29,7.81,7.81,0,0,0,0-.83,8.53,8.53,0,0,0,0-.88.76.76,0,0,1,.19-.52l2-2.4a.51.51,0,0,0,.11-.48l-.93-2.08a.13.13,0,0,0-.06-.07h0c-.08,0-.19,0-.31.09l-2.11,1.92a.37.37,0,0,1-.46.08,3.52,3.52,0,0,0-.9-.52.35.35,0,0,1-.21-.37l.64-3a.16.16,0,0,0-.08-.2.31.31,0,0,0-.2,0l-2.06.21a.58.58,0,0,0-.46.31l-1.11,3a1,1,0,0,1-.45.43,9.36,9.36,0,0,0-1.28.74c-.17.12-.37.12-.44,0L320.7,78.7c-.08-.11-.25-.09-.38,0l-2.27,2.39a.6.6,0,0,0-.18.5l.64,2.14a.72.72,0,0,1-.12.51,20.57,20.57,0,0,0-1,1.81.84.84,0,0,1-.5.37l-1.93.47a.7.7,0,0,0-.45.36l-1,3.29a.22.22,0,0,0,.24.29l1.77.11a.28.28,0,0,1,.3.28,10.88,10.88,0,0,0,0,1.71.8.8,0,0,1-.19.53l-2,2.39a.56.56,0,0,0-.12.49l.92,2.06a.11.11,0,0,0,0,0l0,0h0a.12.12,0,0,0,.08,0,.36.36,0,0,0,.23-.1l2.11-1.93a.37.37,0,0,1,.46-.08,4.09,4.09,0,0,0,.9.53.31.31,0,0,1,.21.36l-.65,3a.19.19,0,0,0,.09.2h0a.42.42,0,0,0,.2,0l2.06-.2a.61.61,0,0,0,.46-.32l1.12-3a.92.92,0,0,1,.45-.44l.66-.34c.2-.12.41-.25.62-.4s.36-.12.44,0L325,97.43a.13.13,0,0,0,0,.06.28.28,0,0,0,.33-.11L327.67,95a.61.61,0,0,0,.17-.5l-.63-2.13a.77.77,0,0,1,.11-.52A17.34,17.34,0,0,0,328.37,90a.79.79,0,0,1,.49-.37l1.94-.46a.67.67,0,0,0,.44-.37l1-3.29a.2.2,0,0,0-.1-.25A0,0,0,0,0,332.1,85.28Zm-7.66,6.29a5.77,5.77,0,0,1-2.68,1.74.53.53,0,0,1-.12,0l-.08,0a1.13,1.13,0,0,1-.18,0l-.22,0H321A2.06,2.06,0,0,1,319,92.11a3.37,3.37,0,0,1-.29-1.08,4,4,0,0,1,0-.6,9.28,9.28,0,0,1,2.56-5.87,6.84,6.84,0,0,1,1.57-1.27,4.2,4.2,0,0,1,.52-.26,3.11,3.11,0,0,1,1.46-.31h.24A2,2,0,0,1,326.68,84C327.56,86,326.56,89.34,324.44,91.57Z",
    style: {
      fill: "#46C5FB"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--text-box--inject-126"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Box--inject-126"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-126",
    d: "M59,303.32,25,322.91a3,3,0,0,0-1.36,2.35v41c0,.86.61,1.21,1.36.78l34-19.59a3,3,0,0,0,1.35-2.35v-41C60.34,303.24,59.74,302.89,59,303.32Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--box--inject-126"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.2,305l-34,19.58a3,3,0,0,0-1.36,2.36v41a3,3,0,0,0,1.37,2.34l2.58,1.47a3,3,0,0,0,2.73,0l34-19.58a3,3,0,0,0,1.36-2.35v-41a3,3,0,0,0-1.36-2.34l-2.59-1.47A3,3,0,0,0,64.2,305Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.52,371.66a3.12,3.12,0,0,1-2.73,0l-2.58-1.47a3,3,0,0,1-1.37-2.34v-41a2.82,2.82,0,0,1,.43-1.39l5.29,3.06a2.7,2.7,0,0,0-.4,1.33v41C34.16,371.67,34.72,372.13,35.52,371.66Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.85,308.5c-.1-.68-.66-.92-1.34-.54l-34,19.59a2.78,2.78,0,0,0-1,1l-5.29-3.06a2.71,2.71,0,0,1,.93-1L64.2,305a3,3,0,0,1,2.72,0l2.59,1.47A3,3,0,0,1,70.85,308.5Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.51,308l-34,19.58a3,3,0,0,0-1.36,2.35v41c0,.87.61,1.22,1.36.78l34-19.58a3,3,0,0,0,1.36-2.35v-41C70.87,307.88,70.26,307.53,69.51,308Z",
    style: {
      fill: "#46C5FB"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik----inject-126"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.4,348.76a2.13,2.13,0,0,1,.16-.84,5.88,5.88,0,0,1,.43-.79l8-13a.8.8,0,0,1,.13-.16l.09-.06a.23.23,0,0,1,.3,0,.54.54,0,0,1,.12.39v5a2.26,2.26,0,0,1-.23,1c-.16.28-.29.51-.41.68l-3.51,5.39L45,347.84a1.89,1.89,0,0,1,.41.2c.15.09.23.35.23.76v5a1.24,1.24,0,0,1-.12.53.79.79,0,0,1-.3.36l-.09,0H45L37,351a1.08,1.08,0,0,1-.43-.29,1.07,1.07,0,0,1-.16-.67Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.89,326.78a4.63,4.63,0,0,1,.3-.8,1.47,1.47,0,0,1,.58-.63l2.69-1.55a.24.24,0,0,1,.31,0,.52.52,0,0,1,.13.4,1.13,1.13,0,0,1,0,.3l-6.78,28.89a3.22,3.22,0,0,1-.28.78,1.47,1.47,0,0,1-.6.66l-2.63,1.51a.24.24,0,0,1-.31,0,.56.56,0,0,1-.13-.4,1.92,1.92,0,0,1,0-.3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.63,331.46a2.1,2.1,0,0,1-.15.84,5.49,5.49,0,0,1-.44.79l-8,13a.69.69,0,0,1-.13.15l-.09.07a.23.23,0,0,1-.3,0,.5.5,0,0,1-.12-.39v-5a2.15,2.15,0,0,1,.23-1c.16-.27.29-.5.41-.67l3.51-5.42L60,332.41a1.33,1.33,0,0,1-.41-.21c-.15-.11-.23-.36-.23-.78v-5a1.24,1.24,0,0,1,.12-.53.79.79,0,0,1,.3-.36l.09,0H60l8,3.7a1.13,1.13,0,0,1,.44.29,1.08,1.08,0,0,1,.15.67Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--text-box--inject-126"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-126",
    d: "M55.16,195.82,24.4,213.55a1.66,1.66,0,0,0-.77,1.32V232c0,.49.34.69.77.44l30.76-17.72a1.68,1.68,0,0,0,.77-1.32V196.26C55.93,195.78,55.58,195.58,55.16,195.82Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--box--inject-126"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-126"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speach-bubble--inject-126"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.37,197.77,29.61,215.49a1.66,1.66,0,0,0-.77,1.32V234a1.68,1.68,0,0,0,.77,1.31l3,1.73a1.72,1.72,0,0,0,1.53,0L64.94,219.3a1.72,1.72,0,0,0,.77-1.33V200.8a1.68,1.68,0,0,0-.77-1.32l-3-1.72A1.68,1.68,0,0,0,60.37,197.77Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.37,197.77,29.61,215.49a1.66,1.66,0,0,0-.77,1.32V234a1.68,1.68,0,0,0,.77,1.31l3,1.73a1.72,1.72,0,0,0,1.53,0L64.94,219.3a1.72,1.72,0,0,0,.77-1.33V200.8a1.68,1.68,0,0,0-.77-1.32l-3-1.72A1.68,1.68,0,0,0,60.37,197.77Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.7,200.66c-.06-.38-.38-.52-.76-.3L34.18,218.08a1.65,1.65,0,0,0-.54.57L29.08,216a1.53,1.53,0,0,1,.53-.54l30.76-17.73a1.72,1.72,0,0,1,1.53,0l3,1.72A1.74,1.74,0,0,1,65.7,200.66Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.94,200.36,34.18,218.08a1.72,1.72,0,0,0-.77,1.32v17.18c0,.49.35.68.77.44L64.94,219.3a1.72,1.72,0,0,0,.77-1.33V200.8C65.71,200.31,65.36,200.12,64.94,200.36Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.94,200.36,34.18,218.08a1.72,1.72,0,0,0-.77,1.32v17.18c0,.49.35.68.77.44L64.94,219.3a1.72,1.72,0,0,0,.77-1.33V200.8C65.71,200.31,65.36,200.12,64.94,200.36Z"
  })))))), /*#__PURE__*/React.createElement("path", {
    d: "M41,222.48c0,.14,0,.32,0,.56v1.44c0,.24,0,.42,0,.55a3.75,3.75,0,0,0,.08.61.92.92,0,0,0,.22.43.48.48,0,0,0,.37.17,1.07,1.07,0,0,0,.56-.17,2.32,2.32,0,0,0,.56-.44,3,3,0,0,0,.35-.5,2.75,2.75,0,0,0,.21-.51,3.35,3.35,0,0,0,.11-.46,2.35,2.35,0,0,1,.11-.4.51.51,0,0,1,.23-.23l1.28-.74a.12.12,0,0,1,.16,0,.27.27,0,0,1,.06.2,6.1,6.1,0,0,1-.25,1.59,7.23,7.23,0,0,1-.64,1.55,7.79,7.79,0,0,1-1,1.36,4.87,4.87,0,0,1-1.21,1,2.58,2.58,0,0,1-1.26.4,1.45,1.45,0,0,1-1-.34,2.09,2.09,0,0,1-.6-1,5.16,5.16,0,0,1-.24-1.44c0-.41,0-.84,0-1.32s0-.93,0-1.37a7.42,7.42,0,0,1,.24-1.72,8,8,0,0,1,.6-1.66,6.59,6.59,0,0,1,1-1.43,4.83,4.83,0,0,1,1.26-1.05,2.65,2.65,0,0,1,1.21-.4,1.54,1.54,0,0,1,1.61,1,3.4,3.4,0,0,1,.25,1.31.66.66,0,0,1-.06.27.41.41,0,0,1-.16.18l-1.28.75c-.11.06-.19.07-.23,0a.79.79,0,0,1-.11-.28,1.82,1.82,0,0,0-.11-.33.61.61,0,0,0-.21-.26.63.63,0,0,0-.35-.09,1.22,1.22,0,0,0-.56.2,2.09,2.09,0,0,0-.56.46,3.13,3.13,0,0,0-.37.6,3.26,3.26,0,0,0-.22.69A5.71,5.71,0,0,0,41,222.48Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.38,213.48a2.51,2.51,0,0,1,1.15-.38,1.68,1.68,0,0,1,.91.19,1.49,1.49,0,0,1,.6.62,2.06,2.06,0,0,1,.23.89.68.68,0,0,1-.07.27.39.39,0,0,1-.14.18l-1.29.74a.37.37,0,0,1-.22.07.51.51,0,0,1-.17-.08l-.09-.1a.52.52,0,0,0-.19-.12.54.54,0,0,0-.29,0,1,1,0,0,0-.43.16,3.27,3.27,0,0,0-.36.25,2.16,2.16,0,0,0-.31.29,1.62,1.62,0,0,0-.21.36,1.07,1.07,0,0,0-.09.43.41.41,0,0,0,.1.32.39.39,0,0,0,.31.1,3.22,3.22,0,0,0,.59-.08l.9-.24a2.78,2.78,0,0,1,.94-.12,1.17,1.17,0,0,1,.68.25,1.42,1.42,0,0,1,.4.68,4.12,4.12,0,0,1,.13,1.16,5.09,5.09,0,0,1-.22,1.5,6.1,6.1,0,0,1-.64,1.4,6.3,6.3,0,0,1-1,1.22,6,6,0,0,1-1.21.92,3,3,0,0,1-1.22.44,1.61,1.61,0,0,1-1-.18,1.42,1.42,0,0,1-.62-.64,2.14,2.14,0,0,1-.24-1,.66.66,0,0,1,.06-.27.4.4,0,0,1,.15-.18l1.28-.74a.45.45,0,0,1,.22-.08.43.43,0,0,1,.16.07l.11.13a1,1,0,0,0,.22.16.78.78,0,0,0,.33.06,1.32,1.32,0,0,0,.5-.18,4.38,4.38,0,0,0,.87-.68,1.2,1.2,0,0,0,.34-.83.33.33,0,0,0-.12-.3.58.58,0,0,0-.39-.06,3.52,3.52,0,0,0-.65.12c-.27.08-.58.16-.94.24a1.42,1.42,0,0,1-1.48-.25,2.72,2.72,0,0,1-.46-1.81,5.06,5.06,0,0,1,.19-1.36,6.57,6.57,0,0,1,.55-1.36,7.07,7.07,0,0,1,.88-1.23A5.16,5.16,0,0,1,49.38,213.48Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.49,209.38a2.66,2.66,0,0,1,1.15-.39,1.75,1.75,0,0,1,.91.19,1.52,1.52,0,0,1,.6.63,1.89,1.89,0,0,1,.23.88.54.54,0,0,1-.07.27.39.39,0,0,1-.14.18l-1.29.74a.31.31,0,0,1-.22.07.37.37,0,0,1-.17-.08l-.09-.1a.5.5,0,0,0-.18-.11.69.69,0,0,0-.3,0,1.09,1.09,0,0,0-.43.17,2.82,2.82,0,0,0-.36.24,1.7,1.7,0,0,0-.3.3,1.45,1.45,0,0,0-.22.36,1,1,0,0,0-.08.42.48.48,0,0,0,.09.33.44.44,0,0,0,.31.1,2.57,2.57,0,0,0,.59-.09l.9-.24a3.47,3.47,0,0,1,.95-.12,1.11,1.11,0,0,1,.67.26,1.38,1.38,0,0,1,.4.67,4.12,4.12,0,0,1,.13,1.16,5.16,5.16,0,0,1-.22,1.51,5.88,5.88,0,0,1-.64,1.4,6.23,6.23,0,0,1-1,1.21,6,6,0,0,1-1.21.93,2.94,2.94,0,0,1-1.22.43,1.71,1.71,0,0,1-1-.17,1.56,1.56,0,0,1-.62-.65,2.24,2.24,0,0,1-.24-1,.54.54,0,0,1,.07-.27.39.39,0,0,1,.14-.18l1.29-.74a.36.36,0,0,1,.21-.07.28.28,0,0,1,.16.07l.12.12a.58.58,0,0,0,.21.16A.58.58,0,0,0,56,218a1.27,1.27,0,0,0,.5-.18,3.6,3.6,0,0,0,.87-.68,1.19,1.19,0,0,0,.35-.83.33.33,0,0,0-.13-.3.69.69,0,0,0-.38-.06,3.76,3.76,0,0,0-.66.13l-.94.24a1.42,1.42,0,0,1-1.47-.26,2.64,2.64,0,0,1-.47-1.81,5,5,0,0,1,.19-1.35,6.18,6.18,0,0,1,.56-1.37,5.82,5.82,0,0,1,.88-1.22A4.44,4.44,0,0,1,56.49,209.38Z",
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--text-box--inject-126"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-126",
    d: "M55.16,231.51,24.4,249.24a1.66,1.66,0,0,0-.77,1.32v17.17c0,.49.34.69.77.44l30.76-17.72a1.68,1.68,0,0,0,.77-1.32V232C55.93,231.47,55.58,231.27,55.16,231.51Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--box--inject-126"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-126"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speach-bubble--inject-126"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.37,233.46,29.61,251.18a1.66,1.66,0,0,0-.77,1.32v17.18a1.68,1.68,0,0,0,.77,1.31l3,1.73a1.72,1.72,0,0,0,1.53,0L64.94,255a1.72,1.72,0,0,0,.77-1.33V236.49a1.65,1.65,0,0,0-.77-1.31l-3-1.73A1.68,1.68,0,0,0,60.37,233.46Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.37,233.46,29.61,251.18a1.66,1.66,0,0,0-.77,1.32v17.18a1.68,1.68,0,0,0,.77,1.31l3,1.73a1.72,1.72,0,0,0,1.53,0L64.94,255a1.72,1.72,0,0,0,.77-1.33V236.49a1.65,1.65,0,0,0-.77-1.31l-3-1.73A1.68,1.68,0,0,0,60.37,233.46Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.7,236.35c-.06-.38-.38-.52-.76-.3L34.18,253.77a1.65,1.65,0,0,0-.54.57l-4.56-2.62a1.53,1.53,0,0,1,.53-.54l30.76-17.73a1.72,1.72,0,0,1,1.53,0l3,1.72A1.74,1.74,0,0,1,65.7,236.35Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.94,236.05,34.18,253.77a1.72,1.72,0,0,0-.77,1.32v17.18c0,.49.35.68.77.44L64.94,255a1.72,1.72,0,0,0,.77-1.33V236.49C65.71,236,65.36,235.81,64.94,236.05Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.94,236.05,34.18,253.77a1.72,1.72,0,0,0-.77,1.32v17.18c0,.49.35.68.77.44L64.94,255a1.72,1.72,0,0,0,.77-1.33V236.49C65.71,236,65.36,235.81,64.94,236.05Z"
  })))))), /*#__PURE__*/React.createElement("path", {
    d: "M41.16,254.07a.14.14,0,0,1,.19,0,.33.33,0,0,1,.08.24v9.77a.88.88,0,0,1-.08.34.42.42,0,0,1-.19.22l-1.28.75a.15.15,0,0,1-.19,0,.33.33,0,0,1-.08-.24v-3.7l-2.18,1.26v3.7a.8.8,0,0,1-.08.33.44.44,0,0,1-.18.23l-1.29.75a.15.15,0,0,1-.19,0,.34.34,0,0,1-.08-.25v-9.77a.8.8,0,0,1,.08-.33.5.5,0,0,1,.19-.23l1.29-.74a.13.13,0,0,1,.18,0,.33.33,0,0,1,.08.24v3.65L39.61,259v-3.65a.8.8,0,0,1,.08-.33.45.45,0,0,1,.19-.23Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.35,249.92a.14.14,0,0,1,.18,0,.36.36,0,0,1,.08.25v1.6a.8.8,0,0,1-.08.33.49.49,0,0,1-.18.23l-1.73,1v7.76a.8.8,0,0,1-.08.33.5.5,0,0,1-.19.23l-1.29.74a.14.14,0,0,1-.18,0,.29.29,0,0,1-.08-.24v-7.76l-1.73,1a.15.15,0,0,1-.19,0,.33.33,0,0,1-.07-.24v-1.6a.86.86,0,0,1,.07-.34.53.53,0,0,1,.19-.22Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.86,255.23a.52.52,0,0,1-.13-.17l-.93-2v5a.73.73,0,0,1-.08.34.46.46,0,0,1-.18.22l-1.29.75a.14.14,0,0,1-.19,0,.33.33,0,0,1-.07-.24v-9.77a.78.78,0,0,1,.07-.33.57.57,0,0,1,.19-.23l1.14-.66c.13-.07.23-.07.29,0a.69.69,0,0,1,.13.17l1.59,3.27,1.6-5.11.12-.32a.69.69,0,0,1,.3-.33l1.14-.66a.14.14,0,0,1,.18,0,.29.29,0,0,1,.08.24v9.78a.67.67,0,0,1-.08.33.54.54,0,0,1-.18.23l-1.29.74a.15.15,0,0,1-.19,0,.34.34,0,0,1-.07-.25v-5l-.93,3a2,2,0,0,1-.13.32.54.54,0,0,1-.23.26l-.63.37C53,255.28,52.91,255.29,52.86,255.23Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.5,249.34a.14.14,0,0,1,.19,0,.33.33,0,0,1,.08.24v1.61a.8.8,0,0,1-.08.33.49.49,0,0,1-.19.23L59,254.38c-.08,0-.14,0-.19,0a.33.33,0,0,1-.08-.24v-9.77a.84.84,0,0,1,.08-.34.49.49,0,0,1,.19-.23l1.28-.74a.14.14,0,0,1,.19,0,.33.33,0,0,1,.08.24v7.76Z",
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--text-box--inject-126"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-126",
    d: "M55.16,267.2,24.4,284.93a1.66,1.66,0,0,0-.77,1.32v17.17c0,.49.34.69.77.44l30.76-17.72a1.68,1.68,0,0,0,.77-1.32V267.65C55.93,267.16,55.58,267,55.16,267.2Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--box--inject-126"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-126"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speach-bubble--inject-126"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.37,269.15,29.61,286.87a1.67,1.67,0,0,0-.77,1.32v17.18a1.68,1.68,0,0,0,.77,1.31l3,1.73a1.72,1.72,0,0,0,1.53,0l30.76-17.72a1.72,1.72,0,0,0,.77-1.33V272.18a1.65,1.65,0,0,0-.77-1.31l-3-1.73A1.68,1.68,0,0,0,60.37,269.15Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.37,269.15,29.61,286.87a1.67,1.67,0,0,0-.77,1.32v17.18a1.68,1.68,0,0,0,.77,1.31l3,1.73a1.72,1.72,0,0,0,1.53,0l30.76-17.72a1.72,1.72,0,0,0,.77-1.33V272.18a1.65,1.65,0,0,0-.77-1.31l-3-1.73A1.68,1.68,0,0,0,60.37,269.15Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.7,272c-.06-.38-.38-.52-.76-.3L34.18,289.46a1.65,1.65,0,0,0-.54.57l-4.56-2.62a1.53,1.53,0,0,1,.53-.54l30.76-17.72a1.68,1.68,0,0,1,1.53,0l3,1.72A1.74,1.74,0,0,1,65.7,272Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.94,271.74,34.18,289.46a1.72,1.72,0,0,0-.77,1.33V308c0,.49.35.68.77.44l30.76-17.72a1.72,1.72,0,0,0,.77-1.33V272.18C65.71,271.69,65.36,271.5,64.94,271.74Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64.94,271.74,34.18,289.46a1.72,1.72,0,0,0-.77,1.33V308c0,.49.35.68.77.44l30.76-17.72a1.72,1.72,0,0,0,.77-1.33V272.18C65.71,271.69,65.36,271.5,64.94,271.74Z"
  })))))), /*#__PURE__*/React.createElement("path", {
    d: "M41.62,293.52c0,.13,0,.32,0,.55v1.45c0,.23,0,.41,0,.54a3.88,3.88,0,0,0,.08.62,1,1,0,0,0,.22.43.56.56,0,0,0,.37.17,1,1,0,0,0,.56-.18,1.9,1.9,0,0,0,.55-.44,2.33,2.33,0,0,0,.36-.5,2.75,2.75,0,0,0,.21-.51,3.24,3.24,0,0,0,.11-.45,1.79,1.79,0,0,1,.11-.41.56.56,0,0,1,.23-.23l1.28-.74a.12.12,0,0,1,.15,0,.24.24,0,0,1,.07.2,6,6,0,0,1-.25,1.59,6.68,6.68,0,0,1-.65,1.56,7.18,7.18,0,0,1-1,1.35,4.87,4.87,0,0,1-1.21,1,2.48,2.48,0,0,1-1.26.4,1.45,1.45,0,0,1-1-.33,2.2,2.2,0,0,1-.6-1,5.16,5.16,0,0,1-.24-1.44c0-.41,0-.85,0-1.32s0-.94,0-1.38a7.89,7.89,0,0,1,.23-1.71,8.21,8.21,0,0,1,.61-1.66,6.59,6.59,0,0,1,1-1.43,4.68,4.68,0,0,1,1.26-1.06,2.78,2.78,0,0,1,1.21-.4,1.53,1.53,0,0,1,1,.24,1.64,1.64,0,0,1,.65.8,3.4,3.4,0,0,1,.25,1.31.54.54,0,0,1-.07.27.42.42,0,0,1-.15.19l-1.28.74c-.12.07-.19.08-.23,0a.58.58,0,0,1-.11-.27,1.42,1.42,0,0,0-.11-.33.71.71,0,0,0-.21-.27.64.64,0,0,0-.36-.09,1.37,1.37,0,0,0-.55.2,2,2,0,0,0-.56.47,2.62,2.62,0,0,0-.37.6,3.18,3.18,0,0,0-.22.68A5.87,5.87,0,0,0,41.62,293.52Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.63,291.5V294a.78.78,0,0,1-.07.33.57.57,0,0,1-.19.23l-1.24.72a.15.15,0,0,1-.19,0,.33.33,0,0,1-.07-.24v-2.5l-1.53.88a.13.13,0,0,1-.18,0,.29.29,0,0,1-.08-.24v-1.53a.67.67,0,0,1,.08-.33.49.49,0,0,1,.18-.23l1.53-.88v-2.5a.78.78,0,0,1,.07-.33.65.65,0,0,1,.19-.23l1.24-.71a.15.15,0,0,1,.19,0,.33.33,0,0,1,.07.24v2.5l1.52-.87a.13.13,0,0,1,.18,0,.29.29,0,0,1,.08.24v1.53a.67.67,0,0,1-.08.33.49.49,0,0,1-.18.23Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.15,287.74v2.5a.8.8,0,0,1-.08.33.5.5,0,0,1-.19.23l-1.24.72a.14.14,0,0,1-.18,0,.33.33,0,0,1-.08-.24v-2.5l-1.52.88a.14.14,0,0,1-.19,0,.33.33,0,0,1-.08-.24v-1.53a.8.8,0,0,1,.08-.33.45.45,0,0,1,.19-.23l1.52-.88v-2.5a.8.8,0,0,1,.08-.33.49.49,0,0,1,.18-.23l1.24-.71a.15.15,0,0,1,.19,0,.33.33,0,0,1,.08.24v2.5l1.51-.87a.14.14,0,0,1,.19,0,.33.33,0,0,1,.08.24v1.53a.8.8,0,0,1-.08.33.5.5,0,0,1-.19.23Z",
    style: {
      fill: "#f0f0f0"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--window-2--inject-126"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-126"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-126"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117,410.06a4.43,4.43,0,0,1-2,.6,5,5,0,0,1-2.9-.51,5.4,5.4,0,0,1-2.36-4.27V256.49l4.73,2.73V408.6c0,1.14.58,1.8,1.4,1.8A2.57,2.57,0,0,0,117,410.06Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.1,265a5.58,5.58,0,0,1-2.52,4.37L117,410.06c-1.39.8-2.52.15-2.52-1.46V245l6.94-4c1.39-.8,3.42-12.19,4.81-13l60.67-35c1.4-.8,4.37,7.71,5.76,6.91L363.1,101.4V265Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.1,103.13V265a4.59,4.59,0,0,1-2,3.5L116.49,409.19a1.29,1.29,0,0,1-.62.21c-.34,0-.4-.5-.4-.8v-163l6.44-3.72c1-.55,1.54-2.38,2.86-7.07.6-2.15,1.51-5.37,2-6L187.07,194a19.9,19.9,0,0,1,1.84,2.9c1.45,2.55,2.32,4,3.54,4a1.47,1.47,0,0,0,.7-.19l169-97.59m1-1.73L192.65,199.86a.49.49,0,0,1-.2,0c-1.39,0-4-7-5.36-7a.49.49,0,0,0-.2,0l-60.67,35c-1.39.8-3.42,12.19-4.81,13l-6.94,4V408.6c0,1.14.57,1.8,1.4,1.8a2.28,2.28,0,0,0,1.12-.34L360.58,269.38A5.58,5.58,0,0,0,363.1,265V101.4Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.11,252.74a5.38,5.38,0,0,1-2.37-4.27V234.65a5.59,5.59,0,0,1,2.52-4.37L355.86,89.6a4.73,4.73,0,0,1,7.24,4.19v13.82a5.5,5.5,0,0,1-2.52,4.36L117,252.65A5.36,5.36,0,0,1,112.11,252.74Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.08,93.38c-.18-1.31-1.24-1.79-2.5-1L117,233a5.24,5.24,0,0,0-1.78,1.89l-4.73-2.74a5.29,5.29,0,0,1,1.78-1.88L355.86,89.6a4.71,4.71,0,0,1,7.22,3.78Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.21,234.9a5,5,0,0,0-.74,2.48v21.84l-4.73-2.73V234.65c0-.11,0-.2,0-.31a4,4,0,0,1,.1-.62,5.81,5.81,0,0,1,.63-1.56Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.1,93.78v7.62L192.65,199.86,121.41,241l-6.94,4v-7.61A5.57,5.57,0,0,1,117,233L360.58,92.33C362,91.52,363.1,92.18,363.1,93.78Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.79,98c1-.57,1.79-.1,1.79,1a4,4,0,0,1-1.79,3.1c-1,.58-1.79.11-1.79-1A4,4,0,0,1,356.79,98Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.34,101.76c1-.58,1.79-.11,1.79,1a4,4,0,0,1-1.79,3.11c-1,.57-1.79.1-1.79-1A4,4,0,0,1,350.34,101.76Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.88,105.48c1-.58,1.8-.11,1.8,1a4,4,0,0,1-1.8,3.11c-1,.57-1.79.1-1.79-1A4,4,0,0,1,343.88,105.48Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.66,242c.85-.5,1.13-1.25,1.54-2.69l.94-3.24c.34-1.3.7-2.19,1.55-2.68L161,211.84c.86-.5,1.53-.55,2.18.53l1.13,2.09c.49.84.73,1.33,1.58.84l29-16.72L363.1,101.4v14.23L114.47,259.22V245l5.19-3",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "114.47 244.99 114.47 259.22 109.74 256.49 109.74 242.26 114.47 244.99",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "114.47 244.99 114.47 259.22 109.74 256.49 109.74 242.26 114.47 244.99",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.3,246.23l-2.91,1.68,1.11-2.14a.51.51,0,0,0,0-.52c-.08-.1-.23,0-.33.16l-1.58,3h0a1.17,1.17,0,0,0,0,.11s0,0,0,0a.77.77,0,0,0,0,.15.52.52,0,0,0,0,.14v0s0,.05,0,.06h0l1.58,1.21a.12.12,0,0,0,.16,0,.4.4,0,0,0,.17-.22.46.46,0,0,0,0-.5l-1.11-.85L123.3,247a.63.63,0,0,0,.23-.5C123.53,246.25,123.43,246.15,123.3,246.23Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.73,244.82l2.91-1.68-1.11-.85a.5.5,0,0,1,0-.5c.09-.2.24-.3.33-.22l1.58,1.21h0l0,.06a0,0,0,0,0,0,0,.59.59,0,0,1,0,.14.77.77,0,0,1,0,.15s0,0,0,0,0,.08,0,.11v0l-1.58,3a.4.4,0,0,1-.15.18.13.13,0,0,1-.18,0,.56.56,0,0,1,0-.52l1.11-2.14-2.91,1.68c-.13.08-.23,0-.23-.22A.63.63,0,0,1,125.73,244.82Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.28,236.44c0-.18-.17-.15-.24,0l-.4,1c-.68-.07-1.51.59-2.06,1.77-.72,1.53-.72,3.33,0,4a1,1,0,0,0,1.3.07,3.5,3.5,0,0,0,1.31-1.58c.09-.2.09-.43,0-.51s-.24,0-.33.19c-.54,1.14-1.41,1.64-2,1.13s-.54-1.87,0-3c.38-.81.93-1.29,1.41-1.32l-.3.73c-.08.19,0,.37.12.29l1.19-.77a.42.42,0,0,0,.13-.33Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.46,215.65l.89-1.87a.61.61,0,0,0,0-.59c-.11-.1-.28,0-.38.22l-.89,1.88-.89-.85c-.1-.1-.27,0-.37.22a.54.54,0,0,0,0,.58l.88.85-.88,1.88a.54.54,0,0,0,0,.58.14.14,0,0,0,.19,0,.56.56,0,0,0,.18-.23l.89-1.88.89.85a.15.15,0,0,0,.19,0,.5.5,0,0,0,.19-.23.59.59,0,0,0,0-.58Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.29,238.7v-3.38a3.7,3.7,0,0,1,1.67-2.9l209-120.76c.93-.53,1.67-.1,1.67,1V116a3.67,3.67,0,0,1-1.67,2.9L142,239.67C141,240.2,140.29,239.77,140.29,238.7Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.65,119.17a.33.33,0,0,1-.15,0,.45.45,0,0,1-.26-.51l.17-1.37-.65-.46a.47.47,0,0,1-.17-.38.72.72,0,0,1,.27-.58l1-.76a.56.56,0,0,0,0-.08l.44-1.44a.6.6,0,0,1,.49-.46.37.37,0,0,1,.39.23l.37.78.83-.32a.4.4,0,0,1,.44.1.61.61,0,0,1,0,.68l-.71,1.33a.2.2,0,0,0,0,.09l.17,1.2a.81.81,0,0,1-.21.61.49.49,0,0,1-.39.15l-.81-.1L349,119A.53.53,0,0,1,348.65,119.17Zm-.48-2.79.65.46a.49.49,0,0,1,.17.46l-.11.92.58-.75a.48.48,0,0,1,.44-.21l.8.1a.19.19,0,0,0,0-.09l-.17-1.21a.86.86,0,0,1,.09-.43l.62-1.17-.64.25a.4.4,0,0,1-.51-.2l-.29-.62-.39,1.28a.73.73,0,0,1-.24.37l-1,.76A.12.12,0,0,0,348.17,116.38Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M354.57,111.25a.58.58,0,0,1-.29-1.08l4.71-2.72a.58.58,0,0,1,.79.21.58.58,0,0,1-.21.79l-4.71,2.72A.6.6,0,0,1,354.57,111.25Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M354.57,114a.58.58,0,0,1-.29-1.08l4.71-2.72a.58.58,0,0,1,.79.21.58.58,0,0,1-.21.79l-4.71,2.72A.6.6,0,0,1,354.57,114Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M354.57,116.69a.58.58,0,0,1-.29-1.08l4.71-2.72a.58.58,0,0,1,.79.21.58.58,0,0,1-.21.79l-4.71,2.72A.6.6,0,0,1,354.57,116.69Z"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M157.94,244.2l.57-5a.9.9,0,0,1,.11-.35.65.65,0,0,1,.17-.19L160,238a.12.12,0,0,1,.14,0,.24.24,0,0,1,.06.18.57.57,0,0,1,0,.12L159,247.7a1.24,1.24,0,0,1-.14.44.86.86,0,0,1-.31.34l-.75.43a.24.24,0,0,1-.29,0,.53.53,0,0,1-.16-.27l-.67-2.74-.68,3.52a2.37,2.37,0,0,1-.15.45.81.81,0,0,1-.3.33l-.75.44a.27.27,0,0,1-.3,0,.4.4,0,0,1-.14-.28l-1.17-8.09v-.1a.7.7,0,0,1,.05-.25.41.41,0,0,1,.14-.17l1.18-.68a.18.18,0,0,1,.17,0c.06,0,.09.1.11.23l.58,4.35.53-2.82a1.9,1.9,0,0,1,.08-.29.46.46,0,0,1,.23-.28l.84-.49c.11-.06.18-.06.23,0a2.05,2.05,0,0,1,.08.2Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.56,242.22a.13.13,0,0,1,.17,0,.29.29,0,0,1,.07.22v1.47a.73.73,0,0,1-.07.31.46.46,0,0,1-.17.21l-4.27,2.46a.14.14,0,0,1-.17,0,.35.35,0,0,1-.07-.23v-8.95a.82.82,0,0,1,.07-.3.54.54,0,0,1,.17-.21l4.2-2.42a.12.12,0,0,1,.17,0,.29.29,0,0,1,.07.22v1.47a.73.73,0,0,1-.07.31.54.54,0,0,1-.17.21l-2.77,1.6v1.49l2.57-1.48a.12.12,0,0,1,.17,0,.28.28,0,0,1,.07.22v1.47a.66.66,0,0,1-.07.3.41.41,0,0,1-.17.21l-2.57,1.49v1.55Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.08,243.56a.12.12,0,0,1-.17,0,.26.26,0,0,1-.07-.22v-8.95a.66.66,0,0,1,.07-.3.46.46,0,0,1,.17-.21l2.9-1.67a1.94,1.94,0,0,1,1-.34,1,1,0,0,1,.66.29,1.57,1.57,0,0,1,.35.72,3.85,3.85,0,0,1,.11,1,4.58,4.58,0,0,1-.2,1.33,4.26,4.26,0,0,1-.16.44l-.14.28a1,1,0,0,1,.49.58,3.71,3.71,0,0,1,.14,1.11,6.8,6.8,0,0,1-.11,1.17,4.94,4.94,0,0,1-.36,1.17,4.54,4.54,0,0,1-.64,1.05,3.7,3.7,0,0,1-1,.82Zm3.37-8.71a.68.68,0,0,0-.14-.49c-.1-.09-.23-.08-.41,0l-1.4.81v1.58l1.4-.81a1.05,1.05,0,0,0,.41-.45A1.59,1.59,0,0,0,170.45,234.85Zm-1.95,5.74,1.49-.86a1.1,1.1,0,0,0,.43-.49,1.56,1.56,0,0,0,.16-.7.66.66,0,0,0-.16-.51.36.36,0,0,0-.43,0l-1.49.86Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.83,228.7a1.83,1.83,0,0,1,1-.3,1.31,1.31,0,0,1,1.16.8,1.73,1.73,0,0,1,.16.69.43.43,0,0,1-.05.24.32.32,0,0,1-.15.17l-.36.22c-.07,0-.12,0-.16,0s-.08-.07-.12-.18a1.51,1.51,0,0,0-.15-.26.78.78,0,0,0-.28-.26.94.94,0,0,0-.43-.1,1.27,1.27,0,0,0-.58.19,2.74,2.74,0,0,0-.49.37,2.5,2.5,0,0,0-.4.51,2.2,2.2,0,0,0-.29.62,2,2,0,0,0-.11.69,1.17,1.17,0,0,0,.1.55.57.57,0,0,0,.34.26,1.73,1.73,0,0,0,.58,0l.85-.12a3.4,3.4,0,0,1,.87,0,1.13,1.13,0,0,1,.58.23,1.05,1.05,0,0,1,.33.53,3,3,0,0,1,.1.86,4.89,4.89,0,0,1-.17,1.25,5.47,5.47,0,0,1-.49,1.17,5.18,5.18,0,0,1-.76,1,4.42,4.42,0,0,1-1,.78,2.26,2.26,0,0,1-1,.32,1.3,1.3,0,0,1-1.26-.72,1.8,1.8,0,0,1-.19-.79.61.61,0,0,1,.06-.25.4.4,0,0,1,.14-.17l.37-.21a.24.24,0,0,1,.15,0s.09.08.12.18a1.73,1.73,0,0,0,.17.33.83.83,0,0,0,.3.26,1,1,0,0,0,.46.07,1.51,1.51,0,0,0,.64-.23,2.82,2.82,0,0,0,.6-.46,3.62,3.62,0,0,0,.5-.6,3.23,3.23,0,0,0,.34-.7,2.28,2.28,0,0,0,.13-.72.83.83,0,0,0-.15-.54.66.66,0,0,0-.41-.22,1.82,1.82,0,0,0-.66,0c-.26,0-.56.08-.89.14a1.78,1.78,0,0,1-.76,0,1.07,1.07,0,0,1-.52-.29,1.37,1.37,0,0,1-.28-.58,3.26,3.26,0,0,1-.09-.82,4.56,4.56,0,0,1,.14-1.07,4.76,4.76,0,0,1,.4-1.09,4.66,4.66,0,0,1,.67-1A3.52,3.52,0,0,1,175.83,228.7Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.7,236.3a.13.13,0,0,1-.17,0,.29.29,0,0,1-.08-.22v-8.95a.68.68,0,0,1,.08-.31.41.41,0,0,1,.17-.21l.36-.21a.14.14,0,0,1,.18,0,.29.29,0,0,1,.07.22v8.95a.7.7,0,0,1-.07.31.48.48,0,0,1-.18.21Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.75,223.1c.07,0,.13,0,.17,0a.28.28,0,0,1,.08.22v.5a.67.67,0,0,1-.08.3.41.41,0,0,1-.17.21l-1.68,1v8.08a.73.73,0,0,1-.07.31.54.54,0,0,1-.17.21l-.37.21a.13.13,0,0,1-.17,0,.29.29,0,0,1-.07-.22v-8.08l-1.69,1a.14.14,0,0,1-.17,0,.3.3,0,0,1-.07-.23v-.49a.67.67,0,0,1,.07-.31.54.54,0,0,1,.17-.21Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.86,228.61a.14.14,0,0,1,.17,0,.34.34,0,0,1,.07.22v.5a.87.87,0,0,1-.07.31.54.54,0,0,1-.17.21l-3.64,2.1a.12.12,0,0,1-.17,0,.28.28,0,0,1-.07-.22v-8.95a.66.66,0,0,1,.07-.3.46.46,0,0,1,.17-.21l3.57-2.06a.14.14,0,0,1,.17,0,.34.34,0,0,1,.07.22v.5a.87.87,0,0,1-.07.31.54.54,0,0,1-.17.21l-3,1.7v2.93l2.76-1.59a.12.12,0,0,1,.17,0,.32.32,0,0,1,.07.22v.5a.82.82,0,0,1-.07.3.54.54,0,0,1-.17.21l-2.76,1.59v3Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.39,190.68l-15,8.69a2.52,2.52,0,0,0-1.18,2c0,.71.52,1,1.18.6l15-8.7a2.52,2.52,0,0,0,1.18-2C248.57,190.57,248,190.3,247.39,190.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.74,177.79l-11.83,6.83a2.54,2.54,0,0,0-1.18,2c0,.7.53,1,1.18.6l11.83-6.83a2.55,2.55,0,0,0,1.18-2C270.92,177.68,270.39,177.41,269.74,177.79Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.08,166.06l-9.82,5.67a2.54,2.54,0,0,0-1.18,2c0,.71.53,1,1.18.6l9.82-5.67a2.54,2.54,0,0,0,1.19-2C291.27,166,290.74,165.68,290.08,166.06Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.64,151.31l-15,8.69a2.55,2.55,0,0,0-1.18,2c0,.71.53,1,1.18.6l15-8.7a2.52,2.52,0,0,0,1.18-2C316.82,151.2,316.29,150.93,315.64,151.31Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "114.47 348.14 363.1 204.59 363.1 134.28 114.47 277.82 114.47 348.14",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.61,266.68,192,243.39c1.19-.69,2.16-.13,2.16,1.25l0,.4a4.81,4.81,0,0,1-2.17,3.75l-40.32,23.28c-1.2.69-2.17.13-2.17-1.25v-1.39C149.44,268.05,150.41,267.38,151.61,266.68Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.61,276.07l26.3-15.19c1.19-.69,2.16-.13,2.15,1.25v.4a4.83,4.83,0,0,1-2.17,3.75l-26.27,15.17c-1.2.69-2.17.13-2.17-1.25v-1.38C149.44,277.43,150.41,276.76,151.61,276.07Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.61,276.07l26.3-15.19c1.19-.69,2.16-.13,2.15,1.25v.4a4.83,4.83,0,0,1-2.17,3.75l-26.27,15.17c-1.2.69-2.17.13-2.17-1.25v-1.38C149.44,277.43,150.41,276.76,151.61,276.07Z",
    style: {
      fill: "#fff",
      opacity: 0.55
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.44,293.11a.37.37,0,0,1-.32-.19.36.36,0,0,1,.13-.51l77.18-44.56a.36.36,0,0,1,.51.13.38.38,0,0,1-.13.52l-77.18,44.56A.45.45,0,0,1,149.44,293.11Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.44,297.8a.37.37,0,0,1-.32-.19.36.36,0,0,1,.13-.51l28.44-16.42a.37.37,0,0,1,.51.14.37.37,0,0,1-.14.51l-28.43,16.42A.45.45,0,0,1,149.44,297.8Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.94,279a.39.39,0,0,1-.33-.19.37.37,0,0,1,.14-.51L198,269a.38.38,0,0,1,.51.14.37.37,0,0,1-.14.51L182.13,279A.45.45,0,0,1,181.94,279Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.2,267.34a.39.39,0,0,1-.33-.19.37.37,0,0,1,.14-.51l24.42-14.1a.38.38,0,0,1,.38.65l-24.42,14.1A.45.45,0,0,1,202.2,267.34Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.44,302.49a.37.37,0,0,1-.32-.19.36.36,0,0,1,.13-.51l12.19-7a.38.38,0,0,1,.51.14.37.37,0,0,1-.14.51l-12.18,7A.41.41,0,0,1,149.44,302.49Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.69,293.11a.39.39,0,0,1-.33-.19.37.37,0,0,1,.14-.51L193.94,276a.38.38,0,0,1,.51.14.37.37,0,0,1-.14.51l-28.43,16.42A.45.45,0,0,1,165.69,293.11Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.19,274.35a.39.39,0,0,1-.33-.19.37.37,0,0,1,.14-.51l28.43-16.42a.37.37,0,0,1,.51.14.36.36,0,0,1-.13.51L198.37,274.3A.41.41,0,0,1,198.19,274.35Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.44,307.18a.37.37,0,0,1-.32-.19.36.36,0,0,1,.13-.51l77.18-44.56a.37.37,0,0,1,.51.14.36.36,0,0,1-.13.51l-77.18,44.56A.45.45,0,0,1,149.44,307.18Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.44,311.87a.37.37,0,0,1-.32-.19.36.36,0,0,1,.13-.51l28.44-16.42a.37.37,0,0,1,.51.14.37.37,0,0,1-.14.51l-28.43,16.42A.45.45,0,0,1,149.44,311.87Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.94,293.11a.39.39,0,0,1-.33-.19.37.37,0,0,1,.14-.51L198,283a.38.38,0,0,1,.51.13.39.39,0,0,1-.14.52l-16.24,9.38A.45.45,0,0,1,181.94,293.11Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.2,281.41a.39.39,0,0,1-.33-.19.37.37,0,0,1,.14-.51l24.42-14.1a.37.37,0,0,1,.51.14.36.36,0,0,1-.13.51l-24.42,14.1A.45.45,0,0,1,202.2,281.41Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.44,316.56a.37.37,0,0,1-.32-.19.36.36,0,0,1,.13-.51l12.19-7a.38.38,0,0,1,.51.14.37.37,0,0,1-.14.51l-12.18,7A.41.41,0,0,1,149.44,316.56Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.69,307.18a.39.39,0,0,1-.33-.19.37.37,0,0,1,.14-.51l28.44-16.42a.37.37,0,0,1,.37.65l-28.43,16.42A.45.45,0,0,1,165.69,307.18Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.19,288.42a.39.39,0,0,1-.33-.19.37.37,0,0,1,.14-.51l28.43-16.42a.37.37,0,0,1,.51.14.36.36,0,0,1-.13.51l-28.44,16.42A.41.41,0,0,1,198.19,288.42Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Image--inject-126"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--dark-window--inject-126"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M329.5,161.28l2.75,1.58a2.31,2.31,0,0,0-1.79,0L274.72,195.7l-4.92,2.83L267.33,200c-.39.23-.86.48-1.18.7a5.08,5.08,0,0,0-1,.83,7.43,7.43,0,0,0-2.07,4.66s-.38,16.37-.56,46.66a2.28,2.28,0,0,0,.91,1.58l-2.81-1.61h0a2.52,2.52,0,0,1-1.08-2.34V204.51a8,8,0,0,1,3.61-6.25l63.73-36.75a2.52,2.52,0,0,1,2.59-.22Z",
    style: {
      fill: "#46C5FB",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.5,161.28l2.75,1.58a2.31,2.31,0,0,0-1.79,0L274.72,195.7l-4.92,2.83L267.33,200c-.39.23-.86.48-1.18.7a5.08,5.08,0,0,0-1,.83,7.43,7.43,0,0,0-2.07,4.66s-.38,16.37-.56,46.66a2.28,2.28,0,0,0,.91,1.58l-2.81-1.61h0a2.52,2.52,0,0,1-1.08-2.34V204.51a8,8,0,0,1,3.61-6.25l63.73-36.75a2.52,2.52,0,0,1,2.59-.22Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.43,165.27v45.9a8,8,0,0,1-3.61,6.25l-63.73,36.75c-1.77,1-3.25.4-3.55-1.37a3.26,3.26,0,0,0,.64-.29l63.74-36.75a8,8,0,0,0,3.6-6.25v-45.9a4.07,4.07,0,0,0-.06-.73C332.15,162.25,333.43,163.22,333.43,165.27Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.46,162.88l-55.74,32.83-4.92,2.83L267.33,200c-.39.24-.86.49-1.18.7a6.36,6.36,0,0,0-1,.83,7.45,7.45,0,0,0-2.07,4.66s-.38,16.37-.57,46.66c-.18-30.29,0-46.67,0-46.67.07-2.13.34-3.34,1.71-4.85a7.74,7.74,0,0,1,1.19-1c.46-.31.83-.49,1.25-.75l2.46-1.42,4.91-2.85Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.46,162.88,274.72,195.7l-4.93,2.83L267.33,200c-.39.23-.86.48-1.18.7a5.08,5.08,0,0,0-1,.83,7.43,7.43,0,0,0-2.07,4.66s-.38,16.37-.57,46.66a3.55,3.55,0,0,0,.64-.29l63.74-36.75a8,8,0,0,0,3.6-6.25v-45.9A4.07,4.07,0,0,0,330.46,162.88Z",
    style: {
      fill: "#46C5FB",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M274.31,241.85h-.21a.19.19,0,0,1-.16-.22.19.19,0,0,1,.22-.17,1.67,1.67,0,0,0,1-.26l.69-.39a.19.19,0,1,1,.19.34l-.68.39A2.09,2.09,0,0,1,274.31,241.85Zm-1.2-1.53a.19.19,0,0,1-.19-.18v-2a.2.2,0,1,1,.39,0v2A.21.21,0,0,1,273.11,240.32Zm4.58-.15a.2.2,0,0,1-.1-.37l1.73-1a.19.19,0,0,1,.27.07.2.2,0,0,1-.07.27l-1.73,1A.17.17,0,0,1,277.69,240.17Zm3.46-2a.21.21,0,0,1-.17-.1.2.2,0,0,1,.07-.27l1.73-1a.2.2,0,0,1,.27.08.19.19,0,0,1-.07.26l-1.73,1A.19.19,0,0,1,281.15,238.18Zm-8-1.86a.2.2,0,0,1-.19-.2v-2a.2.2,0,1,1,.39,0v2A.2.2,0,0,1,273.11,236.32Zm11.5-.14a.19.19,0,0,1-.17-.09.19.19,0,0,1,.07-.27l1.73-1a.2.2,0,0,1,.27.07.2.2,0,0,1-.07.27l-1.73,1A.18.18,0,0,1,284.61,236.18Zm3.45-2a.2.2,0,0,1-.17-.1.2.2,0,0,1,.08-.27l1.72-1a.19.19,0,0,1,.27.07.19.19,0,0,1-.07.27l-1.73,1A.17.17,0,0,1,288.06,234.19Zm-14.95-1.86a.2.2,0,0,1-.19-.2v-2a.2.2,0,1,1,.39,0v2A.2.2,0,0,1,273.11,232.33Zm18.41-.13a.21.21,0,0,1-.17-.1.2.2,0,0,1,.07-.27l1.73-1a.2.2,0,0,1,.2.35l-1.73,1A.17.17,0,0,1,291.52,232.2Zm3.46-2a.21.21,0,0,1-.17-.1.19.19,0,0,1,.07-.27l1.73-1a.21.21,0,0,1,.27.07.2.2,0,0,1-.07.27l-1.73,1A.19.19,0,0,1,295,230.21Zm-21.87-1.87a.2.2,0,0,1-.19-.2v-2a.2.2,0,1,1,.39,0v2A.2.2,0,0,1,273.11,228.34Zm25.33-.13a.19.19,0,0,1-.1-.36l1.73-1a.19.19,0,1,1,.19.34l-1.73,1Zm3.45-2a.2.2,0,0,1-.1-.37l1.73-1a.19.19,0,0,1,.27.07.2.2,0,0,1-.07.27l-1.73,1A.17.17,0,0,1,301.89,226.22Zm-28.78-1.87a.2.2,0,0,1-.19-.2v-2a.19.19,0,0,1,.19-.19.2.2,0,0,1,.2.19v2A.2.2,0,0,1,273.11,224.35Zm32.24-.12a.21.21,0,0,1-.17-.1.2.2,0,0,1,.07-.27l1.73-1a.2.2,0,0,1,.27.08.19.19,0,0,1-.07.26l-1.73,1A.19.19,0,0,1,305.35,224.23Zm3.46-2a.19.19,0,0,1-.17-.09.19.19,0,0,1,.07-.27l1.73-1a.21.21,0,0,1,.27.07.2.2,0,0,1-.07.27l-1.73,1A.18.18,0,0,1,308.81,222.23Zm-35.7-1.87a.19.19,0,0,1-.19-.2v-2a.19.19,0,0,1,.19-.19.2.2,0,0,1,.2.19v2A.2.2,0,0,1,273.11,220.36Zm39.16-.12a.2.2,0,0,1-.1-.37l1.73-1a.18.18,0,0,1,.26.07.19.19,0,0,1-.07.27l-1.73,1A.16.16,0,0,1,312.27,220.24Zm3.45-2a.2.2,0,0,1-.1-.37l1.73-1a.2.2,0,0,1,.2.35l-1.73,1A.17.17,0,0,1,315.72,218.25Zm-42.61-1.88a.19.19,0,0,1-.19-.2v-2a.19.19,0,0,1,.19-.19.2.2,0,0,1,.2.19v2A.2.2,0,0,1,273.11,216.37Zm46.07-.11a.21.21,0,0,1-.17-.1.19.19,0,0,1,.07-.27l.2-.12a4,4,0,0,0,1.21-1.15.2.2,0,0,1,.32.23,4.26,4.26,0,0,1-1.33,1.26l-.2.12A.19.19,0,0,1,319.18,216.26Zm2.28-3.13h0a.2.2,0,0,1-.15-.23,3.5,3.5,0,0,0,.08-.7v-1.25a.2.2,0,0,1,.2-.2.19.19,0,0,1,.19.2v1.25a3.56,3.56,0,0,1-.08.78A.2.2,0,0,1,321.46,213.13Zm-48.35-.75a.19.19,0,0,1-.19-.2v-2a.2.2,0,0,1,.4,0v2A.2.2,0,0,1,273.11,212.38Zm48.44-3.24a.2.2,0,0,1-.2-.19v-2a.2.2,0,0,1,.2-.2.19.19,0,0,1,.19.2v2A.19.19,0,0,1,321.55,209.14Zm-48.44-.75a.2.2,0,0,1-.2-.2v-2a.2.2,0,0,1,.4,0v2A.2.2,0,0,1,273.11,208.39Zm48.44-3.24a.2.2,0,0,1-.2-.19v-2a.2.2,0,0,1,.2-.2.19.19,0,0,1,.19.2v2A.19.19,0,0,1,321.55,205.15Zm-48.35-.75h0a.2.2,0,0,1-.15-.24,5.17,5.17,0,0,1,.85-1.87.19.19,0,1,1,.32.22,4.87,4.87,0,0,0-.79,1.74A.19.19,0,0,1,273.2,204.4Zm2.29-3.12a.2.2,0,0,1-.17-.1.2.2,0,0,1,.08-.27l1.72-1a.19.19,0,0,1,.27.07.19.19,0,0,1-.07.27l-1.73,1A.17.17,0,0,1,275.49,201.28Zm46.06-.12a.2.2,0,0,1-.2-.2v-2a.2.2,0,0,1,.2-.2.19.19,0,0,1,.19.2v2A.19.19,0,0,1,321.55,201.16ZM279,199.29a.21.21,0,0,1-.17-.1.2.2,0,0,1,.07-.27l1.73-1a.2.2,0,0,1,.27.08.19.19,0,0,1-.07.26l-1.73,1A.19.19,0,0,1,279,199.29Zm3.46-2a.19.19,0,0,1-.17-.09.19.19,0,0,1,.07-.27l1.73-1a.21.21,0,0,1,.27.07.2.2,0,0,1-.07.27l-1.73,1A.18.18,0,0,1,282.41,197.29Zm39.14-.12a.2.2,0,0,1-.2-.2v-2a.2.2,0,0,1,.2-.2.19.19,0,0,1,.19.2v2A.19.19,0,0,1,321.55,197.17Zm-35.68-1.87a.2.2,0,0,1-.1-.37l1.73-1a.2.2,0,0,1,.27.07.2.2,0,0,1-.08.27l-1.73,1Zm3.45-2a.2.2,0,0,1-.1-.37l1.73-1a.2.2,0,0,1,.2.35l-1.73,1A.17.17,0,0,1,289.32,193.31Zm32.23-.13a.2.2,0,0,1-.2-.2v-2a.2.2,0,0,1,.2-.2.19.19,0,0,1,.19.2v2A.19.19,0,0,1,321.55,193.18Zm-28.77-1.86a.21.21,0,0,1-.17-.1.2.2,0,0,1,.07-.27l1.73-1a.21.21,0,0,1,.27.07.2.2,0,0,1-.07.27l-1.73,1A.19.19,0,0,1,292.78,191.32Zm3.46-2a.19.19,0,0,1-.1-.36l1.73-1a.19.19,0,1,1,.19.34l-1.72,1Zm25.31-.13a.2.2,0,0,1-.2-.2v-2a.2.2,0,0,1,.2-.2.19.19,0,0,1,.19.2v2A.19.19,0,0,1,321.55,189.19Zm-21.86-1.86a.22.22,0,0,1-.17-.1.2.2,0,0,1,.08-.27l1.72-1a.19.19,0,0,1,.27.07.2.2,0,0,1-.07.27l-1.73,1A.17.17,0,0,1,299.69,187.33Zm3.46-2a.21.21,0,0,1-.17-.1.2.2,0,0,1,.07-.27l1.73-1a.2.2,0,0,1,.27.08.19.19,0,0,1-.07.26l-1.73,1A.19.19,0,0,1,303.15,185.34Zm18.4-.14a.2.2,0,0,1-.2-.2v-2a.2.2,0,0,1,.2-.2.19.19,0,0,1,.19.2v2A.19.19,0,0,1,321.55,185.2Zm-14.94-1.86a.2.2,0,0,1-.17-.09.19.19,0,0,1,.07-.27l1.73-1a.21.21,0,0,1,.27.07.2.2,0,0,1-.07.27l-1.73,1A.18.18,0,0,1,306.61,183.34Zm3.46-2a.18.18,0,0,1-.17-.1A.19.19,0,0,1,310,181l1.73-1a.19.19,0,0,1,.27.07.2.2,0,0,1-.08.27l-1.73,1A.16.16,0,0,1,310.07,181.35Zm11.48-.14a.2.2,0,0,1-.2-.2v-2a.2.2,0,0,1,.2-.2.19.19,0,0,1,.19.2v2A.19.19,0,0,1,321.55,181.21Zm-8-1.85a.21.21,0,0,1-.17-.1.2.2,0,0,1,.07-.27l1.73-1a.2.2,0,0,1,.2.35l-1.73,1A.17.17,0,0,1,313.52,179.36Zm3.46-2a.2.2,0,0,1-.17-.09.2.2,0,0,1,.07-.27l1.73-1a.21.21,0,0,1,.27.07.2.2,0,0,1-.07.27l-1.73,1A.18.18,0,0,1,317,177.36Zm4.57-.14a.2.2,0,0,1-.2-.2c0-.74-.32-1.24-.84-1.32a.2.2,0,0,1-.16-.23.19.19,0,0,1,.22-.16c.72.11,1.17.77,1.18,1.71a.2.2,0,0,1-.2.2Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.12,239.34a.18.18,0,0,1-.1,0,.21.21,0,0,1-.1-.17v-6.94a.15.15,0,0,1,0-.11l16.55-23.63a.19.19,0,0,1,.26-.06l13,7.58-3-3.71a.21.21,0,0,1,0-.25l8.71-11.3a.21.21,0,0,1,.27,0l8.87,5.7a.2.2,0,0,1,.09.17v5.63a3,3,0,0,1-1.26,2.19l-43.26,24.94A.18.18,0,0,1,275.12,239.34Zm.19-7.07v6.54l43-24.77a2.65,2.65,0,0,0,1.07-1.85v-5.52l-8.63-5.55-8.51,11,3.55,4.42a.2.2,0,0,1,0,.25.2.2,0,0,1-.25,0l-13.78-8Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300,200.62a1.45,1.45,0,0,1-.77-.2,2,2,0,0,1-.86-1.85,6,6,0,0,1,2.69-4.66h0a1.78,1.78,0,0,1,2.9,1.67,6,6,0,0,1-2.7,4.66A2.49,2.49,0,0,1,300,200.62Zm1.26-6.37a5.52,5.52,0,0,0-2.49,4.32,1.62,1.62,0,0,0,.66,1.51,1.6,1.6,0,0,0,1.63-.18,5.51,5.51,0,0,0,2.5-4.32,1.62,1.62,0,0,0-.66-1.51,1.64,1.64,0,0,0-1.64.18Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Settings--inject-126"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M153.55,371.55l29.48-17a4.35,4.35,0,0,0,2-3.43V325.63c0-1.27-.88-1.78-2-1.15l-29.48,17a4.37,4.37,0,0,0-2,3.43V370.4C151.56,371.67,152.45,372.18,153.55,371.55Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.66,372.28a1.44,1.44,0,0,1-.74-.2,1.82,1.82,0,0,1-.81-1.68V344.94a4.83,4.83,0,0,1,2.21-3.83l29.48-17a1.66,1.66,0,0,1,2.67,1.54v25.46a4.83,4.83,0,0,1-2.21,3.83l-29.49,17A2.16,2.16,0,0,1,152.66,372.28Zm31.26-47.61a1.36,1.36,0,0,0-.66.21l-29.49,17a3.94,3.94,0,0,0-1.75,3V370.4a.77.77,0,0,0,1.3.75h0l29.48-17a4,4,0,0,0,1.76-3V325.63a1,1,0,0,0-.36-.89A.51.51,0,0,0,183.92,324.67Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.41,344.37V342a.15.15,0,0,0-.23-.15l-1.81.82a.21.21,0,0,1-.3-.14,4.63,4.63,0,0,0-.4-.9.47.47,0,0,1,0-.43l1.2-2.43a.28.28,0,0,0-.1-.36l-1.31-.75a.28.28,0,0,0-.36.08l-1.5,2.26a.52.52,0,0,1-.4.2,4.13,4.13,0,0,0-1,.09.21.21,0,0,1-.27-.19l-.2-2a.15.15,0,0,0-.25-.12l-2,1.17a.54.54,0,0,0-.24.38l-.2,2.26a.84.84,0,0,1-.21.42,10.64,10.64,0,0,0-1.13,1.19.4.4,0,0,1-.4.12l-1.3-.46a.31.31,0,0,0-.37.14l-1.49,2.58a.33.33,0,0,0,.06.39l1.05.9a.39.39,0,0,1,.1.4,13.36,13.36,0,0,0-.47,1.57.78.78,0,0,1-.26.4l-1.86,1.3a.56.56,0,0,0-.2.4v2.35c0,.14.1.2.23.15l1.81-.82a.22.22,0,0,1,.3.14,4.1,4.1,0,0,0,.4.9.52.52,0,0,1,0,.44l-1.21,2.42a.28.28,0,0,0,.11.36l1.31.75a.27.27,0,0,0,.36-.08l1.5-2.26a.45.45,0,0,1,.39-.19,4.87,4.87,0,0,0,1-.1.21.21,0,0,1,.27.19l.2,2a.15.15,0,0,0,.24.13l2-1.18a.59.59,0,0,0,.25-.38l.2-2.26a.8.8,0,0,1,.21-.42,12.84,12.84,0,0,0,1.13-1.19.37.37,0,0,1,.4-.11l1.3.45a.32.32,0,0,0,.37-.13l1.49-2.59a.32.32,0,0,0-.07-.39l-1-.9a.37.37,0,0,1-.1-.4,13.36,13.36,0,0,0,.47-1.57.72.72,0,0,1,.26-.4l1.85-1.3A.53.53,0,0,0,176.41,344.37Zm-7.94,7.37c-1.9,1.1-3.43.21-3.43-2a7.55,7.55,0,0,1,3.43-5.94c1.89-1.09,3.43-.21,3.43,2A7.58,7.58,0,0,1,168.47,351.74Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.76,339.69a.36.36,0,0,1-.3-.18.35.35,0,0,1,.13-.47l1-.57a.36.36,0,0,1,.47.13.35.35,0,0,1-.13.47l-1,.57A.34.34,0,0,1,149.76,339.69Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.83,337.91a.34.34,0,0,1-.29-.17.34.34,0,0,1,.12-.47l2.09-1.2a.34.34,0,0,1,.47.12.35.35,0,0,1-.13.47l-2.08,1.2A.41.41,0,0,1,152.83,337.91ZM157,335.5a.34.34,0,0,1-.29-.17.34.34,0,0,1,.12-.47l2.09-1.2a.34.34,0,1,1,.34.59l-2.09,1.21A.33.33,0,0,1,157,335.5Zm4.17-2.4a.36.36,0,0,1-.3-.18.36.36,0,0,1,.13-.47l2.09-1.2a.33.33,0,0,1,.46.13.34.34,0,0,1-.12.47l-2.09,1.2A.34.34,0,0,1,161.17,333.1Zm4.17-2.41a.34.34,0,0,1-.17-.64l2.08-1.2a.34.34,0,0,1,.35.59l-2.09,1.2A.34.34,0,0,1,165.34,330.69Zm4.17-2.41a.35.35,0,0,1-.3-.17.35.35,0,0,1,.13-.47l2.08-1.2a.35.35,0,0,1,.47.12.34.34,0,0,1-.12.47l-2.09,1.21A.33.33,0,0,1,169.51,328.28Zm4.17-2.4a.36.36,0,0,1-.3-.18.35.35,0,0,1,.13-.47l2.08-1.2a.34.34,0,0,1,.47.13.34.34,0,0,1-.13.47l-2.08,1.2A.34.34,0,0,1,173.68,325.88Zm4.17-2.41a.34.34,0,0,1-.17-.64l2.08-1.21a.36.36,0,0,1,.47.13.35.35,0,0,1-.13.47l-2.08,1.2A.34.34,0,0,1,177.85,323.47Zm4.17-2.41a.34.34,0,0,1-.17-.64l2.08-1.2a.35.35,0,0,1,.47.12.34.34,0,0,1-.13.47L182.19,321A.38.38,0,0,1,182,321.06Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.19,318.65a.34.34,0,0,1-.3-.17A.34.34,0,0,1,186,318l1-.57a.35.35,0,0,1,.35.6l-1,.57A.38.38,0,0,1,186.19,318.65Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.24,377.51a.35.35,0,0,1-.35-.35V376a.35.35,0,0,1,.69,0v1.14A.35.35,0,0,1,148.24,377.51Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.24,374.17a.35.35,0,0,1-.35-.34v-2.2a.35.35,0,0,1,.69,0v2.2A.34.34,0,0,1,148.24,374.17Zm0-4.39a.35.35,0,0,1-.35-.34v-2.19a.35.35,0,1,1,.69,0v2.19A.34.34,0,0,1,148.24,369.78Zm0-4.38a.35.35,0,0,1-.35-.35v-2.19a.35.35,0,0,1,.69,0v2.19A.35.35,0,0,1,148.24,365.4Zm0-4.39a.35.35,0,0,1-.35-.34v-2.19a.35.35,0,1,1,.69,0v2.19A.34.34,0,0,1,148.24,361Zm0-4.38a.35.35,0,0,1-.34-.35v-2.19a.35.35,0,0,1,.69,0v2.19A.35.35,0,0,1,148.23,356.63Zm0-4.39a.34.34,0,0,1-.34-.34v-2.2a.35.35,0,0,1,.69,0v2.2A.35.35,0,0,1,148.23,352.24Zm0-4.39a.34.34,0,0,1-.34-.34v-2.19a.35.35,0,0,1,.69,0v2.19A.35.35,0,0,1,148.23,347.85Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.23,343.47a.34.34,0,0,1-.34-.34V342a.35.35,0,0,1,.69,0v1.15A.35.35,0,0,1,148.23,343.47Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.22,357.34a.34.34,0,0,1-.18-.64l1-.58a.35.35,0,0,1,.47.13.34.34,0,0,1-.12.47l-1,.57A.41.41,0,0,1,186.22,357.34Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.84,376.61a.34.34,0,0,1-.18-.64l2.09-1.21a.34.34,0,0,1,.34.6l-2.08,1.2A.37.37,0,0,1,152.84,376.61ZM157,374.2a.34.34,0,0,1-.17-.64l2.08-1.21a.36.36,0,0,1,.47.13.34.34,0,0,1-.12.47l-2.09,1.2A.34.34,0,0,1,157,374.2Zm4.17-2.41a.35.35,0,0,1-.3-.17.35.35,0,0,1,.13-.47l2.09-1.2a.33.33,0,0,1,.46.12.34.34,0,0,1-.12.47l-2.09,1.21A.33.33,0,0,1,161.18,371.79Zm4.17-2.41a.34.34,0,0,1-.29-.17.34.34,0,0,1,.12-.47l2.09-1.2a.34.34,0,1,1,.34.59l-2.09,1.21A.33.33,0,0,1,165.35,369.38Zm4.18-2.41a.34.34,0,0,1-.3-.17.34.34,0,0,1,.12-.47l2.09-1.2a.35.35,0,0,1,.47.12.34.34,0,0,1-.13.47l-2.08,1.21A.38.38,0,0,1,169.53,367Zm4.17-2.41a.35.35,0,0,1-.3-.17.35.35,0,0,1,.13-.47l2.08-1.2a.35.35,0,0,1,.47.12.34.34,0,0,1-.12.47l-2.09,1.21A.33.33,0,0,1,173.7,364.56Zm4.17-2.41a.35.35,0,0,1-.3-.17.35.35,0,0,1,.13-.47l2.08-1.2a.34.34,0,0,1,.47.13.33.33,0,0,1-.12.46L178,362.11A.33.33,0,0,1,177.87,362.15Zm4.17-2.4a.33.33,0,0,1-.29-.18.33.33,0,0,1,.12-.46L184,357.9a.34.34,0,0,1,.34.6l-2.09,1.2A.34.34,0,0,1,182,359.75Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.76,378.39a.36.36,0,0,1-.3-.18.35.35,0,0,1,.13-.47l1-.57a.34.34,0,0,1,.34.6l-1,.57A.34.34,0,0,1,149.76,378.39Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.73,320.09a.34.34,0,0,1-.34-.34V318.6a.34.34,0,1,1,.68,0v1.15A.34.34,0,0,1,188.73,320.09Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.73,350.79a.34.34,0,0,1-.34-.34v-2.2a.34.34,0,1,1,.68,0v2.2A.34.34,0,0,1,188.73,350.79Zm0-4.39a.34.34,0,0,1-.34-.34v-2.19a.34.34,0,1,1,.68,0v2.19A.34.34,0,0,1,188.73,346.4Zm0-4.38a.35.35,0,0,1-.34-.35v-2.19a.34.34,0,0,1,.68,0v2.19A.35.35,0,0,1,188.73,342Zm0-4.39a.34.34,0,0,1-.34-.34V335.1a.34.34,0,1,1,.68,0v2.19A.34.34,0,0,1,188.73,337.63Zm0-4.38a.35.35,0,0,1-.34-.35v-2.19a.34.34,0,1,1,.68,0v2.19A.35.35,0,0,1,188.73,333.25Zm0-4.39a.34.34,0,0,1-.34-.34v-2.2a.34.34,0,1,1,.68,0v2.2A.34.34,0,0,1,188.73,328.86Zm0-4.39a.34.34,0,0,1-.34-.34v-2.19a.34.34,0,0,1,.68,0v2.19A.34.34,0,0,1,188.73,324.47Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.73,354.13a.35.35,0,0,1-.34-.35v-1.14a.34.34,0,1,1,.68,0v1.14A.35.35,0,0,1,188.73,354.13Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.21,319.82a.39.39,0,0,1-.18,0,.36.36,0,0,1-.17-.3V316a.34.34,0,0,1,.17-.29l3.05-1.77a.36.36,0,0,1,.35,0,.38.38,0,0,1,.17.3v3.52a.36.36,0,0,1-.17.3l-3.05,1.76A.33.33,0,0,1,187.21,319.82Zm.34-3.66v2.73l2.36-1.37V314.8Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.21,358.52a.39.39,0,0,1-.18,0,.36.36,0,0,1-.17-.3v-3.52a.34.34,0,0,1,.17-.29l3.05-1.77a.36.36,0,0,1,.35,0,.38.38,0,0,1,.17.3v3.52a.36.36,0,0,1-.17.3l-3.05,1.76A.33.33,0,0,1,187.21,358.52Zm.34-3.66v2.73l2.36-1.37V353.5Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.71,343.2a.33.33,0,0,1-.17,0,.34.34,0,0,1-.17-.3v-3.52a.35.35,0,0,1,.17-.3l3.05-1.75a.3.3,0,0,1,.34,0,.32.32,0,0,1,.17.29v3.52a.34.34,0,0,1-.17.3l-3.05,1.76A.33.33,0,0,1,146.71,343.2Zm.34-3.66v2.73l2.37-1.37v-2.72Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.71,381.9a.33.33,0,0,1-.17,0,.34.34,0,0,1-.17-.3V378a.35.35,0,0,1,.17-.3l3.05-1.75a.3.3,0,0,1,.34,0,.32.32,0,0,1,.17.29v3.52a.34.34,0,0,1-.17.3l-3.05,1.76A.33.33,0,0,1,146.71,381.9Zm.34-3.66V381l2.37-1.37v-2.72Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.26,337.47a3.68,3.68,0,0,1-1.53,2.94c-.85.48-1.53,0-1.53-1.16a3.68,3.68,0,0,1,1.53-2.94C189.58,335.82,190.26,336.34,190.26,337.47Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170,327.65a3.66,3.66,0,0,1-1.53,2.93c-.85.49-1.54,0-1.54-1.16a3.67,3.67,0,0,1,1.54-2.93C169.32,326,170,326.52,170,327.65Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170,366.35a3.66,3.66,0,0,1-1.53,2.93c-.85.49-1.54,0-1.54-1.16a3.67,3.67,0,0,1,1.54-2.93C169.32,364.7,170,365.22,170,366.35Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.77,360.91a3.67,3.67,0,0,1-1.54,2.93c-.84.49-1.53,0-1.53-1.16a3.69,3.69,0,0,1,1.53-2.93C149.08,359.26,149.77,359.78,149.77,360.91Z",
    style: {
      fill: "#46C5FB"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--image--inject-126"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M226.66,329.33l29.49-17a4.39,4.39,0,0,0,2-3.43V283.41c0-1.26-.89-1.77-2-1.14l-29.49,17a4.4,4.4,0,0,0-2,3.43v25.47C224.68,329.45,225.57,330,226.66,329.33Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.78,330.06a1.49,1.49,0,0,1-.75-.19,1.83,1.83,0,0,1-.81-1.68V302.72a4.8,4.8,0,0,1,2.21-3.82l29.49-17a1.66,1.66,0,0,1,2.67,1.54v25.47a4.83,4.83,0,0,1-2.21,3.83l-29.49,17A2.24,2.24,0,0,1,225.78,330.06ZM257,282.46a1.33,1.33,0,0,0-.65.21l-29.49,17a3.94,3.94,0,0,0-1.75,3v25.47a1,1,0,0,0,.35.89,1,1,0,0,0,.94-.14h0l29.49-17a3.92,3.92,0,0,0,1.75-3V283.41a1,1,0,0,0-.35-.88A.54.54,0,0,0,257,282.46Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "228.46 324.19 254.71 309.03 249.7 300.1 246.79 307.06 247.87 309.72 238.75 300.1 228.46 324.19",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.75,293.82a4.88,4.88,0,0,0-2.21,3.83c0,1.42,1,2,2.21,1.28A4.87,4.87,0,0,0,249,295.1C249,293.68,248,293.11,246.75,293.82Z",
    style: {
      fill: "#46C5FB",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.88,297.47a.34.34,0,0,1-.3-.17.34.34,0,0,1,.12-.47l1-.57a.35.35,0,0,1,.47.12.34.34,0,0,1-.12.47l-1,.58A.38.38,0,0,1,222.88,297.47Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226,295.7a.36.36,0,0,1-.3-.18.33.33,0,0,1,.13-.46l2.08-1.21a.35.35,0,0,1,.35.6l-2.09,1.2A.34.34,0,0,1,226,295.7Zm4.17-2.41a.35.35,0,0,1-.3-.17.34.34,0,0,1,.13-.47l2.08-1.21a.35.35,0,0,1,.47.13.34.34,0,0,1-.12.47l-2.09,1.2A.34.34,0,0,1,230.12,293.29Zm4.17-2.41a.35.35,0,0,1-.3-.17.35.35,0,0,1,.13-.47l2.08-1.2a.35.35,0,0,1,.47.12.34.34,0,0,1-.12.47l-2.09,1.21A.33.33,0,0,1,234.29,290.88Zm4.17-2.41a.34.34,0,0,1-.3-.17.35.35,0,0,1,.13-.47l2.08-1.2a.34.34,0,0,1,.47.13.35.35,0,0,1-.13.47l-2.08,1.2A.33.33,0,0,1,238.46,288.47Zm4.17-2.4a.34.34,0,0,1-.18-.64l2.09-1.21a.36.36,0,0,1,.47.13.35.35,0,0,1-.13.47L242.8,286A.41.41,0,0,1,242.63,286.07Zm4.17-2.41a.34.34,0,0,1-.3-.17.34.34,0,0,1,.12-.47l2.09-1.2a.35.35,0,0,1,.47.12.34.34,0,0,1-.13.47L247,283.62A.38.38,0,0,1,246.8,283.66Zm4.16-2.41a.34.34,0,0,1-.29-.17.34.34,0,0,1,.12-.47l2.09-1.2a.35.35,0,0,1,.47.13.36.36,0,0,1-.13.47l-2.08,1.2A.39.39,0,0,1,251,281.25Zm4.17-2.4a.34.34,0,0,1-.29-.17.34.34,0,0,1,.12-.47l2.09-1.21a.34.34,0,0,1,.34.6l-2.08,1.2A.41.41,0,0,1,255.13,278.85Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.3,276.44a.34.34,0,0,1-.17-.64l1-.57a.35.35,0,0,1,.47.12.34.34,0,0,1-.13.47l-1,.58A.33.33,0,0,1,259.3,276.44Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.35,335.29A.34.34,0,0,1,221,335v-1.14a.35.35,0,0,1,.34-.35.35.35,0,0,1,.35.35V335A.35.35,0,0,1,221.35,335.29Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.35,332a.35.35,0,0,1-.34-.35v-2.19a.34.34,0,0,1,.34-.34.35.35,0,0,1,.35.34v2.19A.35.35,0,0,1,221.35,332Zm0-4.39a.34.34,0,0,1-.34-.34V325a.34.34,0,0,1,.34-.34.35.35,0,0,1,.35.34v2.2A.35.35,0,0,1,221.35,327.57Zm0-4.39a.34.34,0,0,1-.34-.34v-2.19a.35.35,0,0,1,.34-.35.35.35,0,0,1,.35.35v2.19A.35.35,0,0,1,221.35,323.18Zm0-4.38a.35.35,0,0,1-.34-.35v-2.19a.34.34,0,1,1,.68,0v2.19A.35.35,0,0,1,221.35,318.8Zm0-4.39a.34.34,0,0,1-.34-.34v-2.19a.34.34,0,1,1,.68,0v2.19A.34.34,0,0,1,221.35,314.41Zm0-4.38a.35.35,0,0,1-.34-.35v-2.19a.34.34,0,0,1,.68,0v2.19A.35.35,0,0,1,221.35,310Zm0-4.39a.34.34,0,0,1-.34-.34v-2.2a.34.34,0,0,1,.68,0v2.2A.34.34,0,0,1,221.35,305.64Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.35,301.26a.35.35,0,0,1-.34-.35v-1.14a.34.34,0,1,1,.68,0v1.14A.35.35,0,0,1,221.35,301.26Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.33,315.12a.35.35,0,0,1-.3-.17.36.36,0,0,1,.13-.47l1-.57a.34.34,0,0,1,.47.13.34.34,0,0,1-.13.47l-1,.57A.33.33,0,0,1,259.33,315.12Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226,334.39a.32.32,0,0,1-.29-.17.34.34,0,0,1,.12-.47l2.09-1.2a.35.35,0,0,1,.47.13.34.34,0,0,1-.13.46l-2.09,1.21A.33.33,0,0,1,226,334.39Zm4.17-2.4a.35.35,0,0,1-.29-.18.33.33,0,0,1,.12-.46l2.09-1.21a.34.34,0,0,1,.34.6l-2.08,1.2A.41.41,0,0,1,230.12,332Zm4.18-2.41a.34.34,0,0,1-.3-.17.33.33,0,0,1,.13-.47l2.08-1.21a.35.35,0,0,1,.35.6l-2.09,1.2A.37.37,0,0,1,234.3,329.58Zm4.17-2.41a.35.35,0,0,1-.3-.17.34.34,0,0,1,.13-.47l2.08-1.21a.35.35,0,0,1,.35.6l-2.09,1.2A.34.34,0,0,1,238.47,327.17Zm4.17-2.41a.34.34,0,0,1-.17-.64l2.09-1.21a.34.34,0,0,1,.34.6l-2.09,1.2A.34.34,0,0,1,242.64,324.76Zm4.18-2.41a.34.34,0,0,1-.18-.64l2.09-1.21a.36.36,0,0,1,.47.13.35.35,0,0,1-.13.47L247,322.3A.41.41,0,0,1,246.82,322.35Zm4.17-2.41a.34.34,0,0,1-.3-.17.33.33,0,0,1,.13-.47l2.08-1.2a.34.34,0,0,1,.47.12.33.33,0,0,1-.13.47l-2.08,1.21A.38.38,0,0,1,251,319.94Zm4.17-2.41a.35.35,0,0,1-.3-.17.35.35,0,0,1,.13-.47l2.08-1.2a.34.34,0,1,1,.35.59l-2.09,1.21A.33.33,0,0,1,255.16,317.53Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.88,336.17a.34.34,0,0,1-.3-.17.34.34,0,0,1,.12-.47l1-.57a.35.35,0,0,1,.47.12.34.34,0,0,1-.12.47l-1,.58A.38.38,0,0,1,222.88,336.17Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.85,277.88a.35.35,0,0,1-.35-.35v-1.14a.35.35,0,0,1,.35-.34.34.34,0,0,1,.34.34v1.14A.35.35,0,0,1,261.85,277.88Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.85,308.58a.35.35,0,0,1-.35-.35V306a.35.35,0,0,1,.35-.34.34.34,0,0,1,.34.34v2.19A.35.35,0,0,1,261.85,308.58Zm0-4.39a.35.35,0,0,1-.35-.34v-2.2a.35.35,0,0,1,.35-.34.34.34,0,0,1,.34.34v2.2A.34.34,0,0,1,261.85,304.19Zm0-4.39a.35.35,0,0,1-.35-.34v-2.19a.35.35,0,0,1,.35-.35.35.35,0,0,1,.34.35v2.19A.34.34,0,0,1,261.85,299.8Zm0-4.38a.35.35,0,0,1-.35-.35v-2.19a.35.35,0,0,1,.35-.34.34.34,0,0,1,.34.34v2.19A.35.35,0,0,1,261.85,295.42Zm0-4.39a.35.35,0,0,1-.35-.34V288.5a.35.35,0,0,1,.35-.35.35.35,0,0,1,.34.35v2.19A.34.34,0,0,1,261.85,291Zm0-4.38a.35.35,0,0,1-.35-.35v-2.19a.35.35,0,0,1,.35-.34.34.34,0,0,1,.34.34v2.19A.35.35,0,0,1,261.85,286.65Zm0-4.39a.35.35,0,0,1-.35-.34v-2.2a.35.35,0,0,1,.35-.34.34.34,0,0,1,.34.34v2.2A.34.34,0,0,1,261.85,282.26Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.85,311.91a.35.35,0,0,1-.35-.34v-1.14a.35.35,0,0,1,.35-.35.35.35,0,0,1,.34.35v1.14A.34.34,0,0,1,261.85,311.91Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.32,277.61a.26.26,0,0,1-.17-.05.34.34,0,0,1-.17-.29v-3.52a.36.36,0,0,1,.17-.3l3.05-1.76a.34.34,0,0,1,.34,0,.34.34,0,0,1,.17.3v3.52a.35.35,0,0,1-.17.3l-3.05,1.75A.26.26,0,0,1,260.32,277.61Zm.35-3.66v2.72l2.36-1.36v-2.73Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.32,316.31a.26.26,0,0,1-.17-.05A.34.34,0,0,1,260,316v-3.52a.36.36,0,0,1,.17-.3l3.05-1.76a.34.34,0,0,1,.34,0,.34.34,0,0,1,.17.3v3.52a.35.35,0,0,1-.17.3l-3.05,1.75A.26.26,0,0,1,260.32,316.31Zm.35-3.66v2.72L263,314v-2.73Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.83,301a.26.26,0,0,1-.17-.05.33.33,0,0,1-.18-.29v-3.52a.35.35,0,0,1,.18-.3l3-1.76a.35.35,0,0,1,.52.3v3.52a.38.38,0,0,1-.17.3L220,300.94A.26.26,0,0,1,219.83,301Zm.34-3.66v2.72l2.36-1.36V296Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.83,339.69a.33.33,0,0,1-.17,0,.36.36,0,0,1-.18-.3v-3.52a.35.35,0,0,1,.18-.3l3-1.76a.35.35,0,0,1,.52.3v3.52a.38.38,0,0,1-.17.3L220,339.65A.33.33,0,0,1,219.83,339.69Zm.34-3.66v2.72l2.36-1.36v-2.73Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.38,295.26a3.69,3.69,0,0,1-1.53,2.93c-.85.49-1.54,0-1.54-1.16a3.67,3.67,0,0,1,1.54-2.93C262.69,293.61,263.38,294.13,263.38,295.26Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.12,285.43a3.66,3.66,0,0,1-1.54,2.93c-.84.49-1.53,0-1.53-1.16a3.69,3.69,0,0,1,1.53-2.93C242.43,283.78,243.12,284.3,243.12,285.43Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.12,324.13a3.66,3.66,0,0,1-1.54,2.93c-.84.49-1.53,0-1.53-1.16a3.69,3.69,0,0,1,1.53-2.93C242.43,322.48,243.12,323,243.12,324.13Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.88,318.69a3.65,3.65,0,0,1-1.53,2.93c-.85.49-1.53,0-1.53-1.16a3.66,3.66,0,0,1,1.53-2.93C222.2,317,222.88,317.56,222.88,318.69Z",
    style: {
      fill: "#46C5FB"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Video--inject-126"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M299.78,287.12l29.49-17a4.41,4.41,0,0,0,2-3.44V241.2c0-1.26-.89-1.78-2-1.14l-29.49,17a4.36,4.36,0,0,0-2,3.43V286C297.8,287.24,298.68,287.75,299.78,287.12Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.89,287.85a1.49,1.49,0,0,1-.74-.2,1.81,1.81,0,0,1-.81-1.67V260.51a4.83,4.83,0,0,1,2.21-3.83l29.49-17a1.65,1.65,0,0,1,2.66,1.54v25.46a4.8,4.8,0,0,1-2.21,3.83l-29.48,17A2.3,2.3,0,0,1,298.89,287.85Zm31.26-47.61a1.36,1.36,0,0,0-.66.21l-29.48,17a3.92,3.92,0,0,0-1.76,3V286a.77.77,0,0,0,1.3.74l29.49-17a3.94,3.94,0,0,0,1.75-3V241.2a1,1,0,0,0-.35-.89A.65.65,0,0,0,330.15,240.24Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296,255.26a.34.34,0,0,1-.17-.64l1-.58a.35.35,0,0,1,.47.13.33.33,0,0,1-.13.47l-1,.57A.34.34,0,0,1,296,255.26Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.07,253.48a.34.34,0,0,1-.3-.17.35.35,0,0,1,.13-.47l2.08-1.2a.35.35,0,0,1,.47.12.34.34,0,0,1-.13.47l-2.08,1.21A.33.33,0,0,1,299.07,253.48Zm4.17-2.41a.34.34,0,0,1-.17-.64l2.08-1.2a.34.34,0,1,1,.34.6l-2.08,1.2A.38.38,0,0,1,303.24,251.07Zm4.17-2.4a.34.34,0,0,1-.18-.64l2.09-1.21a.36.36,0,0,1,.47.13.35.35,0,0,1-.13.47l-2.08,1.2A.41.41,0,0,1,307.41,248.67Zm4.16-2.41a.34.34,0,0,1-.29-.17.34.34,0,0,1,.12-.47l2.09-1.2a.35.35,0,0,1,.47.12.34.34,0,0,1-.13.47l-2.08,1.21A.39.39,0,0,1,311.57,246.26Zm4.17-2.41a.32.32,0,0,1-.29-.17.34.34,0,0,1,.12-.47l2.09-1.2a.33.33,0,0,1,.46.13.34.34,0,0,1-.12.47l-2.09,1.2A.33.33,0,0,1,315.74,243.85Zm4.17-2.4a.34.34,0,0,1-.17-.64l2.08-1.21a.35.35,0,0,1,.47.13.34.34,0,0,1-.12.47l-2.09,1.2A.34.34,0,0,1,319.91,241.45Zm4.17-2.41a.34.34,0,0,1-.17-.64l2.08-1.2a.34.34,0,1,1,.35.59l-2.09,1.2A.34.34,0,0,1,324.08,239Zm4.17-2.41a.35.35,0,0,1-.3-.17.35.35,0,0,1,.13-.47l2.08-1.2a.35.35,0,0,1,.47.12.34.34,0,0,1-.12.47l-2.09,1.21A.33.33,0,0,1,328.25,236.63Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.42,234.23a.35.35,0,0,1-.3-.17.34.34,0,0,1,.13-.47l1-.58a.36.36,0,0,1,.47.13.35.35,0,0,1-.13.47l-1,.57A.34.34,0,0,1,332.42,234.23Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.47,293.08a.34.34,0,0,1-.34-.34v-1.15a.34.34,0,0,1,.68,0v1.15A.34.34,0,0,1,294.47,293.08Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.47,289.74a.34.34,0,0,1-.34-.34v-2.19a.34.34,0,1,1,.68,0v2.19A.34.34,0,0,1,294.47,289.74Zm0-4.38a.35.35,0,0,1-.34-.35v-2.19a.34.34,0,0,1,.68,0V285A.35.35,0,0,1,294.47,285.36Zm0-4.39a.34.34,0,0,1-.34-.34v-2.2a.34.34,0,1,1,.68,0v2.2A.34.34,0,0,1,294.47,281Zm0-4.39a.34.34,0,0,1-.34-.34v-2.19a.35.35,0,0,1,.35-.34.34.34,0,0,1,.34.34v2.19A.34.34,0,0,1,294.47,276.58Zm0-4.38a.35.35,0,0,1-.35-.35v-2.19a.35.35,0,0,1,.35-.34.34.34,0,0,1,.34.34v2.19A.35.35,0,0,1,294.47,272.2Zm0-4.39a.35.35,0,0,1-.35-.34v-2.19a.35.35,0,0,1,.35-.35.35.35,0,0,1,.34.35v2.19A.34.34,0,0,1,294.47,267.81Zm0-4.38a.35.35,0,0,1-.35-.35v-2.19a.35.35,0,0,1,.35-.34.34.34,0,0,1,.34.34v2.19A.35.35,0,0,1,294.47,263.43Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.47,259a.35.35,0,0,1-.35-.34v-1.15a.35.35,0,0,1,.35-.34.34.34,0,0,1,.34.34v1.15A.34.34,0,0,1,294.47,259Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.45,272.91a.35.35,0,0,1-.3-.17.34.34,0,0,1,.13-.47l1-.57a.34.34,0,1,1,.34.59l-1,.57A.34.34,0,0,1,332.45,272.91Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.07,292.18a.35.35,0,0,1-.3-.17.35.35,0,0,1,.13-.47l2.08-1.2a.34.34,0,0,1,.47.12.34.34,0,0,1-.12.47l-2.09,1.21A.33.33,0,0,1,299.07,292.18Zm4.17-2.41a.35.35,0,0,1-.3-.17.36.36,0,0,1,.13-.47l2.09-1.2a.34.34,0,0,1,.34.59l-2.09,1.21A.33.33,0,0,1,303.24,289.77Zm4.17-2.41a.34.34,0,0,1-.29-.17.34.34,0,0,1,.12-.47l2.09-1.2a.35.35,0,0,1,.47.12.34.34,0,0,1-.13.47l-2.08,1.21A.39.39,0,0,1,307.41,287.36Zm4.18-2.41a.34.34,0,0,1-.3-.17.34.34,0,0,1,.12-.47l2.09-1.2a.34.34,0,1,1,.34.59l-2.08,1.21A.35.35,0,0,1,311.59,285Zm4.17-2.41a.35.35,0,0,1-.3-.17.35.35,0,0,1,.13-.47l2.08-1.2a.34.34,0,0,1,.47.13.33.33,0,0,1-.12.46l-2.09,1.21A.33.33,0,0,1,315.76,282.54Zm4.17-2.4a.36.36,0,0,1-.3-.18.34.34,0,0,1,.13-.46l2.09-1.21a.33.33,0,0,1,.46.13.34.34,0,0,1-.12.47l-2.09,1.2A.34.34,0,0,1,319.93,280.14Zm4.17-2.41a.34.34,0,0,1-.29-.17.34.34,0,0,1,.12-.47l2.09-1.21a.34.34,0,0,1,.34.6l-2.09,1.2A.34.34,0,0,1,324.1,277.73Zm4.18-2.41a.34.34,0,0,1-.18-.64l2.09-1.21a.36.36,0,0,1,.47.13.35.35,0,0,1-.13.47l-2.08,1.2A.41.41,0,0,1,328.28,275.32Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296,294a.34.34,0,0,1-.17-.64l1-.58a.35.35,0,0,1,.47.13.33.33,0,0,1-.13.47l-1,.57A.34.34,0,0,1,296,294Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335,235.66a.34.34,0,0,1-.34-.34v-1.15a.34.34,0,0,1,.34-.34.35.35,0,0,1,.35.34v1.15A.35.35,0,0,1,335,235.66Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335,266.36a.34.34,0,0,1-.34-.34v-2.2a.34.34,0,0,1,.34-.34.35.35,0,0,1,.35.34V266A.35.35,0,0,1,335,266.36Zm0-4.38a.35.35,0,0,1-.34-.35v-2.19a.34.34,0,0,1,.34-.34.35.35,0,0,1,.35.34v2.19A.35.35,0,0,1,335,262Zm0-4.39a.34.34,0,0,1-.34-.34v-2.2a.34.34,0,0,1,.34-.34.35.35,0,0,1,.35.34v2.2A.35.35,0,0,1,335,257.59Zm0-4.39a.34.34,0,0,1-.34-.34v-2.19a.34.34,0,0,1,.34-.34.35.35,0,0,1,.35.34v2.19A.35.35,0,0,1,335,253.2Zm0-4.38a.35.35,0,0,1-.34-.35v-2.19a.34.34,0,0,1,.34-.34.35.35,0,0,1,.35.34v2.19A.35.35,0,0,1,335,248.82Zm0-4.39a.34.34,0,0,1-.34-.34V241.9a.35.35,0,0,1,.34-.35.35.35,0,0,1,.35.35v2.19A.35.35,0,0,1,335,244.43Zm0-4.38a.35.35,0,0,1-.34-.35v-2.19a.34.34,0,0,1,.34-.34.35.35,0,0,1,.35.34v2.19A.35.35,0,0,1,335,240.05Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335,269.7a.35.35,0,0,1-.34-.35v-1.14a.34.34,0,0,1,.34-.34.35.35,0,0,1,.35.34v1.14A.35.35,0,0,1,335,269.7Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.44,235.4a.34.34,0,0,1-.17-.05.33.33,0,0,1-.17-.3v-3.52a.32.32,0,0,1,.17-.29l3.05-1.76a.34.34,0,0,1,.34,0,.32.32,0,0,1,.17.29v3.52a.33.33,0,0,1-.17.3l-3.05,1.76A.34.34,0,0,1,333.44,235.4Zm.34-3.67v2.73l2.36-1.36v-2.73Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.44,274.1a.34.34,0,0,1-.17-.05.33.33,0,0,1-.17-.3v-3.52a.32.32,0,0,1,.17-.29l3.05-1.76a.34.34,0,0,1,.34,0,.32.32,0,0,1,.17.29V272a.33.33,0,0,1-.17.3l-3.05,1.76A.34.34,0,0,1,333.44,274.1Zm.34-3.67v2.73l2.36-1.36v-2.73Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.94,258.78a.41.41,0,0,1-.17,0,.35.35,0,0,1-.17-.3v-3.52a.34.34,0,0,1,.17-.29l3.05-1.76a.34.34,0,0,1,.34,0,.33.33,0,0,1,.18.29v3.52a.34.34,0,0,1-.18.3l-3,1.76A.41.41,0,0,1,292.94,258.78Zm.35-3.67v2.73l2.36-1.36v-2.73Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.94,297.48a.41.41,0,0,1-.17-.05.35.35,0,0,1-.17-.3v-3.52a.34.34,0,0,1,.17-.29l3.05-1.76a.34.34,0,0,1,.34,0,.33.33,0,0,1,.18.29v3.52a.34.34,0,0,1-.18.3l-3,1.76A.41.41,0,0,1,292.94,297.48Zm.35-3.67v2.73l2.36-1.36v-2.73Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.5,253.05A3.67,3.67,0,0,1,335,256c-.84.49-1.53,0-1.53-1.16a3.67,3.67,0,0,1,1.53-2.93C335.81,251.4,336.5,251.92,336.5,253.05Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.24,243.22a3.67,3.67,0,0,1-1.54,2.93c-.85.49-1.53,0-1.53-1.16a3.66,3.66,0,0,1,1.53-2.93C315.55,241.57,316.24,242.09,316.24,243.22Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.24,281.92a3.67,3.67,0,0,1-1.54,2.93c-.85.49-1.53,0-1.53-1.16a3.66,3.66,0,0,1,1.53-2.93C315.55,280.27,316.24,280.79,316.24,281.92Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296,276.48a3.69,3.69,0,0,1-1.53,2.93c-.85.49-1.54,0-1.54-1.16a3.67,3.67,0,0,1,1.54-2.93C295.31,274.83,296,275.35,296,276.48Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.7,253.55c-4.72,2.73-8.55,9.36-8.55,14.81S310,276,314.7,273.3s8.55-9.36,8.55-14.81S319.42,250.83,314.7,253.55Zm4.47,8-6.38,7.62c-.62.74-1.12.56-1.12-.41v-7.16a1.67,1.67,0,0,1,1.75-1.68l5.13.21C319.51,260.18,319.79,260.81,319.17,261.56Z",
    style: {
      fill: "#46C5FB"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Cursor--inject-126"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Arrow--inject-126"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M330.11,287.18,318,272.65a1.24,1.24,0,0,0-.22-.2l-2.91-1.68c-.25-.14-.43.05-.43.53l-.06,29.35c0,.25,0,.4.1.44l2.91,1.68c.1.05.25-.11.43-.48l2.08-4.45,1.19,4.24a.51.51,0,0,0,.23.34c.24.15,2.81,1.63,2.92,1.69s.59,0,.93-.38l1.68-1.93a2.55,2.55,0,0,0,.61-2l-2.3-8.18a1.49,1.49,0,0,1,1-1.56l3.4-1.53C330.2,288.2,330.47,287.6,330.11,287.18Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.11,287.18,318,272.65a1.24,1.24,0,0,0-.22-.2l-2.91-1.68c-.25-.14-.43.05-.43.53l-.06,29.35c0,.25,0,.4.1.44l2.91,1.68c.1.05.25-.11.43-.48l2.08-4.45,1.19,4.24a.51.51,0,0,0,.23.34c.24.15,2.81,1.63,2.92,1.69s.59,0,.93-.38l1.68-1.93a2.55,2.55,0,0,0,.61-2l-2.3-8.18a1.49,1.49,0,0,1,1-1.56l3.4-1.53C330.2,288.2,330.47,287.6,330.11,287.18Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.28,302.33l.06-29.35c0-.61.29-.76.65-.33l12.12,14.53c.36.42.09,1-.6,1.33l-3.4,1.53a1.49,1.49,0,0,0-1,1.56l2.3,8.18a2.55,2.55,0,0,1-.61,2l-1.68,1.93c-.5.56-1,.58-1.17,0l-2.3-8.19c-.15-.55-.51-.48-.81.15l-3.07,6.57C317.51,302.92,317.27,302.94,317.28,302.33Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.18,304.08c-.37-.21-2.65-1.52-2.87-1.66a.56.56,0,0,1-.24-.34l-1.18-4.24,1-2.12c.3-.63.66-.7.82-.15l2.29,8.19A.6.6,0,0,0,324.18,304.08Z",
    style: {
      fill: "#263238"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-126"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-126"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.26,450.94l7.87-4.54s4.69-19.47,2.82-37c-2.62-24.63-18.83-33.89-25-31.77s-8,9.29,2.25,24C85.22,410.25,92.61,428.28,91.26,450.94Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.26,450.94l7.87-4.54s4.69-19.47,2.82-37c-2.62-24.63-18.83-33.89-25-31.77s-8,9.29,2.25,24C85.22,410.25,92.61,428.28,91.26,450.94Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M94.52,441.38h-.07a.55.55,0,0,1-.44-.64c4.32-22.71-3.62-48.24-13.44-58.86a.54.54,0,0,1,0-.77.55.55,0,0,1,.77,0c10,10.81,18.1,36.76,13.72,59.81A.55.55,0,0,1,94.52,441.38Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.45,462.38c-1.17.6-4.3-2.08-5.17-2.73a10.84,10.84,0,0,1-3.42-4.34,10.25,10.25,0,0,1-.6-6.19,24.2,24.2,0,0,1,.94-3.22c.36-1,.71-2.08,1.07-3.13a8.11,8.11,0,0,0,.63-3.17c-.17-2.18-2-3.79-3.7-5.19-1.86-1.55-3.78-3.56-3.64-6.17a9.15,9.15,0,0,1,2.58-5.34c1.33-1.52,2.88-2.84,4.09-4.45a6.42,6.42,0,0,0,1.51-4,6.61,6.61,0,0,0-.75-2.58,35.8,35.8,0,0,1-2.52-5.22c-.54-1.85-.33-4.12,1.16-5.35a5.91,5.91,0,0,1,4.54-.89,10.22,10.22,0,0,1,4.1,1.68c4,2.51,6.14,7.53,10.45,9.53A44.7,44.7,0,0,0,88,413.2a6.57,6.57,0,0,1,4.24,3.22c1.45,3.3-1.74,7.12-.78,10.6.85,3.08,3.73,4.39,5.24,7.2a6.47,6.47,0,0,1,.58,4,19.15,19.15,0,0,1-2,6.61,58.5,58.5,0,0,1-4,6.11S71.63,462.29,71.45,462.38Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.65
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.45,462.38c-1.17.6-4.3-2.08-5.17-2.73a10.84,10.84,0,0,1-3.42-4.34,10.25,10.25,0,0,1-.6-6.19,24.2,24.2,0,0,1,.94-3.22c.36-1,.71-2.08,1.07-3.13a8.11,8.11,0,0,0,.63-3.17c-.17-2.18-2-3.79-3.7-5.19-1.86-1.55-3.78-3.56-3.64-6.17a9.15,9.15,0,0,1,2.58-5.34c1.33-1.52,2.88-2.84,4.09-4.45a6.42,6.42,0,0,0,1.51-4,6.61,6.61,0,0,0-.75-2.58,35.8,35.8,0,0,1-2.52-5.22c-.54-1.85-.33-4.12,1.16-5.35a5.91,5.91,0,0,1,4.54-.89,10.22,10.22,0,0,1,4.1,1.68c4,2.51,6.14,7.53,10.45,9.53A44.7,44.7,0,0,0,88,413.2a6.57,6.57,0,0,1,4.24,3.22c1.45,3.3-1.74,7.12-.78,10.6.85,3.08,3.73,4.39,5.24,7.2a6.47,6.47,0,0,1,.58,4,19.15,19.15,0,0,1-2,6.61,58.5,58.5,0,0,1-4,6.11S71.63,462.29,71.45,462.38Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M82.85,456.44h0a.51.51,0,0,1-.47-.56c1.88-20.43-6.63-43.52-13.31-50.44a.52.52,0,0,1,.74-.72c6.82,7.06,15.51,30.54,13.6,51.26A.52.52,0,0,1,82.85,456.44Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.82,431.25a.45.45,0,0,1-.16,0,69,69,0,0,0-14.73-3.14.52.52,0,0,1-.47-.57.5.5,0,0,1,.56-.46,70.58,70.58,0,0,1,15,3.2.52.52,0,0,1-.2,1Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-126"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--chartacter-on-a-table--inject-126"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chair--inject-126"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M385.57,409.67,391,351l5-.26-7.92,58.9h0a.71.71,0,0,1-.34.45,2,2,0,0,1-1.79.09.62.62,0,0,1-.4-.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391,351l5-.26-1.48,9.74a18.92,18.92,0,0,1-3-1.37,3.09,3.09,0,0,1-1.33-1.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.84,343.48h5l8.06,55.79h0a.59.59,0,0,1-.36.55,2,2,0,0,1-1.8,0,.69.69,0,0,1-.36-.43h0Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.88,343.48,464.83,357a20.68,20.68,0,0,1-4,2.43l-3-16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.22,426.89l4-59.52,5-.25-6.49,59.76h0a.66.66,0,0,1-.33.45,2,2,0,0,1-1.8.09.59.59,0,0,1-.39-.53Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.72,374.9l.5-7.53,5-.25-.88,8.12A9.36,9.36,0,0,1,422.72,374.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.35,327.5h5l8.07,56.88h0a.59.59,0,0,1-.36.55,2,2,0,0,1-1.8,0,.66.66,0,0,1-.36-.43h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--chair--inject-126"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M472.34,287.85a28.44,28.44,0,0,1,2,8.84c.58,6.78-1.72,28.73-3.1,38.55h0c-2,16.4-4.44,16.43-8,19.18-6.12,4.72-23.7,14-29.5,16.26-10.53,4.15-19.13-2.24-25.54-5.41a148.53,148.53,0,0,1-17-10.06c-1.6-1.17-2.44-2.35-2.42-3.59,0-.49,0-2.51,0-3,0-1.59,1.4-3.29,4.35-5.19,5.43-3.53,25.08-15,32.69-19.2a.08.08,0,0,1,.06-.07c5.86-3.55,9.38-27.72,13.44-40.58.08-.27.17-.54.26-.8l.21-.6c.26-.7.52-1.33.8-1.92",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.81,348.59c0-1.59,1.4-3.29,4.35-5.19,5.43-3.53,25.08-15,32.69-19.2a.08.08,0,0,1,.06-.07c5.86-3.55,9.38-27.72,13.44-40.58a20.73,20.73,0,0,1,.85-2.36l.07-.18c.07-.17.15-.34.23-.52l.12-.26h0a12.41,12.41,0,0,1,2.71-3.91,6.11,6.11,0,0,1,1.33-.93c.66-.37,2-1.14,2.38-1.35,4-2.38,9.2.48,15.7,4,4.05,2.22,7.5,4.85,9.6,9.77h0a28.44,28.44,0,0,1,2,8.84c.58,6.78-1.72,28.73-3.1,38.55h0c-2,16.4-4.44,16.43-8,19.18-6.12,4.72-23.7,14-29.5,16.26-10.53,4.15-19.13-2.24-25.54-5.41a148.53,148.53,0,0,1-17-10.06c-1.6-1.17-2.44-2.35-2.42-3.59C388.83,351.12,388.81,349.1,388.81,348.59Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.81,348.59c0-1.59,1.4-3.29,4.35-5.19,5.43-3.53,25.08-15,32.69-19.2a.08.08,0,0,1,.06-.07c5.86-3.55,9.38-27.72,13.44-40.58a20.73,20.73,0,0,1,.85-2.36l.07-.18c.07-.17.15-.34.23-.52l.12-.26h0a12.41,12.41,0,0,1,2.71-3.91,6.11,6.11,0,0,1,1.33-.93c.66-.37,2-1.14,2.38-1.35,4-2.38,9.2.48,15.7,4,4.05,2.22,7.5,4.85,9.6,9.77h0a28.44,28.44,0,0,1,2,8.84c.58,6.78-1.72,28.73-3.1,38.55h0c-2,16.4-4.44,16.43-8,19.18-6.12,4.72-23.7,14-29.5,16.26-10.53,4.15-19.13-2.24-25.54-5.41a148.53,148.53,0,0,1-17-10.06c-1.6-1.17-2.44-2.35-2.42-3.59C388.83,351.12,388.81,349.1,388.81,348.59Z",
    style: {
      fill: "#fff",
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.23,362.21a148.53,148.53,0,0,1-17-10.06c-3.65-2.65-3.31-5.36,1.91-8.75,7.27-4.72,36.87-21.52,36.87-21.52s37.43,22.09,35.82,26.17-24.77,16.7-32.07,19.57C423.24,371.76,414.64,365.38,408.23,362.21Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.23,362.21a148.53,148.53,0,0,1-17-10.06c-3.65-2.65-3.31-5.36,1.91-8.75,7.27-4.72,36.87-21.52,36.87-21.52s37.43,22.09,35.82,26.17-24.77,16.7-32.07,19.57C423.24,371.76,414.64,365.38,408.23,362.21Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.66,275.39c3.94-2.07,9.06.74,15.39,4.21,4.06,2.23,7.51,4.86,9.61,9.79l2.68-1.54c-2.1-4.92-5.55-7.55-9.6-9.77-6.5-3.56-11.72-6.42-15.7-4C446.7,274.25,445.32,275,444.66,275.39Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.66,275.39c3.94-2.07,9.06.74,15.39,4.21,4.06,2.23,7.51,4.86,9.61,9.79l2.68-1.54c-2.1-4.92-5.55-7.55-9.6-9.77-6.5-3.56-11.72-6.42-15.7-4C446.7,274.25,445.32,275,444.66,275.39Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.91,324.13s3.82,1.26,17.43,7.94c5.59,2.75,9.27,5.51,14.5,8.81,7.7,4.85,7.12,8.45,7.12,8.45,3.83-3.18,7.64-40,6.7-51.12a27.94,27.94,0,0,0-2.19-9.27c-.1-.22-.21-.43-.32-.65s-.14-.3-.22-.44l-.12-.2a15,15,0,0,0-1-1.55c-.08-.13-.17-.25-.25-.36l-.27-.35-.27-.35-.24-.27a18.85,18.85,0,0,0-1.38-1.44c-.12-.12-.24-.22-.37-.33a21.92,21.92,0,0,0-2.43-1.85l-.4-.26-.53-.34-.45-.26c-.4-.24-.79-.47-1.2-.69-4.84-2.65-9-4.92-12.41-4.92a6.44,6.44,0,0,0-4.31,1.64c-2.54,2.24-3.9,7-4,7.23C435.29,296.41,431.77,320.58,425.91,324.13Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.91,324.13s3.82,1.26,17.43,7.94c5.59,2.75,9.27,5.51,14.5,8.81,7.7,4.85,7.12,8.45,7.12,8.45,3.83-3.18,7.64-40,6.7-51.12a27.94,27.94,0,0,0-2.19-9.27c-.1-.22-.21-.43-.32-.65s-.14-.3-.22-.44l-.12-.2a15,15,0,0,0-1-1.55c-.08-.13-.17-.25-.25-.36l-.27-.35-.27-.35-.24-.27a18.85,18.85,0,0,0-1.38-1.44c-.12-.12-.24-.22-.37-.33a21.92,21.92,0,0,0-2.43-1.85l-.4-.26-.53-.34-.45-.26c-.4-.24-.79-.47-1.2-.69-4.84-2.65-9-4.92-12.41-4.92a6.44,6.44,0,0,0-4.31,1.64c-2.54,2.24-3.9,7-4,7.23C435.29,296.41,431.77,320.58,425.91,324.13Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bottom--inject-126"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M398.75,383.22s5.38,10.51,6,14.78c.62,4.46,1.83,5.85,1.49,10.78-.07,1.08-.45,3.25-.51,4.12a1.27,1.27,0,0,0,1.29,1.49c2,.24,4.88-3.69,6.08-7.79a118,118,0,0,0,2.63-14.33,6.13,6.13,0,0,0-.88-3.08,9.23,9.23,0,0,0-1-1.55c-.81-1.89-1.44-5.57-2.2-8.09Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.86,396a4.63,4.63,0,0,1,.65,1.42c.12.89-1.64,4-2.34,5.14a7.2,7.2,0,0,0-1,5.22,12.42,12.42,0,0,1-2.31,8.22,19.62,19.62,0,0,1-9.21,7.23c-4.59,1.86-6.45-.36-6.45-.36s-1.66-2.15-.86-3.15S419.86,396,419.86,396Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.79,387.64c.15,0,.4-.08.8.33.16.16,1.2,2.21,2,3.26s2.87,3,3.26,4.79c-.79,3.59-3.86,6.3-4.06,9.64s.07,7.18-4.66,11.66-9.9,5.34-11.87,4.44-2-2.93.32-7c2.42-4.3,3.53-13.26,3.53-13.26a29.89,29.89,0,0,0,.17-3.78,24.75,24.75,0,0,0-.67-3.68,2.7,2.7,0,0,1,.09-1.69,2.82,2.82,0,0,1,1.31-1.09,13,13,0,0,1,2.53-1.11,4.12,4.12,0,0,1,2.71.1c.61.26,1.14.72,1.77.92a2.41,2.41,0,0,0,2.45-.66,2.05,2.05,0,0,0,.48-2.34A4.42,4.42,0,0,0,413.79,387.64Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.79,387.64c.15,0,.4-.08.8.33.16.16,1.2,2.21,2,3.26s2.87,3,3.26,4.79c-.79,3.59-3.86,6.3-4.06,9.64s.07,7.18-4.66,11.66-9.9,5.34-11.87,4.44-2-2.93.32-7c2.42-4.3,3.53-13.26,3.53-13.26a29.89,29.89,0,0,0,.17-3.78,24.75,24.75,0,0,0-.67-3.68,2.7,2.7,0,0,1,.09-1.69,2.82,2.82,0,0,1,1.31-1.09,13,13,0,0,1,2.53-1.11,4.12,4.12,0,0,1,2.71.1c.61.26,1.14.72,1.77.92a2.41,2.41,0,0,0,2.45-.66,2.05,2.05,0,0,0,.48-2.34A4.42,4.42,0,0,0,413.79,387.64Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.83,413.83a8.1,8.1,0,0,0-7.7-3.34c-5.38.48-7,3.38-7.69,5.07-.81,2-1.52,5.56.79,6.37,2.49.87,5.24.3,9.43-2.27A11.72,11.72,0,0,0,413.83,413.83Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.45,397.69a.55.55,0,0,1-.5,0c-.87-.35-5.35-.89-7.7,1.71-.36-.24-.33-.73,0-1.46,2.84-2.16,7.08-1.67,8.13-1.24a.51.51,0,0,1,.27.69A.59.59,0,0,1,411.45,397.69Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403,402.62a1.68,1.68,0,0,1,.19-1.5,10.09,10.09,0,0,1,7.76-1,.51.51,0,0,1,.27.7.51.51,0,0,1-.23.25.53.53,0,0,1-.49,0C409.62,400.78,405.37,400.27,403,402.62Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.4,410.09a3,3,0,0,1,.52-2,10,10,0,0,1,8-1.16.52.52,0,0,1,.28.7.59.59,0,0,1-.73.29C408.56,407.54,403.62,407,401.4,410.09Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.46,404.48a.53.53,0,0,1-.49,0c-.86-.35-5.25-.87-7.63,1.63a1.94,1.94,0,0,1,.31-1.64,10.1,10.1,0,0,1,7.77-1,.51.51,0,0,1,.27.69A.53.53,0,0,1,410.46,404.48Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.39,397.52s-1.69,13.41-3.94,18.67S388,424,384.81,428.05c-.7.88-2.32,2.53-2.9,3.24a1.33,1.33,0,0,0,.23,2c1.56,1.38,7.95,1.47,11.42-1.35s6.5-8.66,8.54-10.9c.77-.84,1.49-1.7,2.18-2.61s.43-1.67.46-2.62c0-.46-.11-1.72-.11-1.72.4-2.26,1.59-5.83,2.2-8Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.29,424.16a4.76,4.76,0,0,1-.1,1.63c-.32.88-3.48,2.9-4.68,3.61a7.5,7.5,0,0,0-3.5,4.32,13,13,0,0,1-6.16,6.47,20.53,20.53,0,0,1-12.07,2.17c-5.15-.53-5.79-3.5-5.79-3.5s-.48-2.8.76-3.34S406.29,424.16,406.29,424.16Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.79,413.44c.14.05.4.12.57.7.07.22,0,2.62.26,4s1.18,4.18.67,6c-2.49,2.93-6.66,3.94-8.49,6.92s-3.46,6.67-10,8.49-11.77.09-13.15-1.71-.38-3.68,3.72-6.3c4.34-2.79,9.76-10.52,9.76-10.53a29.89,29.89,0,0,0,2-3.41,24.77,24.77,0,0,0,1.18-3.72,3,3,0,0,1,.92-1.53A3.06,3.06,0,0,1,394,412a13.22,13.22,0,0,1,2.88.22,4.28,4.28,0,0,1,2.46,1.42c.44.54.69,1.22,1.18,1.72a2.51,2.51,0,0,0,2.59.59,2.15,2.15,0,0,0,1.59-1.93A4.41,4.41,0,0,0,404.79,413.44Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.79,413.44c.14.05.4.12.57.7.07.22,0,2.62.26,4s1.18,4.18.67,6c-2.49,2.93-6.66,3.94-8.49,6.92s-3.46,6.67-10,8.49-11.77.09-13.15-1.71-.38-3.68,3.72-6.3c4.34-2.79,9.76-10.52,9.76-10.53a29.89,29.89,0,0,0,2-3.41,24.77,24.77,0,0,0,1.18-3.72,3,3,0,0,1,.92-1.53A3.06,3.06,0,0,1,394,412a13.22,13.22,0,0,1,2.88.22,4.28,4.28,0,0,1,2.46,1.42c.44.54.69,1.22,1.18,1.72a2.51,2.51,0,0,0,2.59.59,2.15,2.15,0,0,0,1.59-1.93A4.41,4.41,0,0,0,404.79,413.44Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392,437.66a8.48,8.48,0,0,0-5.48-6.86c-5.21-2.19-8.14-.31-9.59.92-1.73,1.45-4.14,4.39-2.41,6.27s4.71,2.85,9.84,2.53S392,437.66,392,437.66Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.69,421.58a.57.57,0,0,1-.48-.21c-.63-.75-4.5-3.44-8-2.2-.21-.39.06-.83.75-1.32,3.68-.61,7.36,1.92,8.12,2.83a.53.53,0,0,1-.09.77A.62.62,0,0,1,397.69,421.58Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.43,422a1.71,1.71,0,0,1,.91-1.3,10.56,10.56,0,0,1,7.66,2.89.55.55,0,0,1-.09.78.56.56,0,0,1-.34.12.59.59,0,0,1-.48-.2C394.48,423.54,390.8,421,387.43,422Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.32,428.11a3.2,3.2,0,0,1,1.46-1.6c3.63-.52,7.22,2,8,2.86a.53.53,0,0,1-.09.77.58.58,0,0,1-.81-.08C390.18,429.27,385.9,426.31,382.32,428.11Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.44,427.37a.58.58,0,0,1-.47-.2c-.62-.75-4.42-3.38-7.84-2.24a2,2,0,0,1,1.08-1.36,10.57,10.57,0,0,1,7.67,2.9.54.54,0,0,1-.1.78A.7.7,0,0,1,393.44,427.37Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.29,318.64c-5.34,4.17-20.84,16.57-28.35,24-2.17,2.13-4.78,4.29-3.59,11.26,1.36,8,9.65,34.77,9.65,34.77L442.75,330Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.05,380.05c6.79-6,28.24-42.28,28.24-42.28l-1-.18c-5.12-2.41-6.68-8.74-6.68-8.74-.69,2.85,1,6.75,2.64,9-1.73,1.59-10.19,9.22-17,14.94a10,10,0,0,0-3.95,6.37C399.17,366.71,397.84,378.53,398.05,380.05Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.79,320.5h0l40.44,6.08c-1.34,11-3.26,13.83-4.85,16.2-2.37,3.54-5.77,7.31-15.59,12.82-10,5.6-18.82,10.85-21.15,12.07-1.76.92-2.66,4.75-3.28,9.42-.66,4.9-.64,8-5.05,18.41-4.32,10.19-5.81,12.57-5.81,12.57s-7.26,1.05-12.26-3c0,0,5.25-34.54,6.41-40.77.65-3.47.6-5.29,4.73-9.25,3.54-3.39,20-17.44,20-17.44S418,330.11,421.79,320.5Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455,325.5c-.43,6.79-.82,10.72-4.38,14.77-5.06-1.62-5.05-5.54-4.51-10.13.18-1.53.41-3.69.63-5.88l-1.07-.16c-.22,2.2-.45,4.37-.63,5.92-.42,3.6-1,9,4.78,11.11a38.46,38.46,0,0,1-5.93,4.73c-4.63,3.14-10,6.25-14.69,9-7.15,4.15-12.8,7.44-14,9.55-1.06,1.91-1.59,5.34-2.27,9.68-.55,3.58-1.18,7.64-2.26,11.86-1.75,6.82-5.47,17.24-7.3,22.23.41,0,.8,0,1.14,0,1.88-5.13,5.49-15.28,7.2-22a121.65,121.65,0,0,0,2.29-12c.65-4.23,1.17-7.57,2.14-9.32s7.13-5.39,13.58-9.14c4.73-2.75,10.09-5.87,14.75-9,10.4-7,11-11.32,11.58-21.1Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Top--inject-126"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M428.87,270c-10.43,2.35-11,3.27-18.35,10.69L399,292.28s-8.38-15.42-8.7-17.85c-.39-2.91.76-4.76.92-7.91s-.22-5.23.4-6.61-2-1.42-2.89.31-.76,4-1.52,3.68-1.79-5.17-1.55-8.75-1.82-4.3-2.42-3.1a9.8,9.8,0,0,0-.8,2,7.06,7.06,0,0,0-1-.08,1.49,1.49,0,0,0-1.29.47,14.49,14.49,0,0,1-.91,1.13,8,8,0,0,1-1.26.77c-3.06,1.89-2.24,7.38-1.82,10.29.87,6.06,4,8.84,5,11,.38.8,1,3.52,2.52,9.15,1.78,6.43,3.33,13.05,7,19.31,3.07,5.24,7.25,4.53,11.08,2C407.25,304.47,422.4,293,422.4,293,428,284.47,428.87,270,428.87,270Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.68,270.22c-3.55.89-6.6,1.22-10.39,4.46s-17.27,17-17.27,17l-2-3a8.67,8.67,0,0,1-4.27,5.65c-3.82,2.36-6.64,1.08-6.64,1.08a51.85,51.85,0,0,0,2.67,7.92c1.77,4,3.84,6.75,6.79,6.95s4.08-.1,11-4.88S423.11,293,423.11,293Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.7,265.62s-3.52,2.73-1.76,8.33c0,0-2.34-2.77-1.27-5.43A4.29,4.29,0,0,1,385.7,265.62Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399,291.64s2.27,3.14,2.39,9.33a13,13,0,0,0-1.22-10.5Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--Chest--inject-126",
    d: "M419.66,285.12c1.34-12.26,4.58-14.5,8.66-15.36s7.87-1.74,12-1.49c5,.31,14.77,4.12,19.16,6.6,3.75,2.11,4.36,5.65,5,11.8.48,4.39,0,6-.06,19.29A127.42,127.42,0,0,1,461,333.44c-8.52,6-34.87-1.18-44.68-12.48a23,23,0,0,0,2.79-11.34C419.41,298.89,419,291,419.66,285.12Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Head--inject-126"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M445.75,238a5,5,0,0,1,4,3.18c1,2.25.52,6.56-.17,11.74s-1.23,7.43-1.8,8.9a3.89,3.89,0,0,1-2,2l-.51-6-.25-4.19s-3.08-3.36-3.7-6.33c-.8-3.81-.17-5.48-.17-5.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.75,238c-1-3.3-6-6.15-12.75-5.76a13.48,13.48,0,0,0-11.79,7.62c-1.91,4.19,0,7,0,7l20.25-2.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.41,258.54c-2.63,2.28-4.69.62-4.69.62l1.12,12.6c-2,4.56-10.13,8-14.21,6.64s-2.22-3.58-.75-5.53l-.51-3.92a33.31,33.31,0,0,1-3.64.08c-2.79-.12-4.76-2.11-5.91-5-1.84-4.64-2.51-13-1-21.78,3.33-3.16,12.33-3.76,19.25-.38.29,5.5,2.07,7.76,2.28,9.75a5.39,5.39,0,0,0,1.35,1.41c1.11.76,1.68-1.59,2.42-2.56s4-2.45,5.68.3A6.08,6.08,0,0,1,451.41,258.54Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.37,269c3.5-.31,8.16-1.92,9.95-3.82a11.37,11.37,0,0,0,2.34-5s.27,4.63-2.44,7.34-9.59,3.52-9.59,3.52Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419,250.7c.57,1,.24,1.25.87,3.52s4.89,3.53,7,1.26a4.64,4.64,0,0,0,.82-1.31c.54-1.21.41-2.9,1.28-3.09,2.43-.31.32,6.12,6.94,5.76,3.21-.13,3.66-3.26,4-5.72.14-.71.71-.85.78-1.72s-.66-1.15-1.36-1.17a19.3,19.3,0,0,0-6.33.07c-2,.55-2.7,1.19-3.82,1.18s-1.73-.7-3.62-1.31c-1.7-.55-4.48-.07-6.52.16C418.08,248.58,418.52,250.24,419,250.7Zm12.62-.44c1.39-1.59,6.14-1.66,7.14-.6.55.63.17,2.82-.11,3.84,0,.13-.08.25-.13.38a3.14,3.14,0,0,1-3.23,2.05,3.6,3.6,0,0,1-2.73-1.09,4,4,0,0,1-.94-1.83A4.19,4.19,0,0,1,431.66,250.26Zm-8.57-1.41c3.67.1,4.94,1.08,3.85,4.76-.37,1.75-3.05,2.7-4.86,1.78a4.16,4.16,0,0,1-1.88-2.95C419.81,250.57,420,249,423.09,248.85Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.63,258.93l-4.6-1.46,4.19-6.4a.91.91,0,0,1,.89.58Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.81,246.77l3.17.9a1.72,1.72,0,0,0-1.17-2.08A1.61,1.61,0,0,0,434.81,246.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.76,247.37l3.09-.93a1.55,1.55,0,0,0-2-1.06A1.65,1.65,0,0,0,422.76,247.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.17,251.24a1.3,1.3,0,1,1-.94-.93A1.27,1.27,0,0,1,426.17,251.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.56,251.61a1.3,1.3,0,1,1-1.3-1.3A1.3,1.3,0,0,1,436.56,251.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.16,260l-5.63,1.12a2.82,2.82,0,0,0,3.31,2.34A3,3,0,0,0,435.16,260Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.47,260.85a3.19,3.19,0,0,1,.69,0,3,3,0,0,1-2.32,2.54,2.85,2.85,0,0,1-.92,0A2.63,2.63,0,0,1,434.47,260.85Z",
    style: {
      fill: "#f28f8f"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-126"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M405.61,363.37,414.1,437h0a1,1,0,0,0,.56.76,3,3,0,0,0,2.69,0,1,1,0,0,0,.56-.76h0L411,363.37a1.35,1.35,0,0,0-.79-1.11,4.28,4.28,0,0,0-3.82,0A1.37,1.37,0,0,0,405.61,363.37ZM311.41,437h0a1,1,0,0,0,.56.76,3,3,0,0,0,2.69,0,1,1,0,0,0,.56-.76h0l8.49-73.61a1.37,1.37,0,0,0-.79-1.11,4.28,4.28,0,0,0-3.82,0,1.35,1.35,0,0,0-.79,1.11Zm50.32-62.27.87,79.71h0a1,1,0,0,0,.61.83,3.22,3.22,0,0,0,3,0,1,1,0,0,0,.61-.83h0l.87-79.71a1.47,1.47,0,0,0-.87-1.21,4.62,4.62,0,0,0-4.19,0A1.47,1.47,0,0,0,361.73,374.71Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M405.61,363.37,414.1,437h0a1,1,0,0,0,.56.76,3,3,0,0,0,2.69,0,1,1,0,0,0,.56-.76h0L411,363.37a1.35,1.35,0,0,0-.79-1.11,4.28,4.28,0,0,0-3.82,0A1.37,1.37,0,0,0,405.61,363.37ZM311.41,437h0a1,1,0,0,0,.56.76,3,3,0,0,0,2.69,0,1,1,0,0,0,.56-.76h0l8.49-73.61a1.37,1.37,0,0,0-.79-1.11,4.28,4.28,0,0,0-3.82,0,1.35,1.35,0,0,0-.79,1.11Zm50.32-62.27.87,79.71h0a1,1,0,0,0,.61.83,3.22,3.22,0,0,0,3,0,1,1,0,0,0,.61-.83h0l.87-79.71a1.47,1.47,0,0,0-.87-1.21,4.62,4.62,0,0,0-4.19,0A1.47,1.47,0,0,0,361.73,374.71Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--table--inject-126"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--table--inject-126"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M362,396.1l-.24-21.39a1.47,1.47,0,0,1,.87-1.21,4.62,4.62,0,0,1,4.19,0,1.47,1.47,0,0,1,.87,1.21l-.24,21.39C365.61,396.14,363.78,396.14,362,396.1Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M318.31,363.37a1.35,1.35,0,0,1,.79-1.11,4.28,4.28,0,0,1,3.82,0,1.37,1.37,0,0,1,.79,1.11l-2.62,22.68-1.2-.65c-1.19-.7-2.36-1.46-3.44-2.19Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M406.4,362.26a4.28,4.28,0,0,1,3.82,0,1.35,1.35,0,0,1,.79,1.11l1.86,19.86c-1.09.74-2.27,1.51-3.48,2.21-.38.22-.77.42-1.16.63l-2.62-22.7A1.37,1.37,0,0,1,406.4,362.26Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M409.55,323.58c-24.81-14.32-65-14.32-89.82,0-12.4,7.16-18.59,16.54-18.59,25.93,0,1.92,0-.11,0,1.82,0,9.38,6.19,18.77,18.59,25.93,24.8,14.31,65,14.31,89.82,0,12.4-7.16,18.59-16.55,18.58-25.93V349.5C428.14,340.12,422,330.74,409.55,323.58Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M409.55,323.58c-24.81-14.32-65-14.32-89.82,0-12.4,7.16-18.59,16.54-18.59,25.93,0,1.92,0-.11,0,1.82,0,9.38,6.19,18.77,18.59,25.93,24.8,14.31,65,14.31,89.82,0,12.4-7.16,18.59-16.55,18.58-25.93V349.5C428.14,340.12,422,330.74,409.55,323.58Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M409.6,318.82c-24.8-14.32-65-14.32-89.81,0-12.4,7.16-18.59,16.54-18.59,25.93v3.12c0,9.39,6.19,18.77,18.59,25.93,24.8,14.32,65,14.32,89.81,0,12.4-7.16,18.59-17.85,18.59-27.23v-1.82C428.19,335.36,422,326,409.6,318.82Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M409.6,318.82c-24.8-14.32-65-14.32-89.81,0-12.4,7.16-18.59,16.54-18.59,25.93v3.12c0,9.39,6.19,18.77,18.59,25.93,24.8,14.32,65,14.32,89.81,0,12.4-7.16,18.59-17.85,18.59-27.23v-1.82C428.19,335.36,422,326,409.6,318.82Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M409.6,318.82c-24.8-14.32-65-14.32-89.81,0-12.4,7.16-18.59,16.54-18.59,25.93v3.12c0,9.39,6.19,18.77,18.59,25.93,24.8,14.32,65,14.32,89.81,0,12.4-7.16,18.59-17.85,18.59-27.23v-1.82C428.19,335.36,422,326,409.6,318.82Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M319.79,370.67c-24.8-14.32-24.8-37.53,0-51.85s65-14.32,89.81,0,24.8,37.53,0,51.85S344.59,385,319.79,370.67Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.85
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M319.73,370.67c-24.8-14.32-24.8-37.53,0-51.85s65-14.32,89.82,0,24.8,37.53,0,51.85S344.53,385,319.73,370.67Z",
    style: {
      fill: "#fff"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Laptop--inject-126"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--laptop--inject-126"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M347.17,332,374,316.47a1.52,1.52,0,0,1,1.54,0l46.62,26.91a.35.35,0,0,1,0,.6l-27.12,15.66Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.18,328.71v.6a2.47,2.47,0,0,0,1.24,2.15l43.42,25.07a2.49,2.49,0,0,0,2.48,0L420,342.91a2.49,2.49,0,0,0,1.24-2.15v-.83h0a.32.32,0,0,1-.16.28l-26,15Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.17,328.71l25.75-14.86a1.45,1.45,0,0,1,1.48,0l44.67,25.79a.33.33,0,0,1,0,.57l-26,15Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "395.31 353.03 409.2 345.02 368.6 321.57 354.64 329.54 395.31 353.03",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "354.64 329.54 355.17 329.85 368.6 322.18 408.67 345.32 409.2 345.02 368.6 321.57 354.64 329.54",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "402.14 330.75 401.88 330.89 395.08 334.82 382.97 327.83 382.72 327.69 389.78 323.62 402.14 330.75",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "401.88 330.89 395.08 334.82 382.97 327.83 389.78 323.91 401.88 330.89",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.08,355.21v1.65a2.38,2.38,0,0,1-1.24-.33l-43.42-25.07a2.48,2.48,0,0,1-1.25-2.15v-.6Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-126"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Arm--inject-126"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M427.35,328.59a28,28,0,0,0-2.82.61,29.88,29.88,0,0,1-3.14,1.36c-2.71.88-6,.29-8.37.2a24.7,24.7,0,0,0-8.59,1.31c-2.18.92-4.86-2.42-6-2s-3-.44-1-2.47,4.87-4.84,7.31-5.69a13.14,13.14,0,0,1,1.72-.57,19.74,19.74,0,0,1-2.53-.46,4.55,4.55,0,0,1-2.15-1.38c-.22-.28-.38-.71-.11-.94a.6.6,0,0,1,.35-.13c1.84-.08,3.28-.39,5-.54a8.82,8.82,0,0,1,2.49-.22c.69.18,1.3.27,2.37.5a31.84,31.84,0,0,0,8.87.63c.94-.09,3.17-.38,3.17-.38.56-.06,1.21,1.39,2.25,3.62A12.65,12.65,0,0,1,427.35,328.59Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.47,320a8.23,8.23,0,0,1,3.36.49,18.37,18.37,0,0,0-4.36.82,19.74,19.74,0,0,1-2.53-.46,4.56,4.56,0,0,1-1.95-1.16C403.32,320.61,405.88,320.22,407.47,320Z",
    style: {
      fill: "#9a4a4d"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M424.53,329.2c3-1.09,9.77-.78,18.92-1.7a89.87,89.87,0,0,0,10.13-1.37c3.43-.8,5.32-.77,7-5.55,2-5.66,5.51-22.53,6.33-28.29.93-6.55.11-10.29-1.86-13.22-2.08-3.09-7.57-4.93-7.57-4.93s-4.51,3.14-6.31,10.36a54,54,0,0,0-1.87,10.7l-3.06,17.1s-8.45,2.57-13.34,3.83c-6.23,1.61-9,2.21-11.21,2.57S424.53,329.2,424.53,329.2Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.07,273.65c2.72.94,8.78,3.52,10,9.17s-.73,15.19-1.7,19.64-3.79,16.51-4.56,18.87-2.1,4.14-5.68,4.8-7.17.89-7.17.89a8.36,8.36,0,0,0-.63-7.61,13,13,0,0,0-6.18-5.59l4.87-1.66s2.48-14.12,3.31-19.41S451.73,277.7,457.07,273.65Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446,312.16c2.43-.62,9,1.14,9.78,4.82-.15-2.93-3.8-7.05-9.45-6.69Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M394.38,355.58a2.92,2.92,0,0,1-2.54-.2l-43.23-25a3,3,0,0,1-1.43-2.05l-4.73-28.23a2.59,2.59,0,0,1,0-.48,2.92,2.92,0,0,1,.87-2.09l44.93,25.94a2.18,2.18,0,0,1,1.05,1.52Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.08,355.21l-.3.17a3,3,0,0,1-.4.2L389.26,325a2.18,2.18,0,0,0-1.05-1.52l-44.93-25.94a3.08,3.08,0,0,1,.6-.46l45,26a2.18,2.18,0,0,1,1.05,1.52Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.85,324.09l.69-.4a2.11,2.11,0,0,1,.41.93l5.13,30.59-.3.17a3,3,0,0,1-.4.2L389.26,325A2.22,2.22,0,0,0,388.85,324.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370,329.52c-.32-1.89-2.27-4.4-4.36-5.6s-3.52-.65-3.21,1.23,2.27,4.4,4.36,5.61S370.35,331.41,370,329.52Z",
    style: {
      fill: "#46C5FB"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Coffee--inject-126"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-126",
    d: "M336.56,355.33c4,2.06,4,5.41,0,7.47a17.55,17.55,0,0,1-14.4,0c-4-2.06-4-5.41,0-7.47A17.55,17.55,0,0,1,336.56,355.33Z",
    style: {
      fill: "#46C5FB",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--coffee--inject-126"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M323.05,340.51a22.33,22.33,0,0,1,12.68.06c3.44,1.25,3.43,3.24,0,4.45A22.34,22.34,0,0,1,323,345C319.47,343.71,319.48,341.72,323.05,340.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.2,336.28l18.27.46-1.56,22.84h0c-.1.73-.86,1.44-2.27,2a17.19,17.19,0,0,1-10.95-.27c-1.43-.59-2.17-1.34-2.24-2.07h0Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.47,336.74l-.4,4.09a8.22,8.22,0,0,1-1.54.73A23.66,23.66,0,0,1,322,341.2c-.18-.07-.32-.14-.48-.22a9.38,9.38,0,0,1-1.13-.63l-.17-4.07Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319,336.85l.09-3.08,2.13.05c.28-.13.6-.26.94-.38a23.69,23.69,0,0,1,14.55.35,9,9,0,0,1,.88.43l2.07,0-.08,3.08h0c0,1-1.05,2-3,2.7A23.66,23.66,0,0,1,322,339.7C320,338.88,319,337.85,319,336.85Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.26,331.07a23.69,23.69,0,0,1,14.55.35c3.9,1.63,3.83,4.11-.16,5.55a23.63,23.63,0,0,1-14.54-.35C318.06,335,318.13,332.5,322.26,331.07Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321,333.07h0l.73-2.52,5.22.13a22.57,22.57,0,0,1,5.2.12l5.07.13.59,2.55h0c.31.93-.5,1.88-2.43,2.54a20.28,20.28,0,0,1-12-.29C321.45,335,320.66,334,321,333.07Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.07,329a19.56,19.56,0,0,1,11,.27c3,1.12,2.91,2.83-.11,3.81a19.66,19.66,0,0,1-11-.26C320.9,331.67,321,330,324.07,329Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.77,330.86a.88.88,0,0,0,.33.37,5.11,5.11,0,0,0,1.26.63,16.93,16.93,0,0,0,5.16.86,16.14,16.14,0,0,0,5.11-.6,4.67,4.67,0,0,0,1.24-.58c.26-.18.33-.32.34-.36s-.26-.52-1.52-1a15.86,15.86,0,0,0-5.08-.85,16.94,16.94,0,0,0-5.2.6C323.11,330.34,322.78,330.77,322.77,330.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.1,331.23a5.11,5.11,0,0,0,1.26.63,16.93,16.93,0,0,0,5.16.86,16.14,16.14,0,0,0,5.11-.6,4.67,4.67,0,0,0,1.24-.58,4.27,4.27,0,0,0-1.2-.64,16.44,16.44,0,0,0-5.08-.85,17.23,17.23,0,0,0-5.2.61A5.09,5.09,0,0,0,323.1,331.23Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M326.2,331.37a1.68,1.68,0,0,0-1.22-.25c-.22.12-.05.41.39.67a1.62,1.62,0,0,0,1.22.24C326.82,331.92,326.65,331.62,326.2,331.37Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M337.75,350.2c0,.76-.82,1.51-2.45,2.08a21,21,0,0,1-11.95,0c-1.67-.59-2.5-1.35-2.5-2.11l-.48-7.4c0,.81.88,1.62,2.66,2.24a22.34,22.34,0,0,0,12.68.06c1.72-.61,2.59-1.41,2.59-2.21Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.17,350.61a10.3,10.3,0,0,0,.71-1.25,3.92,3.92,0,0,1,2.08-1.7.27.27,0,0,1,.32.11,2.53,2.53,0,0,1-.77,2.93,3,3,0,0,1-3.11.71s-.06-.12,0-.14A2.47,2.47,0,0,0,332.17,350.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.47,347.43a4.44,4.44,0,0,0-1.31.74,3.6,3.6,0,0,0-1,1.21,3.61,3.61,0,0,1-1.19,1.46.26.26,0,0,1-.36,0,2.45,2.45,0,0,1,.65-3.12,3,3,0,0,1,3.19-.67A.23.23,0,0,1,334.47,347.43Z",
    style: {
      fill: "#263238"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-126"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-126"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-126"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M434.49,218l3-5.63-2.41-7v-4.26l7.38,4.26v4.26l-3.17,5.49a.47.47,0,0,1-.22.2h0Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.49,218l3-5.63-2.41-7v-4.26l7.38,4.26v4.26l-3.17,5.49a.47.47,0,0,1-.22.2h0Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.77,166.3a4.9,4.9,0,0,1,2.21-3.83l1.8-1a4.85,4.85,0,0,1,4.42,0l26.5,15.27a4.91,4.91,0,0,1,2.22,3.84V213a4.89,4.89,0,0,1-2.22,3.83l-1.8,1a4.85,4.85,0,0,1-4.42,0l-9.66-5.56-3.17,5.49a.47.47,0,0,1-.85-.09l-3.35-9.65L421,202.61a4.9,4.9,0,0,1-2.21-3.83Z",
    style: {
      fill: "#46C5FB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.92,213a4.89,4.89,0,0,1-2.22,3.83l-1.8,1a4.94,4.94,0,0,1-4,.18c1,.39,1.83-.19,1.83-1.46V184.74a6.26,6.26,0,0,0-.35-3l5.93-3.43a4.5,4.5,0,0,1,.65,2.18Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.84,165.67c.26-.94,1.11-1.24,2.13-.65l26.51,15.28a4.6,4.6,0,0,1,1.85,1.5l5.93-3.44a4.44,4.44,0,0,0-1.56-1.65l-26.49-15.28a4.94,4.94,0,0,0-4.43,0l-1.81,1A4.86,4.86,0,0,0,418.84,165.67Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "freepik--World--inject-126",
    d: "M442.8,185.42l-.15-.29,0,0a22.67,22.67,0,0,0-8.13-9.17c-2.95-1.7-5.75-1.84-7.89-.4l-.18.13-.09.06c-2.18,1.65-3.38,4.82-3.38,8.93a28.37,28.37,0,0,0,3.38,12.83,22.75,22.75,0,0,0,8.16,9.22c3.08,1.78,6,1.85,8.16.2S446,202.06,446,198A28.33,28.33,0,0,0,442.8,185.42Zm-4.66-2c.26.84.49,1.72.69,2.63a7.28,7.28,0,0,1-2.32-.43l-.22-.08a9.45,9.45,0,0,1-1.41-.67v-7.05l.09.06c.26.16.52.34.77.53A15.48,15.48,0,0,1,438.14,183.39Zm-.83-3.67a23,23,0,0,1,4.22,5.63,5.15,5.15,0,0,1-1.62.58l-.2,0-.3,0c-.21-1-.46-1.93-.74-2.84A22.48,22.48,0,0,0,437.31,179.72Zm-3.23,10.83-4.8-2.77a27.48,27.48,0,0,1,.7-6.15,20.94,20.94,0,0,0,2.37,2.42l.23.2a14.57,14.57,0,0,0,1.5,1.09Zm0,1.07v5.15a10,10,0,0,0-1.5-.63l-.23-.08a7.37,7.37,0,0,0-2.37-.31,39.17,39.17,0,0,1-.7-6.9Zm.8.46,4.82,2.78a28.07,28.07,0,0,1-.66,5.89,19,19,0,0,0-2.42-2.34l-.23-.18a13.93,13.93,0,0,0-1.51-1Zm0-1.07v-5.17a10.77,10.77,0,0,0,1.51.71l.23.09a8.06,8.06,0,0,0,2.42.46,39.83,39.83,0,0,1,.66,6.7ZM434,177.29a.2.2,0,0,1,.08,0v7a15.11,15.11,0,0,1-1.38-1l-.22-.19a19.56,19.56,0,0,1-2.27-2.35,11.81,11.81,0,0,1,.62-1.63c.68-1.4,1.51-2.15,2.4-2.24A7.67,7.67,0,0,1,434,177.29Zm-3.7,1a13.06,13.06,0,0,0-.67,1.75c-.09-.12-.18-.23-.26-.35l-.2-.27a25.91,25.91,0,0,1-1.5-2.38,5.49,5.49,0,0,1,4-.62A5.84,5.84,0,0,0,430.3,178.32Zm-1.49,1.8.2.28c.13.18.26.34.39.51a28.64,28.64,0,0,0-.75,6.51l-4.45-2.57c.09-3.38,1.12-6,2.92-7.4A29.57,29.57,0,0,0,428.81,180.12Zm-.16,8.36a41.12,41.12,0,0,0,.75,7.33l-.39.05-.2,0a5.68,5.68,0,0,0-1.7.73,25.64,25.64,0,0,1-2.91-10.73Zm.52,8.52.19-.05.27,0c.2.87.42,1.72.67,2.52a24.18,24.18,0,0,0,1.36,3.44,23,23,0,0,1-4-5.23A5.17,5.17,0,0,1,429.17,197Zm1.66,2.19c-.23-.75-.44-1.54-.62-2.34a6.69,6.69,0,0,1,2.27.27l.22.07a9,9,0,0,1,1.38.58v7l-.08,0c-.26-.16-.51-.34-.77-.53A15.76,15.76,0,0,1,430.83,199.19ZM435,205.3l-.09-.05v-7.06a15.42,15.42,0,0,1,1.41,1l.22.17a19.54,19.54,0,0,1,2.32,2.25,11.69,11.69,0,0,1-.69,1.83c-.68,1.41-1.5,2.16-2.4,2.24C435.49,205.55,435.23,205.43,435,205.3Zm3.7-1a12.25,12.25,0,0,0,.74-2l.3.37.2.26a24.13,24.13,0,0,1,1.63,2.48,5.42,5.42,0,0,1-4.23.74A5.59,5.59,0,0,0,438.67,204.26Zm1.58-2-.21-.27-.41-.5a28.4,28.4,0,0,0,.69-6.22l4.46,2.57c-.1,3.3-1.1,5.79-2.71,7.19A29.45,29.45,0,0,0,440.25,202.21Zm.08-8.05a41.12,41.12,0,0,0-.7-7.07l.41,0,.21,0a5.53,5.53,0,0,0,1.81-.65,25.53,25.53,0,0,1,2.72,10.36Z",
    style: {
      fill: "#fff"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsite);
export default __webpack_public_path__ + "static/media/website.ce4054b1a47226f2b7baad9621417fce.svg";
export { ForwardRef as ReactComponent };